var Webpack = Webpack || {}; Webpack["main"] =
webpackJsonpWebpack__name_([3],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formPutFetch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return unlinkWorkstation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return unlinkAllWorkstations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return loadWorkstations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return loadReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return signIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return userSubscriptionSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cancelSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setReport; });
/* unused harmony export deleteFetch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icepath__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_report_components_lib_reducers__ = __webpack_require__(8);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var formPutFetch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])('FORM_FETCH', function (s) {
  return s;
}, function (obj, _ref) {
  var url = _ref.url;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["postFetcher"])(url, obj, { method: "PUT" });
});

var unlinkWorkstation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])("UNLINK_WORKSTATION", function (chain, _, _ref2) {
  var id = _ref2._payload;
  return chain.unset(id).filterIn(['order'], function (_) {
    return _ !== id;
  });
}, function (id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["getFetcher"])('/api/station-tokens/' + id, {}, { method: 'DELETE' });
});
var unlinkAllWorkstations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])("UNLINK_ALL_WORKSTATIONS", function () {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"])({ order: [] });
}, function () {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["getFetcher"])('/api/clear-station-tokens/', {}, { method: 'DELETE' });
});
var loadWorkstations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])("LOAD_WORKSTATIONS", function (chain, resp) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["arrToMap"])(resp, "id"));
}, function () {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["getFetcher"])('/api/station-tokens');
});
var workstationsReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["reducerCreator"])({}, [unlinkWorkstation, unlinkAllWorkstations, loadWorkstations]);

var addNewReports = function addNewReports(chain, response, _ref3) {
  var _ref3$_payload = _ref3._payload,
      page = _ref3$_payload.page,
      query = _ref3$_payload.query,
      sort = _ref3$_payload.sort;

  if (response.first) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["arrToMap"])(response.content, "uid")).assign({ 'finished': response.last, 'totalPages': response.totalPages, total: response.totalElements, page: 0, query: query, sort: sort });
  } else {
    var _arrToMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["arrToMap"])(response.content, "uid"),
        order = _arrToMap.order,
        values = _objectWithoutProperties(_arrToMap, ['order']);

    return chain.push.apply(chain, ['order'].concat(_toConsumableArray(order))).assign(values).set('finished', response.last).set('page', page);
  }
};

var loadReports = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])("LOAD_REPORTS", addNewReports, function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { size: 40, page: 0, sort: 'last_Saved,desc' };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["getFetcher"])('/api/reports', params);
});
var deleteReport = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])("DELETE_REPORT", function (chain, _, _ref4) {
  var id = _ref4._payload;
  return chain.unset(id).filterIn(['order'], function (_) {
    return _ !== id;
  }).updateIn('total', function (i) {
    return i - 1;
  });
}, function (id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["getFetcher"])('/api/report/' + id, {}, { method: 'DELETE' });
});
var reportsReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["reducerCreator"])({}, [loadReports, deleteReport]);

var signIn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])("SIGN_IN", function (chain, result) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"])(result);
});
var getAccount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])("GET_ACCOUNT", function (chain, result) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"])(result);
}, function () {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["getFetcher"])('/api/account');
});
var setProfile = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])("SET_PROFILE", function (chain, _, _ref5) {
  var _ref5$_payload = _ref5._payload,
      firstName = _ref5$_payload.firstName,
      lastName = _ref5$_payload.lastName,
      picture = _ref5$_payload.picture;
  return chain.assign({ hasProfile: true, firstName: firstName, lastName: lastName, picture: picture });
}, function (form) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["postFetcher"])('/api/profiles', form);
});
var logout = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])("LOGOUT", function () {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"])({});
}, function () {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["getFetcher"])("/api/logout");
});
var userSubscriptionSuccess = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])("SUBSCRIPTION_SUCCESS", function (chain, _, _ref6) {
  var _payload = _ref6._payload;
  return chain.set('accountStatus', 'active').set('stripeCardAdded', true).set('authorities', _payload);
});
var cancelSubscription = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])("CANCEL_SUBSCRIPTION", function (chain) {
  return chain;
}, function (subscriptionType) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["postFetcher"])('/api/cancel-subscription', { subscriptionType: subscriptionType });
});
var userReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["reducerCreator"])({}, [signIn, getAccount, setProfile, logout, cancelSubscription, userSubscriptionSuccess]);

var clearNotifications = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])('CLEAR_NOTIFICATIONS', function (chain) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"])([]);
});
var setNotifications = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])('SET_NOTIFICATIONS', function (chain, notification) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"])(notification);
});
var notificationReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["reducerCreator"])([], [clearNotifications, setNotifications]);

var setReport = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])('SET_REPORT', undefined, function (id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["getFetcher"])('/api/report-json/' + id);
});

var deleteFetch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["makeActionCreator"])('DELETE_FETCH', function (s) {
  return s;
}, function (obj, _ref7) {
  var url = _ref7.url;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["postFetcher"])(url, obj, { method: "DELETE" });
});

var reducers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  report: function report(state, action) {
    if (action.type === setReport.toString()) {
      state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_report_components_lib_reducers__["c" /* propsToStoreState */])(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].set(action.payload, 'userEmail', __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].get(action, ['meta', 'ownProps', 'userEmail'])));
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_report_components_lib_reducers__["d" /* reportReducers */])(state, action);
  },
  reports: reportsReducer(_defineProperty({}, logout, function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"])({});
  })),
  workstations: workstationsReducer(_defineProperty({}, logout, function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"])({});
  })),
  user: userReducer(),
  appUI: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["uiReducer"])({
    notifications: notificationReducer(_defineProperty({}, setProfile, function (chain, _, meta) {
      return meta._dontFetch ? chain : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"])(["Changes saved successfully"]);
    }))
  })
});

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(267).enable();
  window.Promise = __webpack_require__(266);
}

// fetch() polyfill for making API calls.
__webpack_require__(310);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(55);

// find, findIndex
(function (ArrayProto) {
  var find = function(type) {
    return function (predicate) {
      if (this === null) {
        throw new TypeError('"this" is null or not defined');
      }
      var o = Object(this);
      var len = o.length >>> 0;
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var thisArg = arguments[1];
      for (var k = 0; k < len; k++) {
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return (type===0? kValue : k);
        }
      }
      return (type===0?undefined:-1);
    };
  };
  if (!ArrayProto.find) {
    ArrayProto.find = find(0);
  }

  if (!ArrayProto.findIndex) {
    ArrayProto.findIndex = find(1)
  }
})(Array.prototype);

// remove
(function (arr) {
  arr.forEach(function (item) {
    if (!item.remove) {
      item.remove = function remove() {
        this.parentNode.removeChild(this);
      }
    }
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// matches closest
(function (ElementProto) {
  if (typeof ElementProto.matches !== 'function') {
    ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
        var element = this;
        var elements = (element.parentNode || element.document || element.ownerDocument).querySelectorAll(selector);
        var index = 0;

        while (elements[index] && elements[index] !== element) {
          ++index;
        }

        return Boolean(elements[index]);
      };
  }

  if (typeof ElementProto.closest !== 'function') {
    ElementProto.closest = function closest(selector) {
      var element = this;

      while (element && element.nodeType === 1) {
        if (element.matches(selector)) {
          return element;
        }

        element = element.parentNode;
      }

      return null;
    };
  }
})(window.Element.prototype);

Object.values = Object.values || function values(O) {
  return Object.keys(O).map(function(k){return [O[k]]})
};

Object.entries = Object.entries || function entries(O) {
  return Object.keys(O).map(function(k){return [k,O[k]]})
};


(function() {
  var lastTime = 0;
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function(callback, element) {
      var currTime = Date.now();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function() { callback(currTime + timeToCall); }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
    window.cancelAnimationFrame = window.clearTimeout
  }
}());

(function () {
  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

/***/ }),

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_report_components_stylesheets_index_less__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_report_components_stylesheets_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_report_components_stylesheets_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stylesheets_index_less__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stylesheets_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__stylesheets_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_hot_loader__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_thunk__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_slot_fill__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_report_components_lib_reducers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_startlibs__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
















__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_startlibs__["setAjaxDefaultError"])('The communication with the server has failed, please check your connection and try again');
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || __WEBPACK_IMPORTED_MODULE_5_redux__["compose"];

var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux__["createStore"])(function (s) {
  return s;
});

var reportActionsToUrl = function reportActionsToUrl(reportUid, json) {
  return {
    "saveCompleteReport": ["PUT", "report-json/"],
    "saveSettings": ["POST", "report-settings/"],
    "saveSignature": ["POST", "report-signatures/"],
    "finishReport": ["POST", "finish-report/" + reportUid],
    "unfinishReport": ["POST", "unfinish-report/" + reportUid],
    "saveTemplate": ["PUT", "report-templates/"],
    "changeTemplate": ["PUT", "change-report-template/" + reportUid],
    "renameTemplate": ["PUT", "report-templates/rename/"],
    "deleteTemplate": ["DELETE", "report-templates/" + json.templateId, function (_ref) {
      var templateId = _ref.templateId;
      return { id: templateId };
    }],
    "deleteSignature": ["DELETE", "report-signatures/" + json.signatureId, function () {
      return "";
    }]
  };
};

function init() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


  store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_11__reducers__["a" /* reducers */], props, composeEnhancers(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_8_redux_thunk___default.a)));
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_report_components_lib_reducers__["a" /* setStore */])({ getState: function getState() {
      return store.getState().report;
    }, dispatch: store.dispatch });

  var getCommandUrl = function getCommandUrl(action, commandType, json) {
    if (!reportActionsToUrl("", json)[action]) {
      console.log(action);return ['GET', '/'];
    }

    var _reportActionsToUrl$a = _slicedToArray(reportActionsToUrl(store.getState().report.reportUID, json)[action], 3),
        method = _reportActionsToUrl$a[0],
        url = _reportActionsToUrl$a[1],
        fn = _reportActionsToUrl$a[2];

    return [method, '/api/' + url, fn ? fn(json) : json];
  };

  // if (process.env.NODE_ENV === 'development') {
  //   import(`./reducers/dev-polyfill/fakePostFetcher`).then(module =>
  //     setFetcher((action, json, commandType) => module.fakePostFetcher(action, getCommandUrl(action, commandType), json))
  //   )
  // } else {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_report_components_lib_reducers__["b" /* setFetcher */])(function (action, json, commandType, opts) {
    var _getCommandUrl = getCommandUrl(action, commandType, json),
        _getCommandUrl2 = _slicedToArray(_getCommandUrl, 3),
        method = _getCommandUrl2[0],
        url = _getCommandUrl2[1],
        formattedJson = _getCommandUrl2[2];

    return fetch(url, _extends({
      method: method,
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json; charset=UTF-8' },
      body: JSON.stringify(formattedJson)
    }, opts)).then(function (e) {
      return e.status >= 400 ? Promise.reject(e.json()) : e.text();
    }).catch(function (e) {
      return e.then ? e.then(function (e) {
        return Promise.reject(e.errors ? e : { errorResponse: e });
      }) : Promise.reject(e);
    }).then(function (e) {
      return e && typeof e === 'string' ? JSON.parse(e) : e;
    });
  });
  // }


  var render = function render(Component) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_hot_loader__["AppContainer"],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_redux__["Provider"],
        { store: store },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_router_dom__["BrowserRouter"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_slot_fill__["Provider"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null)
          )
        )
      )
    ), document.getElementById('root'));
  };

  render(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* App */]);

  if (false) {
    module.hot.accept('./App', function () {
      render(App);
    });
  }
}

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Navbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slot_fill__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_little_loader__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_little_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_little_loader__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class;

var _templateObject = _taggedTemplateLiteral(['\n  a.styled-button.video-link {\n    margin-top: .75rem;\n  }\n'], ['\n  a.styled-button.video-link {\n    margin-top: .75rem;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem 0.5rem 0.75rem;\n  .user-info {\n    display: inline-block;\n    margin-left: 0.5rem;\n  }\n  .user-name {\n    font-weight: 600;\n    max-width: 13rem;\n    display: flex;\n    align-items: center;\n    span {\n      overflow: hidden;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n  .user-email {\n    color: rgba(0,0,0,0.5);\n    font-size: 11px;\n  }\n  .user-avatar {\n    width: 2.75rem;\n    height: 2.75rem;\n    border-radius: 50%;\n    background-color: ', ';\n    display: inline-block;\n    overflow: hidden;\n    img {\n      width: 100%;\n    }\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem 0.5rem 0.75rem;\n  .user-info {\n    display: inline-block;\n    margin-left: 0.5rem;\n  }\n  .user-name {\n    font-weight: 600;\n    max-width: 13rem;\n    display: flex;\n    align-items: center;\n    span {\n      overflow: hidden;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n  .user-email {\n    color: rgba(0,0,0,0.5);\n    font-size: 11px;\n  }\n  .user-avatar {\n    width: 2.75rem;\n    height: 2.75rem;\n    border-radius: 50%;\n    background-color: ', ';\n    display: inline-block;\n    overflow: hidden;\n    img {\n      width: 100%;\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background-color: rgba(0,0,0,0.05);\n  border-top: 1px solid rgba(0,0,0,0.05);\n  margin-top: 0.5rem;\n  margin-bottom: -0.5rem;\n  padding: 6px 1rem 9px;\n  font-size: 11px;\n  color: rgba(0,0,0,0.5);\n  a {\n    line-height: 14px;\n    display: inline-block;\n    text-decoration: none;\n    color: inherit;\n    &:hover {\n      color: ', ';\n      text-decoration: underline;\n    }\n  }\n'], ['\n  background-color: rgba(0,0,0,0.05);\n  border-top: 1px solid rgba(0,0,0,0.05);\n  margin-top: 0.5rem;\n  margin-bottom: -0.5rem;\n  padding: 6px 1rem 9px;\n  font-size: 11px;\n  color: rgba(0,0,0,0.5);\n  a {\n    line-height: 14px;\n    display: inline-block;\n    text-decoration: none;\n    color: inherit;\n    &:hover {\n      color: ', ';\n      text-decoration: underline;\n    }\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  padding: 2px 0.5rem;\n  border-radius: 3px;\n  color: white;\n  font-size: 11px;\n  margin-top: -1px;\n  text-decoration: none;\n  margin-left: 0.25rem;\n'], ['\n  background-color: ', ';\n  padding: 2px 0.5rem;\n  border-radius: 3px;\n  color: white;\n  font-size: 11px;\n  margin-top: -1px;\n  text-decoration: none;\n  margin-left: 0.25rem;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  background-color: ', ';\n'], ['\n  background-color: ', ';\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }















var WistiaSpan = __WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].span(_templateObject);

var ContextMenuHeader = __WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].li(_templateObject2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('gray240'));
var ContextMenuFooter = __WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].li(_templateObject3, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('main'));

var TrialLabel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Link"])(_templateObject4, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('main'));

var CanceledLabel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"])(TrialLabel)(_templateObject5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('alert'));

var Navbar = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (_ref, _ref2) {
  var report = _ref.report,
      user = _ref.user;
  var location = _ref2.location;
  return {
    isReportPreviewOpen: location.pathname.indexOf('/report/') >= 0 && report ? report.isPreviewOpen || report.finished || report.readOnly : false,
    user: user
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_startlibs_lib_hocs__["withPopupToggles"])('helpPopup', 'preferencesMenu'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["withRouter"])(_class = _dec(_class = _dec2(_class = function (_React$PureComponent) {
  _inherits(Navbar, _React$PureComponent);

  function Navbar() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, Navbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref3, [this].concat(args))), _this), _this.signOut = function () {
      localStorage.removeItem('hasLogged');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_startlibs__["getFetcher"])('/api/logout').then(function () {
        return window.location = '/';
      });
    }, _this.getAvatarBackground = function () {
      return { backgroundImage: 'url("' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["h" /* getResource */])(_this.props.user.picture || '/public/user-avatar.png') + '")' };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Navbar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_11_little_loader___default()("https://fast.wistia.com/embed/medias/zb975x40on.jsonp");

      __WEBPACK_IMPORTED_MODULE_11_little_loader___default()("https://fast.wistia.com/assets/external/E-v1.js");
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          helpPopup = _props.helpPopup,
          location = _props.location,
          preferencesMenu = _props.preferencesMenu,
          isReportPreviewOpen = _props.isReportPreviewOpen,
          user = _props.user;

      var isEmbedded = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["i" /* queryHasValue */])(location.search, 'embedded', 'true');
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: 'navbar ' + (isEmbedded ? 'embedded-layout ' : 'browser-layout ') + __WEBPACK_IMPORTED_MODULE_4_classnames___default()(isReportPreviewOpen ? 'preview' : 'editor') },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: 'navbar-content' },
          !isEmbedded && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            { className: 'left-container logo-container' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment,
              null,
              user.id ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Link"],
                { to: '/', className: 'logo' },
                'Horos Cloud'
              ) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Link"],
                { skipTo: '/', className: 'logo' },
                'Horos Cloud'
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react_router_dom__["Switch"],
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["Route"], { path: '/report/:uid', render: function render() {
                    return null;
                  } }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["Route"], { path: '/checkout', render: function render() {
                    return null;
                  } }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["Route"], { path: '/first-steps', render: function render() {
                    return null;
                  } }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["Route"], { path: '/storage/checkout', render: function render() {
                    return null;
                  } }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["Route"], { render: function render() {
                    return user.hasProfile && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      'div',
                      { className: 'navbar-user-name-container' },
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        'span',
                        {
                          className: 'navbar-user-name' },
                        user.firstName,
                        ' ',
                        user.lastName
                      )
                    );
                  } })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_slot_fill__["Slot"], { name: 'Navbar-Center' }),
          !isEmbedded && (user.hasProfile ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            { className: 'right-container navbar-user-actions' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react_router_dom__["Switch"],
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["Route"], { path: '/', exact: true, render: function render() {
                  return null;
                } }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["Route"], { render: function render() {
                  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Link"],
                    { className: 'navbar-icon-button', to: '/' },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Icon"], { icon: 'home', className: 'icon' })
                  );
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'a',
              { className: 'navbar-icon-button', onClick: helpPopup.toggle },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Icon"], { icon: 'help', className: 'icon' }),
              helpPopup.isOpen && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Popup"],
                { arrow: true, offset: '25 0', className: 'help-bubble' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  'div',
                  { className: 'bubble-title bold' },
                  'Need help?'
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Button"].a,
                  { target: '_blank', href: '/first-steps', rel: 'noopener noreferrer' },
                  'First steps guide'
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Button"].a,
                  { target: '_blank', href: 'https://info.horosproject.org/horos-cloud-faq', rel: 'noopener noreferrer' },
                  'Frequently Asked Questions'
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Button"].a,
                  { target: '_blank', href: 'http://academy.horosproject.org/', rel: 'noopener noreferrer' },
                  'Learn with Horos Academy'
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  WistiaSpan,
                  { className: 'wistia_embed wistia_async_zb975x40on popover=true popoverContent=link' },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Button"].a,
                    { className: 'video-link', href: '#' },
                    'Check our video tutorial'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Button"].a,
                  { highlight: true, target: '_blank', href: 'https://horosproject.org/professional-support/',
                    rel: 'noopener noreferrer' },
                  'Get professional support'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'a',
              { className: 'user-menu', onClick: preferencesMenu.toggle },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'user-avatar', style: this.getAvatarBackground() }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'icon icon-arrow-down' }),
              preferencesMenu.isOpen && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["ContextMenu"],
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  ContextMenuHeader,
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'user-avatar', style: this.getAvatarBackground() }),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'div',
                    { className: 'user-info' },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      'div',
                      { className: 'user-name' },
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        'span',
                        null,
                        user.firstName,
                        ' ',
                        user.lastName
                      ),
                      user.accountStatus === "trialing" && !user.stripeCardAdded && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        TrialLabel,
                        { to: '/checkout' },
                        'Trial'
                      ),
                      user.accountStatus === "canceled" && user.stripeCardAdded && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        CanceledLabel,
                        { to: '/checkout' },
                        'Canceled'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      'div',
                      { className: 'user-email' },
                      user.email
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["ListSeparator"], null),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Li"], { linkTo: '/profile', icon: 'edit-box', label: 'Edit profile' }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Li"], { skipTo: '/account-settings', label: 'Account settings' }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Li"], { linkTo: '/workstations', label: 'Manage workstations' }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["ListSeparator"], null),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Li"], { linkTo: '/billing', icon: 'credit-card', label: 'Manage subscription' }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["ListSeparator"], null),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Li"], { onClick: this.signOut, icon: 'sign-out', label: 'Sign out' }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  ContextMenuFooter,
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'a',
                    { href: '/license', target: '_blank', rel: 'noopener noreferrer' },
                    'License Terms'
                  ),
                  ' - ',
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'a',
                    {
                      href: 'https://www.horosproject.org/', target: '_blank', rel: 'noopener noreferrer' },
                    'Horos Project'
                  )
                )
              )
            )
          ) : user.id && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            { className: 'right-container' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_components__["Button"],
              { onClick: this.signOut, small: true, outline: true, white: true, className: 'logout-button' },
              'Logout'
            )
          ))
        )
      );
    }
  }]);

  return Navbar;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PureComponent)) || _class) || _class) || _class);

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(3);
var _templateObject = _taggedTemplateLiteral(['\n  padding: 10rem 1rem 1rem;\n  text-align: center;\n  max-width: 40rem;\n  margin: 0 auto;\n  color: rgba(0,0,0,0.5);\n  h2 {\n    font-size: 20px;\n    margin-bottom: 0.5rem;\n  }\n  p {\n    max-width: 25rem;\n    margin: 0 auto 2rem;\n  }\n  ', ' {\n    font-size: 70px;\n  }\n  .content-box {\n    padding: 3rem 1rem;\n    background-color: rgba(0,0,0,0.05);\n    border-radius: 5px;\n  }\n  @media (max-width: 515px) {\n    padding: 6rem 1rem;\n    h2 {\n      max-width: 16rem;\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n'], ['\n  padding: 10rem 1rem 1rem;\n  text-align: center;\n  max-width: 40rem;\n  margin: 0 auto;\n  color: rgba(0,0,0,0.5);\n  h2 {\n    font-size: 20px;\n    margin-bottom: 0.5rem;\n  }\n  p {\n    max-width: 25rem;\n    margin: 0 auto 2rem;\n  }\n  ', ' {\n    font-size: 70px;\n  }\n  .content-box {\n    padding: 3rem 1rem;\n    background-color: rgba(0,0,0,0.05);\n    border-radius: 5px;\n  }\n  @media (max-width: 515px) {\n    padding: 6rem 1rem;\n    h2 {\n      max-width: 16rem;\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }





var PageError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(function (_ref) {
  var className = _ref.className;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'content-box' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Icon"], { icon: 'warning' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        null,
        'This page could not be loaded'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Please refresh the page and try again.',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        'If the problem persists, contact us.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"].Link,
        { to: '/' },
        'Return to home'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"].a,
        { href: '.', highlight: true },
        'Refresh page'
      )
    )
  );
})(_templateObject, __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Icon"]);

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return simpleFetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return queryHasValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return formatCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return daysLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripeIntervalToInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripeIntervalToAbbreviation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPlanType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getAuthorities; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getResource = function getResource(str) {
  if (str.indexOf("/public") === 0) {
    return str;
  } else {
    return "/api/report-resources/" + str;
  }
  // if (process.env.NODE_ENV === 'development') {
  //   return "/api/report-resourcaes/"+str
  // } else {
  //   return (/*store.getState().resourceOrigin || */location.origin) + '/resource.php?resourceUID=' + str + '&reportUID=' /*+ getReportId()*/
  // }
};

var simpleFetch = function simpleFetch(url, extra) {
  return fetch(url, _extends({
    credentials: 'same-origin',
    method: 'GET'
  }, extra)).then(function (e) {
    if (e.status >= 400) {
      return Promise.reject(e);
    } else {
      return e.text();
    }
  }).then(function (e) {
    if (e && typeof e === 'string') {
      try {
        return JSON.parse(e);
      } catch (e) {
        return e;
      }
    } else {
      return e;
    }
  });
};

var queryHasValue = function queryHasValue(url, key, value) {
  return url.indexOf('?' + key + '=' + value) >= 0 || url.indexOf('&' + key + '=' + value) >= 0;
};

var splitAt = function splitAt(str, pos) {
  return [str.slice(0, pos), str.slice(pos)];
};

var formatCurrency = function formatCurrency(price) {
  var _splitAt = splitAt("00" + Math.round(Math.abs(price)), -2),
      _splitAt2 = _slicedToArray(_splitAt, 2),
      left = _splitAt2[0],
      right = _splitAt2[1];

  return left.replace(/^0+(\d)/, '$1').replace(/\d(?=(\d{3})+$)/g, '$&,') + '.' + right;
};

var DAY_MILLSECS = 1000 * 60 * 60 * 24;
var daysLeft = function daysLeft(millisecs) {
  return Math.round((millisecs - Date.now()) / DAY_MILLSECS);
};

var toPrice = formatCurrency;

var normalizeSubscription = function normalizeSubscription(stripeSubscriptionOrEmpty, hasCard) {
  var stripeSubscription = stripeSubscriptionOrEmpty || { status: 'canceled' };
  return (stripeSubscription.status === 'active' || stripeSubscription.status === 'trialing') && stripeSubscription.cancelAtPeriodEnd ? _extends({}, stripeSubscription, { status: 'canceled_renewal' }) : stripeSubscription.status === 'trialing' && hasCard ? _extends({}, stripeSubscription, { status: 'active' }) : stripeSubscription;
};
var stripeIntervalToInterval = function stripeIntervalToInterval(interval, capitalize) {
  var irregular_intervals = { 'day': 'dai' };
  var result = (irregular_intervals[interval] || interval) + "ly";
  return (capitalize ? result.charAt(0).toUpperCase() : result.charAt(0)) + result.slice(1);
};
var stripeIntervalToAbbreviation = function stripeIntervalToAbbreviation(interval) {
  return { 'year': 'yr', 'month': 'mo', 'week': 'wk', 'day': 'day' }[interval];
};

var getPlanType = function getPlanType(type) {
  return {
    "REPORT_BASIC": "Report Basic",
    "REPORT_BASIC_V2": "Report Free",
    "REPORT_BASIC_V3": "Report Basic",
    "REPORT_STANDARD": "Report Standard",
    "REPORT_STANDARD_V2": "Report Standard",
    "REPORT_PRO": "Report Pro",
    "STORAGE_PRO": "Storage Pro",
    "STORAGE_STANDARD": "Storage Standard"
  }[type];
};

var getAuthorities = function getAuthorities(type) {
  return type.indexOf("REPORT_BASIC") === 0 ? ["ROLE_USER"] : ["ROLE_USER", "KEY_IMAGES"];
};

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportCheckout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icepath__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_url_search_params__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_url_search_params___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_url_search_params__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_report_components_src_components_timer__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CheckoutSignupDialog__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CreditCardCheckout__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user_ProfileData__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__user_Billing__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CheckoutSuccess__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__reducers_index__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class;

var _templateObject = _taggedTemplateLiteral(['\n  margin-top: -1rem;\n  margin-bottom: 2.5rem;\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  ', ' {\n    font-size: 24px;\n    margin-right: 1rem;\n    font-weight: 400;\n  }\n  h4 {\n    margin: 0;\n    font-size: 14px;\n  }\n'], ['\n  margin-top: -1rem;\n  margin-bottom: 2.5rem;\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  ', ' {\n    font-size: 24px;\n    margin-right: 1rem;\n    font-weight: 400;\n  }\n  h4 {\n    margin: 0;\n    font-size: 14px;\n  }\n']);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }






















var PLAN_TYPE_HEADER = {
  'REPORT_BASIC': 'Basic',
  'REPORT_BASIC_V2': 'Free',
  'REPORT_BASIC_V3': 'Basic',
  'REPORT_STANDARD': 'Standard',
  'REPORT_STANDARD_V2': 'Standard',
  'REPORT_PRO': 'Pro'
};

var PriceChangeNotice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["e" /* InfoBox */])(_templateObject, __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Icon"]);

var PlanRadioComponent = function PlanRadioComponent(_ref) {
  var form = _ref.form,
      plan = _ref.plan,
      monthlyCost = _ref.monthlyCost,
      isCurrent = _ref.isCurrent;
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["f" /* PlanRadio */],
    { form: form,
      className: 'plan-box selectable',
      path: 'stripePlanId',
      discontinuedPlan: plan.discontinued,
      fieldValue: plan.id },
    plan.amount === 0 ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["g" /* PlanPrice */],
      null,
      'Free'
    ) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["g" /* PlanPrice */],
      null,
      '$',
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["d" /* toPrice */])(plan.amount),
      ' USD / ',
      plan.interval
    ),
    monthlyCost && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["h" /* PlanPriceDetail */],
      null,
      'You save $',
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["d" /* toPrice */])(monthlyCost * 12 - plan.amount),
      ' USD'
    ),
    isCurrent && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["i" /* CurrentPlanLabel */],
      null,
      'Current'
    )
  );
};

var SubscriptionPlansCard = function SubscriptionPlansCard(_ref2) {
  var form = _ref2.form,
      plans = _ref2.plans,
      planType = _ref2.planType,
      currentPlanId = _ref2.currentPlanId,
      currentStatus = _ref2.currentStatus,
      children = _ref2.children;

  var isCardSelected = plans.find(function (plan) {
    return plan.id === form.properties.stripePlanId;
  });
  var discontinuedPlan = !plans.find(function (_) {
    return !_.discontinued;
  });
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["j" /* SubscriptionPlan */],
    {
      onClick: function onClick() {
        return !isCardSelected && form.connector.setValue('stripePlanId', plans[0].id);
      },
      selected: !!isCardSelected,
      discontinuedPlan: discontinuedPlan
    },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["k" /* PlanHeader */],
      null,
      PLAN_TYPE_HEADER[planType],
      ' ',
      discontinuedPlan && '(discontinued)'
    ),
    __WEBPACK_IMPORTED_MODULE_13__user_Billing__["d" /* PLAN_TYPE_DETAILS */][planType](),
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["l" /* PlanBillingOptionContainer */],
      null,
      plans.sort(function (a, b) {
        return a.amount < b.amount ? 1 : -1;
      }).map(function (plan) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(PlanRadioComponent, {
          plan: plan,
          key: plan.id,
          form: form,
          isCurrent: plan.id === currentPlanId && currentStatus !== 'trialing',
          monthlyCost: plan.interval === 'year' && plans.filter(function (_) {
            return _.interval !== 'year';
          }).map(function (_) {
            return _.amount;
          })[0]
        });
      })
    )
  );
};

var PLAN_PARAMS_TRANSLATION = {
  'STANDARD': 'REPORT_STANDARD_V2',
  'PRO': 'REPORT_PRO',
  'BASIC': 'REPORT_BASIC_V3'
};

var ReportCheckout = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__["fetchConnect"])(function (_ref3) {
  var user = _ref3.user;
  return { user: user };
}, { userSubscriptionSuccess: __WEBPACK_IMPORTED_MODULE_17__reducers_index__["o" /* userSubscriptionSuccess */], setNotifications: __WEBPACK_IMPORTED_MODULE_17__reducers_index__["c" /* setNotifications */] }, 'stripe'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["withForm"])(), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__["withToggles"])('couponLoading', 'isLoading', 'checkoutStep', 'firstTimeDialog'), _dec(_class = _dec2(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__["withRouteTo"])(_class = _dec3(_class = function (_React$PureComponent) {
  _inherits(ReportCheckout, _React$PureComponent);

  function ReportCheckout() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, ReportCheckout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = ReportCheckout.__proto__ || Object.getPrototypeOf(ReportCheckout)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {}, _this.stripePlans = _this.props.stripe.stripePlans.plans, _this.replacedPlans = _this.props.stripe.replacedPlans ? _this.props.stripe.replacedPlans.plans : [], _this.allPlans = [].concat(_toConsumableArray(_this.stripePlans), _toConsumableArray(_this.replacedPlans)), _this.isUpgradePlan = new __WEBPACK_IMPORTED_MODULE_6_url_search_params___default.a(_this.props.location.search).get('of') === 'plan', _this.isFirstTime = new __WEBPACK_IMPORTED_MODULE_6_url_search_params___default.a(_this.props.location.search).get('from') === 'signup', _this.preValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_validation__["a" /* buildValidation */])({
      acceptedTerms: function acceptedTerms(v) {
        return !v && 'You must read & agree to the License Terms.';
      }
    }), _this.setStripeCustomer = function (stripe, fromSignup) {
      var customer = stripe && stripe.customer;
      if (customer) {
        var currentCard = customer.sources && customer.sources.data && customer.sources.data[0];
        var currentSubscription = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["a" /* normalizeSubscription */])(customer.subscriptions && customer.subscriptions.data && customer.subscriptions.data.find(function (_) {
          return _.metadata && (!_.metadata.type || _.metadata.type === 'REPORT');
        }), currentCard);
        _this.setState({
          loadedStripeCustomer: true,
          currentCard: currentCard,
          currentSubscription: currentSubscription,
          fromSignup: fromSignup
        }, _this.fetchProrate);
      } else {
        _this.setState({
          loadedStripeCustomer: true,
          fromSignup: fromSignup
        });
      }
    }, _this.confirmCoupon = function (e) {
      e.preventDefault();
      var _this$props$form$prop = _this.props.form.properties,
          stripePlanId = _this$props$form$prop.stripePlanId,
          coupon = _this$props$form$prop.coupon;

      _this.props.couponLoading.open();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["getFetcher"])('/api/coupon-test', { coupon: coupon }).then(function (coupon) {
        return _this.fetchProrate(true, coupon);
      }).catch(function () {
        return _this.fetchProrate(true, { "id": coupon });
      });
    }, _this.isCanceled = function () {
      return _this.state.currentSubscription && (_this.state.currentSubscription.status === 'canceled' || _this.state.currentSubscription.status === 'canceled_renewal');
    }, _this.getCurrentPlanId = function () {
      return _this.isFirstTime || _this.state.isCanceled ? '' : __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].get(_this.state, ['currentSubscription', 'plan', 'id']);
    }, _this.hasCurrentActivePlan = function () {
      return !_this.isFirstTime && _this.state.currentSubscription && _this.state.currentSubscription.status === 'active';
    }, _this.isCurrentPlanSelected = function () {
      return _this.hasCurrentActivePlan() && _this.getCurrentPlanId() === _this.props.form.properties.stripePlanId;
    }, _this.fetchProrate = function (checkingCoupon, checkedCoupon) {
      var currentPlan = _this.getCurrentPlanId();
      if (!currentPlan) {
        return;
      }
      var stripePlanId = _this.props.form.properties.stripePlanId;
      if (!_this.state.currentSubscription || _this.hasCurrentActivePlan() && currentPlan === stripePlanId) {
        _this.props.couponLoading.close();
        if (checkingCoupon) {
          _this.props.form.connector.setValue('coupon', '');
          var valid = checkedCoupon && checkedCoupon.valid;
          _this.setState({
            coupon: checkedCoupon,
            couponError: !valid && 'invalid.coupon'
          });
        }
        return;
      }
      if (!checkingCoupon) {
        _this.setState({ prorate: null, couponError: null });
      }
      var coupon = checkingCoupon ? checkedCoupon : _this.state.coupon;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs__["getFetcher"])('/api/pro-rata', _extends({
        subscriptionId: _this.state.currentSubscription.id,
        stripePlanId: stripePlanId
      }, coupon ? { coupon: coupon.id } : {})).then(function (prorate) {
        if (checkingCoupon) {
          _this.props.form.connector.setValue('coupon', '');
        }
        var couponError = checkingCoupon && !coupon ? 'invalid.coupon' : coupon && !prorate.discount ? 'invalid.coupon.plan' : prorate.discount ? null : _this.state.couponError;
        _this.props.couponLoading.close();
        _this.setState({
          prorate: prorate,
          coupon: coupon,
          couponError: couponError
        });
      }).catch(function () {
        _this.props.couponLoading.close();
        if (checkingCoupon) {
          _this.props.form.connector.setValue('coupon', '');
        }
        _this.setState({ prorate: null });
      });
    }, _this.isFreePlanSelected = function () {
      // const freePlanId = this.stripePlans.filter(_ => _.name === 'REPORT_BASIC_V2').map(_ => _.id)[0]
      // return this.props.form.properties.stripePlanId === freePlanId
      return false;
    }, _this.goToCreditCardCheckout = function () {
      if (_this.isFreePlanSelected()) {
        //always false
        // this.signUpForFree()
      } else {
        _this.props.checkoutStep.open(2);
      }
    }, _this.login = function () {
      var validated = _this.preValidation(_this.props.form.properties, {});
      if (validated.errors) {
        return _this.props.form.connector.setErrors(validated.errors);
      }
      if (_this.props.user.id) {
        if (_this.isFreePlanSelected()) {
          //always false
          // this.props.isLoading.open()
          // this.signUpForFree()
        } else {
          _this.props.checkoutStep.open(2);
        }
      } else {
        _this.props.checkoutStep.open(1);
      }
    }, _this.creditCardSuccess = function () {
      _this.props.checkoutStep.open(3);
      var selectedPlanInfo = _this.stripePlans.find(function (_) {
        return _.id === _this.props.form.properties.stripePlanId;
      });
      _this.props.userSubscriptionSuccess(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["k" /* getAuthorities */])(selectedPlanInfo.name));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReportCheckout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var params = new __WEBPACK_IMPORTED_MODULE_6_url_search_params___default.a(this.props.location.search);
      var planName = PLAN_PARAMS_TRANSLATION[(params.get('plan') || '').toUpperCase()] || 'REPORT_STANDARD_V2';
      var interval = params.get('interval') || 'year';
      this.props.form.connector.setValue('stripePlanId', this.isFirstTime && this.stripePlans.filter(function (_) {
        return _.interval === interval && _.name === planName;
      }).map(function (_) {
        return _.id;
      })[0] || this.isUpgradePlan && this.stripePlans.filter(function (_) {
        return _.interval === interval && _.name === 'REPORT_PRO';
      }).map(function (_) {
        return _.id;
      })[0] || __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].get(this.state, ['currentSubscription', 'plan', 'id']) || (this.stripePlans.find(function (_) {
        return _.interval === interval && _.name === planName;
      }) || this.stripePlans[0]).id);
      if (this.props.stripe.customer) {
        this.setStripeCustomer(this.props.stripe);
      } else if (this.props.user.id) {
        this.props.routeTo('/billing');
      }
      if (this.isFirstTime) {
        this.props.firstTimeDialog.open();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps) {
      if (this.state.currentSubscription && oldProps.form.properties.stripePlanId !== this.props.form.properties.stripePlanId) {
        this.fetchProrate();
      }
    }

    /*signUpForFree = () => postFetcher('/api/update-subscription', {
      stripePlanId: this.props.form.properties.stripePlanId,
      subscriptionType: 'STORAGE'
    }, {method: 'PUT'}).then(() =>
      this.props.checkoutStep.open(3)
    )*/

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.isUpgradePlan && this.props.user.id && !this.state.loadedStripeCustomer) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Loading"], { absolute: true, size: 40, borderWidth: 6 });
      }

      var _props = this.props,
          form = _props.form,
          checkoutStep = _props.checkoutStep,
          firstTimeDialog = _props.firstTimeDialog,
          couponLoading = _props.couponLoading,
          isLoading = _props.isLoading,
          user = _props.user;
      var _state = this.state,
          appliedCoupon = _state.coupon,
          prorate = _state.prorate,
          couponError = _state.couponError,
          fromSignup = _state.fromSignup;


      var isCurrentPlanSelected = this.isCurrentPlanSelected();
      var hasCurrentActivePlan = this.hasCurrentActivePlan();

      var currentPlanInfo = this.allPlans.find(function (_) {
        return _.id === _this2.getCurrentPlanId();
      });
      var selectedPlanInfo = this.stripePlans.find(function (_) {
        return _.id === form.properties.stripePlanId;
      });

      var orderPreview = function orderPreview(changePlanButton, finished) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(OrderSummary, {
          currentPlanId: _this2.getCurrentPlanId(),
          form: form,
          finished: finished,
          changePlanButton: changePlanButton,
          confirmCoupon: _this2.confirmCoupon,
          couponLoading: couponLoading,
          couponError: couponError,
          prorate: prorate,
          appliedCoupon: appliedCoupon,
          plan: selectedPlanInfo
        });
      };

      if (checkoutStep.isOpen === 2) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CreditCardCheckout__["a" /* CreditCardCheckout */], {
          currentCard: this.state.currentCard,
          orderPreview: orderPreview,
          finalPlan: selectedPlanInfo,
          coupon: appliedCoupon && appliedCoupon.id,
          prorate: prorate,
          skipContactInfo: true,
          workstationsVPN: 0,
          form: form,
          hasCurrentActivePlan: hasCurrentActivePlan,
          isCurrentPlanSelected: isCurrentPlanSelected,
          nextStep: this.creditCardSuccess,
          prevStep: checkoutStep.close
        });
      }
      if (checkoutStep.isOpen === 3) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__CheckoutSuccess__["a" /* ReportCheckoutSuccess */], {
          isFreePlanSelected: this.isFreePlanSelected(),
          planName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["c" /* getPlanType */])(selectedPlanInfo.name),
          orderPreview: orderPreview,
          finishButton: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"].Link,
            { highlight: true,
              to: '/' },
            fromSignup ? 'Start using Horos Cloud' : 'Go to home screen'
          )
        });
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["m" /* CheckoutPage */],
        { className: 'content edit-profile' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'profile-header checkout-header' + (hasCurrentActivePlan ? ' mobile-margin' : '') },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'h1',
            null,
            hasCurrentActivePlan ? 'Update Horos Cloud subscription' : 'Horos Cloud subscription'
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"].a,
            { small: true, href: 'https://info.horosproject.org/horos-cloud-faq', target: '_blank' },
            'Learn more'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'h3',
          null,
          hasCurrentActivePlan ? 'Select a new Horos Cloud Reporting plan' : 'Select your Horos Cloud Reporting plan'
        ),
        hasCurrentActivePlan && !currentPlanInfo.discontinued && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'p',
          null,
          'Your current plan is ',
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'strong',
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["c" /* getPlanType */])(currentPlanInfo.name),
            ' - ',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["f" /* stripeIntervalToInterval */])(currentPlanInfo.interval),
            ' billing ($',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["d" /* toPrice */])(currentPlanInfo.amount),
            ' USD / ',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["e" /* stripeIntervalToAbbreviation */])(currentPlanInfo.interval),
            ')'
          ),
          '.'
        ),
        hasCurrentActivePlan && currentPlanInfo.discontinued && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'p',
            null,
            'Your current plan has been discontinued:'
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SubscriptionPlansCard, {
            planType: currentPlanInfo.name,
            form: form,
            plans: [currentPlanInfo],
            currentPlanId: this.getCurrentPlanId(),
            currentStatus: this.state.currentSubscription.status
          }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'p',
            { className: 'warning-text' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'b',
              null,
              'You can keep your current plan and price or select a new plan and get access to new features:'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(PlanTypeSelection, {
          form: form,
          currentPlanId: this.getCurrentPlanId(),
          currentStatus: __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].get(this.state, 'currentSubscription', 'status'),
          stripePlans: this.stripePlans
        }),
        isCurrentPlanSelected && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["e" /* InfoBox */],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'strong',
              null,
              'The plan and billing period you selected is already active in your current subscription.'
            ),
            ' If you\'d like to change your plan, select another option above and click \'Update subscription\'. For changing your credit card details only, click below.'
          )
        ),
        orderPreview(),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'checkbox-list' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["SimpleCheckbox"], {
            form: form,
            label: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'span',
              { className: 'license-terms-agreement' },
              'By continuing, you confirm you have read and accept the Horos Cloud ',
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'a',
                {
                  className: 'link nowrap', href: '/license', target: '_blank' },
                'License Terms'
              ),
              '.'
            ),
            path: 'acceptedTerms',
            tabIndex: 1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["Errors"], { form: form }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'profile-footer' },
          user.id && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"].Link,
            { to: '/billing' },
            'Cancel'
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"],
            {
              highlight: true,
              isLoading: isLoading.isOpen,
              disabled: isCurrentPlanSelected,
              onClick: this.login

            },
            this.isFreePlanSelected() && !isCurrentPlanSelected ? 'Subscribe' : 'Next'
          ),
          checkoutStep.isOpen === 1 && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CheckoutSignupDialog__["a" /* CheckoutSignupDialog */], {
            closeDialog: checkoutStep.close,
            form: form,
            setStripCustomer: this.setStripeCustomer,
            nextStep: this.goToCreditCardCheckout
          })
        ),
        firstTimeDialog.isOpen && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(FirstTimeDialog, { closeDialog: firstTimeDialog.close })
      );
    }
  }]);

  return ReportCheckout;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.PureComponent)) || _class) || _class) || _class) || _class);

var PlanTypeSelection = function PlanTypeSelection(_ref5) {
  var form = _ref5.form,
      stripePlans = _ref5.stripePlans,
      currentStatus = _ref5.currentStatus,
      currentPlanId = _ref5.currentPlanId;
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["n" /* SubscriptionPlanList */],
    null,
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SubscriptionPlansCard, {
      planType: 'REPORT_BASIC_V3',
      form: form,
      plans: stripePlans.filter(function (_) {
        return _.name === 'REPORT_BASIC_V3';
      }),
      currentPlanId: currentPlanId,
      currentStatus: currentStatus
    }),
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SubscriptionPlansCard, {
      planType: 'REPORT_STANDARD_V2',
      form: form,
      plans: stripePlans.filter(function (_) {
        return _.name === 'REPORT_STANDARD_V2';
      }),
      currentPlanId: currentPlanId,
      currentStatus: currentStatus
    }),
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SubscriptionPlansCard, {
      planType: 'REPORT_PRO',
      form: form,
      plans: stripePlans.filter(function (_) {
        return _.name === 'REPORT_PRO';
      }),
      currentPlanId: currentPlanId,
      currentStatus: currentStatus
    })
  );
};

var OrderSummary = function OrderSummary(_ref6) {
  var changePlanButton = _ref6.changePlanButton,
      finished = _ref6.finished,
      currentPlanId = _ref6.currentPlanId,
      plan = _ref6.plan,
      form = _ref6.form,
      confirmCoupon = _ref6.confirmCoupon,
      appliedCoupon = _ref6.appliedCoupon,
      couponLoading = _ref6.couponLoading,
      prorate = _ref6.prorate,
      couponError = _ref6.couponError;

  if (currentPlanId === form.properties.stripePlanId || !plan || plan.amount === 0) return null;
  var nonNullProrate = prorate || {};
  var saldo = nonNullProrate.total + nonNullProrate.startingBalance;
  var intervals = saldo <= 0 ? -saldo / plan.amount : 0;
  var nextChargeDate = new Date(nonNullProrate.nextPaymentAttempt * 1000);
  if (plan.interval === 'year') {
    nextChargeDate.setFullYear(nextChargeDate.getFullYear() + Math.ceil(intervals));
  } else {
    nextChargeDate.setMonth(nextChargeDate.getMonth() + Math.ceil(intervals));
  }
  var nextCharge = intervals === 0 ? nonNullProrate.amountDue : plan.amount + saldo % plan.amount;

  var validCoupon = prorate ? nonNullProrate.discount && nonNullProrate.discount.coupon : appliedCoupon && appliedCoupon.valid ? appliedCoupon : null;

  var couponDiscount = validCoupon ? validCoupon.amountOff ? validCoupon.amountOff : Math.round(plan.amount * validCoupon.percentOff / 100) : 0;

  var credit = plan.amount - saldo + (isNaN(couponDiscount) ? 0 : -couponDiscount);

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["o" /* OrderSummaryWrapper */],
    null,
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      { className: 'heading-text' },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'h3',
        null,
        'Your Order ',
        changePlanButton
      )
    ),
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      { className: 'card order' },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'order-table' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'b',
              null,
              PLAN_TYPE_HEADER[plan.name],
              ' Plan'
            ),
            ' (',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["f" /* stripeIntervalToInterval */])(plan.interval),
            ')'
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'span',
            { className: 'amount' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'b',
              null,
              '$',
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["d" /* toPrice */])(plan.amount),
              ' USD'
            )
          )
        ),
        validCoupon && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'span',
            null,
            'Promo code discount (',
            validCoupon.percentOff ? validCoupon.percentOff + '%' : '$' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["d" /* toPrice */])(validCoupon.amountOf) + ' USD',
            '):'
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'span',
            { className: 'discount amount' },
            '-$',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["d" /* toPrice */])(couponDiscount),
            ' USD'
          )
        ),
        credit > 0 && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'span',
            null,
            'Credit from current subscription:'
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'span',
            { className: 'discount amount' },
            '-$',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["d" /* toPrice */])(credit),
            ' USD'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: 'total' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'b',
              null,
              'Your first payment',
              !isNaN(nextChargeDate.getTime()) && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'span',
                { className: 'nowrap' },
                ' (on ',
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_report_components_src_components_timer__["a" /* Timer */], { key: 'date', language: 'en', dateFormat: 'L dd, yyyy', noPrefix: true, noHours: true,
                  time: nextChargeDate }),
                ')'
              ),
              ':'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'span',
            { className: 'amount' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'b',
              null,
              '$',
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["d" /* toPrice */])(isNaN(nextCharge) ? plan.amount : nextCharge),
              ' USD'
            )
          )
        )
      ),
      !finished && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["p" /* PromoCodeContainer */],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'form',
          { onSubmit: confirmCoupon },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["Field"],
            { label: 'Promo Code' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["q" /* TextInputWithButton */],
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'input-container' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["TextInput"], { form: form, path: 'coupon', placeholder: 'Insert your promo code' })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"],
                { small: true, isLoading: couponLoading.isOpen, type: 'submit' },
                'Apply'
              )
            )
          )
        ),
        validCoupon && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["r" /* CouponFeedback */],
          { success: true },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'span',
            { className: 'applied-coupon' },
            appliedCoupon.id
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'b',
            null,
            'Coupon successfully applied.'
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            null,
            validCoupon.percentOff ? validCoupon.percentOff + '% off on first payment.' : '$' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_index__["d" /* toPrice */])(validCoupon.amountOf) + ' USD off.'
          )
        ),
        couponError && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["r" /* CouponFeedback */],
          { error: true },
          appliedCoupon && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'span',
            { className: 'applied-coupon' },
            appliedCoupon.id
          ),
          couponError === 'invalid.coupon' && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            null,
            'Sorry, the coupon you entered is not valid.'
          ),
          couponError === 'invalid.coupon.plan' && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            null,
            'Sorry, coupon not valid for this user account or selected plan.'
          )
        )
      ),
      finished && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__CheckoutComponents__["p" /* PromoCodeContainer */],
        null,
        (__WEBPACK_IMPORTED_MODULE_13__user_Billing__["d" /* PLAN_TYPE_DETAILS */][plan.name] || function () {
          return '';
        })()
      )
    )
  );
};

var FirstTimeDialog = function FirstTimeDialog(_ref7) {
  var closeDialog = _ref7.closeDialog;
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_12__user_ProfileData__["b" /* NewUserDialog */],
    {
      title: 'Welcome to Horos Cloud'
    },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Dialog"].Content,
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', { src: '/public/favicon.png', alt: 'Horos Icon' }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'p',
        null,
        'Check our subscription plans and select',
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('br', null),
        ' one that best fits your practice.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Dialog"].Footer,
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"],
        { highlight: true, onClick: closeDialog },
        'Continue'
      )
    )
  );
};

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUnvolumedPlanName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StorageCheckout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_index__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_Billing__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_url_search_params__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_url_search_params___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_url_search_params__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CheckoutSignupDialog__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CreditCardCheckout__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CheckoutSuccess__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_report_components_src_components_timer__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_icepath__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_icepath__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class;

var _templateObject = _taggedTemplateLiteral(['\n'], ['\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  >div {\n    margin-bottom: 0;\n    >div {\n      border-radius: 5px !important;\n      :before {\n        border-radius: 5px !important;\n      }\n      input {\n        width: auto !important;\n        flex-grow: 1 !important;\n        :focus {\n          box-shadow: none !important;\n        }\n      }\n      input ~ span {\n        border-top-right-radius: 5px;\n        border-bottom-right-radius: 5px;\n        margin-left: -4px;\n        min-width: 126px;\n        position: relative;\n        justify-content: center;\n        white-space: nowrap;\n      }\n    }\n  }\n  .increment-buttons {\n    position: absolute;\n    left: -5.75rem;\n    top: 50%;\n    transform: translateY(-50%);\n    a span {\n      padding: 0.5rem;\n      background-color: rgba(0,0,0,0.1);\n      margin-left: 0.5rem;\n      border-radius: 100px;\n      width: 2rem;\n      line-height: 1rem;\n      display: inline-block;\n      text-align: center;\n      font-size: 17px;\n      user-select: none;\n      :hover {\n        background-color: rgba(0,0,0,0.15);\n      }\n      :active {\n        background-color: rgba(0,0,0,0.2);\n      }\n    }\n  }\n'], ['\n  >div {\n    margin-bottom: 0;\n    >div {\n      border-radius: 5px !important;\n      :before {\n        border-radius: 5px !important;\n      }\n      input {\n        width: auto !important;\n        flex-grow: 1 !important;\n        :focus {\n          box-shadow: none !important;\n        }\n      }\n      input ~ span {\n        border-top-right-radius: 5px;\n        border-bottom-right-radius: 5px;\n        margin-left: -4px;\n        min-width: 126px;\n        position: relative;\n        justify-content: center;\n        white-space: nowrap;\n      }\n    }\n  }\n  .increment-buttons {\n    position: absolute;\n    left: -5.75rem;\n    top: 50%;\n    transform: translateY(-50%);\n    a span {\n      padding: 0.5rem;\n      background-color: rgba(0,0,0,0.1);\n      margin-left: 0.5rem;\n      border-radius: 100px;\n      width: 2rem;\n      line-height: 1rem;\n      display: inline-block;\n      text-align: center;\n      font-size: 17px;\n      user-select: none;\n      :hover {\n        background-color: rgba(0,0,0,0.15);\n      }\n      :active {\n        background-color: rgba(0,0,0,0.2);\n      }\n    }\n  }\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }



















var StorageVolumeWrapper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["s" /* ContentSection */])(_templateObject);
var WorkstationsWrapper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["s" /* ContentSection */])(_templateObject);
var TextInputWithTextBox = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);

var STORAGE_PLAN_TYPE_HEADER = {
  'STORAGE_STANDARD': 'Standard',
  'STORAGE_PRO': 'Pro'
};

var PlanRadioComponent = function PlanRadioComponent(_ref) {
  var form = _ref.form,
      plan = _ref.plan,
      monthlyCost = _ref.monthlyCost,
      isCurrent = _ref.isCurrent;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["f" /* PlanRadio */],
    { form: form,
      className: 'plan-box selectable',
      path: 'planType',
      discontinuedPlan: plan.discontinued,
      fieldValue: plan },
    plan.amount === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["g" /* PlanPrice */],
      null,
      'Free'
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["g" /* PlanPrice */],
      null,
      'Starting at $',
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["d" /* toPrice */])(plan.amount),
      ' USD / ',
      plan.interval
    ),
    monthlyCost && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["h" /* PlanPriceDetail */],
      null,
      'You save $',
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["d" /* toPrice */])(monthlyCost * 12 - plan.amount),
      ' USD'
    ),
    isCurrent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["i" /* CurrentPlanLabel */],
      null,
      'Current'
    )
  );
};

var SubscriptionPlansCard = function SubscriptionPlansCard(_ref2) {
  var form = _ref2.form,
      plans = _ref2.plans,
      planType = _ref2.planType,
      currentPlanId = _ref2.currentPlanId,
      currentStatus = _ref2.currentStatus,
      children = _ref2.children;

  var isCardSelected = plans.find(function (plan) {
    return plan === form.properties.planType;
  });
  var discontinuedPlan = !plans.find(function (_) {
    return !_.discontinued;
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["j" /* SubscriptionPlan */],
    {
      onClick: function onClick() {
        return !isCardSelected && form.connector.setValue('planType', plans.find(function (_) {
          return _.interval === form.properties.planType.interval;
        }));
      },
      selected: !!isCardSelected,
      discontinuedPlan: discontinuedPlan
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["k" /* PlanHeader */],
      null,
      STORAGE_PLAN_TYPE_HEADER[planType],
      ' ',
      discontinuedPlan && '(discontinued)'
    ),
    __WEBPACK_IMPORTED_MODULE_5__user_Billing__["f" /* STORAGE_PLAN_TYPE_DETAILS */][planType](),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["l" /* PlanBillingOptionContainer */],
      null,
      plans.sort(function (a, b) {
        return a.amount < b.amount ? 1 : -1;
      }).map(function (plan) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlanRadioComponent, {
          plan: plan,
          key: plan.id,
          form: form,
          isCurrent: plan.id === currentPlanId,
          monthlyCost: plan.interval === 'year' && plans.filter(function (_) {
            return _.interval !== 'year';
          }).map(function (_) {
            return _.amount;
          })[0]
        });
      })
    )
  );
};

var getUnvolumedPlanName = function getUnvolumedPlanName(planName) {
  return planName.split('_').slice(0, 2).join('_');
};
var getPlanVolume = function getPlanVolume(planName) {
  return planName.split('_')[2];
};

var StorageCheckout = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__["fetchConnect"])(function (_ref3) {
  var user = _ref3.user;
  return { user: user };
}, { userSubscriptionSuccess: __WEBPACK_IMPORTED_MODULE_8__reducers_index__["o" /* userSubscriptionSuccess */], setNotifications: __WEBPACK_IMPORTED_MODULE_8__reducers_index__["c" /* setNotifications */] }, 'stripe'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["withForm"])(), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__["withToggles"])('couponLoading', 'checkoutStep'), _dec(_class = _dec2(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__["withRouteTo"])(_class = _dec3(_class = function (_React$PureComponent) {
  _inherits(StorageCheckout, _React$PureComponent);

  function StorageCheckout() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, StorageCheckout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = StorageCheckout.__proto__ || Object.getPrototypeOf(StorageCheckout)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {}, _this.stripePlans = _this.props.stripe.storagePlans.plans, _this.isUpgradePlan = new __WEBPACK_IMPORTED_MODULE_9_url_search_params___default.a(_this.props.location.search).get('of') === 'plan', _this.vpnCost = {
      year: _this.props.stripe.vpnstationPriceYear,
      month: _this.props.stripe.vpnstationPrice
    }, _this.preValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_validation__["a" /* buildValidation */])({
      acceptedTerms: function acceptedTerms(v) {
        return !v && 'You must read & agree to the License Terms.';
      }
    }), _this.setStripeCustomerAfterMount = function (stripe) {
      var customer = stripe.customer;
      if (!_this.isUpgradePlan && customer.subscriptions && customer.subscriptions.data && customer.subscriptions.data.find(function (_) {
        return _.metadata && _.metadata.type === 'STORAGE';
      })) {
        _this.props.routeTo('/billing');
      } else {
        _this.setStripeCustomer(stripe);
      }
    }, _this.setStripeCustomer = function (stripe) {
      var customer = stripe && stripe.customer;
      if (customer) {
        var currentCard = customer.sources && customer.sources.data && customer.sources.data[0];
        var currentSubscription = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["a" /* normalizeSubscription */])(customer.subscriptions && customer.subscriptions.data && customer.subscriptions.data.find(function (_) {
          return _.metadata && _.metadata.type === 'STORAGE';
        }), currentCard);
        _this.setState({
          loadedStripeCustomer: true,
          currentCard: currentCard,
          currentSubscription: currentSubscription
        }, _this.fetchProrate);
      } else {
        _this.setState({
          loadedStripeCustomer: true
        });
      }
    }, _this.confirmCoupon = function (e) {
      e.preventDefault();
      var coupon = _this.props.form.properties.coupon;

      _this.props.couponLoading.open();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_startlibs__["getFetcher"])('/api/coupon-test', { coupon: coupon }).then(function (couponDiscount) {
        if (_this.state.currentSubscription && _this.state.currentSubscription.id) {
          _this.fetchProrate(true, coupon);
        } else if (couponDiscount.valid) {
          _this.setState({ couponDiscount: couponDiscount, coupon: coupon, couponError: null });
          _this.props.couponLoading.close();
          _this.props.form.connector.setValue('coupon', '');
        } else {
          return Promise.reject(couponDiscount);
        }
      }).catch(function () {
        if (_this.state.currentSubscription && _this.state.currentSubscription.id) {
          _this.fetchProrate(true, null);
        } else {
          _this.setState({ coupon: coupon, couponDiscount: null, couponError: 'invalid.coupon' });
          _this.props.couponLoading.close();
          _this.props.form.connector.setValue('coupon', '');
        }
      });
    }, _this.isCanceled = function () {
      return _this.state.currentSubscription.status === 'canceled' || _this.state.currentSubscription.status === 'canceled_renewal';
    }, _this.stripePlansIds = _this.stripePlans.map(function (_) {
      return _.id;
    }), _this.getCurrentPlanId = function () {
      return _this.state.currentSubscription && (_this.isCanceled() ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_icepath__["ice"])(_this.state.currentSubscription).get(['subscriptionItems', 'data']).filter(function (_) {
        return _.plan;
      }).map(function (_) {
        return _.plan.id;
      }).value().find(function (_) {
        return _this.stripePlansIds.indexOf(_) >= 0;
      }));
    }, _this.hasCurrentActivePlan = function () {
      return _this.state.currentSubscription && _this.state.currentSubscription.status === 'active';
    }, _this.getCurrentVPNs = function () {
      return !_this.state.currentSubscription ? 0 : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_icepath__["ice"])(_this.state.currentSubscription).get(['subscriptionItems', 'data']).filter(function (_) {
        return _.plan;
      }).map(function (_) {
        return [_.plan.id, _.quantity];
      }).value().filter(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
            planId = _ref6[0];

        return _this.stripePlansIds.indexOf(planId) < 0;
      }).reduce(function (acc, _ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            quantity = _ref8[1];

        return acc + quantity;
      }, 0);
    }, _this.isCurrentPlanSelected = function () {
      return _this.hasCurrentActivePlan() && _this.getCurrentPlanId() === _this.getFinalPlan().id && _this.getCurrentVPNs() === _this.props.form.properties.workstationsVPN;
    }, _this.fetchProrate = function (checkingCoupon, checkedCoupon) {
      var currentPlan = _this.getCurrentPlanId();
      var finalPlan = _this.getFinalPlan(_this.props.form.properties);
      var isPro = getUnvolumedPlanName(finalPlan.name) === 'STORAGE_PRO';
      var stripePlanId = finalPlan.id;
      if (!_this.state.currentSubscription || !_this.state.currentSubscription.id || _this.isCurrentPlanSelected()) {
        _this.props.couponLoading.close();
        return;
      }
      if (!checkingCoupon) {
        _this.setState({ prorate: null, couponError: null });
      }

      var numberOfWorkstationsVPN = isPro ? Number(_this.props.form.properties.workstationsVPN) : 0;
      var coupon = checkingCoupon ? checkedCoupon : _this.state.coupon;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_startlibs__["getFetcher"])('/api/pro-rata', _extends({
        subscriptionId: _this.state.currentSubscription.id,
        stripePlanId: stripePlanId,
        numberOfWorkstationsVPN: numberOfWorkstationsVPN
      }, coupon ? { coupon: coupon } : {})).then(function (prorate) {
        if (checkingCoupon) {
          _this.props.form.connector.setValue('coupon', '');
        }
        var couponError = checkingCoupon && !coupon ? 'invalid.coupon' : coupon && !prorate.discount ? 'invalid.coupon.plan' : prorate.discount ? null : _this.state.couponError;
        _this.props.couponLoading.close();
        _this.setState({
          prorate: prorate,
          coupon: coupon,
          couponDiscount: __WEBPACK_IMPORTED_MODULE_16_icepath__["ice"].get(prorate, 'discount.coupon'),
          couponError: couponError
        });
      }).catch(function () {
        _this.props.couponLoading.close();
        if (checkingCoupon) {
          _this.props.form.connector.setValue('coupon', '');
        }
        _this.setState({ prorate: null });
      });
    }, _this.getFinalPlan = function () {
      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.form.properties;

      var selectedPlan = properties.planType || _this.stripePlans[0];
      var interval = selectedPlan.interval;
      var planType = getUnvolumedPlanName(selectedPlan.name);
      var volume = properties.volume || '40';
      return _this.stripePlans.find(function (_) {
        return _.name === planType + '_' + volume && _.interval === interval;
      }) || selectedPlan;
    }, _this.login = function () {
      var validated = _this.preValidation(_this.props.form.properties, {});
      if (validated.errors) {
        return _this.props.form.connector.setErrors(validated.errors);
      }
      if (_this.props.user.id) {
        _this.props.checkoutStep.open(2);
      } else {
        _this.props.checkoutStep.open(1);
      }
    }, _this.isCurrentPlanMonthly = function () {
      var currentPlanId = _this.getCurrentPlanId();
      if (currentPlanId) {
        return _this.stripePlans.find(function (_) {
          return _.id === currentPlanId && _.interval === 'month';
        });
      } else {
        return false;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(StorageCheckout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var params = new __WEBPACK_IMPORTED_MODULE_9_url_search_params___default.a(this.props.location.search);
      var plan = (params.get('plan') || 'PRO').toUpperCase();
      var interval = 'year';
      this.props.form.connector.setValues(function (chain) {
        return chain.assign({
          'planType': _this2.stripePlans.find(function (_) {
            return _.name.indexOf('_' + plan + '_') > 0 && _.interval === interval;
          }),
          'volume': '40',
          'workstationsVPN': 1
        });
      });
      if (this.props.stripe.customer) {
        this.setStripeCustomer(this.props.stripe);
      } else if (this.props.user.id) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_startlibs__["getFetcher"])('/api/stripe-customer').then(this.setStripeCustomerAfterMount);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps) {
      if (this.state.currentSubscription && this.getFinalPlan(oldProps.form.properties).id !== this.getFinalPlan(this.props.form.properties).id || oldProps.form.properties.workstationsVPN !== this.props.form.properties.workstationsVPN) {
        this.fetchProrate();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (!this.isUpgradePlan && this.props.user.id && !this.state.loadedStripeCustomer) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_components__["Loading"], { absolute: true, size: 40, borderWidth: 6 });
      }

      var _props = this.props,
          form = _props.form,
          checkoutStep = _props.checkoutStep,
          couponLoading = _props.couponLoading,
          user = _props.user;
      var _state = this.state,
          appliedCoupon = _state.coupon,
          couponDiscount = _state.couponDiscount,
          prorate = _state.prorate,
          couponError = _state.couponError;

      var selectedPlanType = form.properties.planType || this.stripePlans[0];
      var planNameWithoutVolume = getUnvolumedPlanName(selectedPlanType.name);
      var isCurrentPlanSelected = this.isCurrentPlanSelected();
      var orderPreview = function orderPreview(changePlanButton, finished) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderPreview, {
          finished: finished,
          form: form,
          vpnCost: _this3.vpnCost[selectedPlanType.interval],
          stripePlans: _this3.stripePlans,
          finalPlan: _this3.getFinalPlan(),
          confirmCoupon: _this3.confirmCoupon,
          appliedCoupon: appliedCoupon,
          couponDiscount: couponDiscount,
          couponLoading: couponLoading,
          prorate: prorate,
          couponError: couponError,
          changePlanButton: changePlanButton
        });
      };

      if (checkoutStep.isOpen === 2) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__CreditCardCheckout__["a" /* CreditCardCheckout */], {
          currentCard: this.state.currentCard,
          orderPreview: orderPreview,
          isStorage: true,
          finalPlan: this.getFinalPlan(),
          prorate: prorate,
          hasCurrentActivePlan: this.hasCurrentActivePlan(),
          coupon: appliedCoupon,
          workstationsVPN: planNameWithoutVolume === 'STORAGE_PRO' ? Number(form.properties.workstationsVPN) : 0,
          form: form,
          isCurrentPlanSelected: isCurrentPlanSelected,
          nextStep: function nextStep() {
            return checkoutStep.open(3);
          },
          prevStep: checkoutStep.close
        });
      }
      if (checkoutStep.isOpen === 3) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CheckoutSuccess__["b" /* StorageCheckoutSuccess */], {
          planName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["c" /* getPlanType */])(getUnvolumedPlanName(this.getFinalPlan().name)),
          orderPreview: orderPreview
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["m" /* CheckoutPage */],
        { className: 'content edit-profile' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-header checkout-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            this.hasCurrentActivePlan() && "Update ",
            'Horos Access subscription'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_components__["Button"].a,
            { small: true, href: 'https://info.horosproject.org/horos-cloud-faq', target: '_blank' },
            'Learn more'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          'Select your Horos Access plan'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlanTypeSelection, {
          isCurrentMonthly: this.isCurrentPlanMonthly(),
          form: form,
          currentPlanId: this.getCurrentPlanId(),
          stripePlans: this.stripePlans
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          StorageVolumeWrapper,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'heading-text' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'Cloud Storage Volume'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'card' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StorageVolumeSelection, {
              form: form,
              stripePlans: this.stripePlans,
              selectedPlanType: selectedPlanType
            })
          )
        ),
        planNameWithoutVolume === 'STORAGE_PRO' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          WorkstationsWrapper,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Number of workstations'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'card' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'First workstation is free and it is ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'b',
                null,
                '$',
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["d" /* toPrice */])(this.vpnCost[selectedPlanType.interval]),
                ' USD per ',
                selectedPlanType.interval
              ),
              ' for each additional workstation accessing Protected Health Information.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NumberOfWorkstationsInput, {
              form: form,
              vpnCost: this.vpnCost[selectedPlanType.interval],
              interval: selectedPlanType.interval
            })
          )
        ),
        isCurrentPlanSelected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["e" /* InfoBox */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'The plan and billing period you selected is already active in your current subscription.'
            ),
            ' If you\'d like to change your plan, select another option above and click \'Update subscription\'. For changing your credit card details only, click below.'
          )
        ),
        orderPreview(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'checkbox-list' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["SimpleCheckbox"], {
            form: form,
            label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'license-terms-agreement' },
              'By continuing, you confirm you have read and accept the Horos Cloud ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'link nowrap', href: '/license', target: '_blank' },
                'License Terms'
              ),
              '.'
            ),
            path: 'acceptedTerms',
            tabIndex: 1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["Errors"], { form: form }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-footer' },
          user.id && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_components__["Button"],
            { onClick: function onClick() {
                return window.history.back();
              } },
            'Cancel'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_components__["Button"],
            { highlight: true, disabled: isCurrentPlanSelected, onClick: this.login },
            'Next'
          ),
          checkoutStep.isOpen === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CheckoutSignupDialog__["a" /* CheckoutSignupDialog */], {
            closeDialog: checkoutStep.close,
            form: form,
            setStripCustomer: this.setStripeCustomer,
            nextStep: function nextStep() {
              return checkoutStep.open(2);
            }
          })
        )
      );
    }
  }]);

  return StorageCheckout;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class) || _class) || _class) || _class);

var PlanTypeSelection = function PlanTypeSelection(_ref9) {
  var form = _ref9.form,
      stripePlans = _ref9.stripePlans,
      currentPlanId = _ref9.currentPlanId,
      isCurrentMonthly = _ref9.isCurrentMonthly;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["n" /* SubscriptionPlanList */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubscriptionPlansCard, {
      planType: 'STORAGE_STANDARD',
      form: form,
      currentPlanId: currentPlanId,
      plans: stripePlans.filter(function (_) {
        return _.name === 'STORAGE_STANDARD_40' && (isCurrentMonthly || _.interval !== 'month');
      })
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubscriptionPlansCard, {
      planType: 'STORAGE_PRO',
      form: form,
      currentPlanId: currentPlanId,
      plans: stripePlans.filter(function (_) {
        return _.name === 'STORAGE_PRO_40' && (isCurrentMonthly || _.interval !== 'month');
      })
    })
  );
};

var StorageVolumeSelection = function StorageVolumeSelection(_ref10) {
  var form = _ref10.form,
      stripePlans = _ref10.stripePlans,
      selectedPlanType = _ref10.selectedPlanType;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Select your ',
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["f" /* stripeIntervalToInterval */])(selectedPlanType.interval),
      ' storage package:'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'radio-list' },
      stripePlans.filter(function (_) {
        return _.name.indexOf(getUnvolumedPlanName(selectedPlanType.name)) === 0 && _.interval === selectedPlanType.interval;
      }).sort(function (_) {
        return _.amount;
      }).map(function (plan) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["SimpleRadiobox"], {
          form: form,
          key: plan.name,
          path: 'volume',
          fieldValue: getPlanVolume(plan.name),
          label: getPlanVolume(plan.name) + ' studies/month for $' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["d" /* toPrice */])(plan.amount) + ' USD/' + plan.interval
        });
      })
    )
  );
};

var calculateVPN = function calculateVPN(cost, numberOfStations) {
  return cost * (numberOfStations - 1);
};

var NumberOfWorkstationsInput = function NumberOfWorkstationsInput(_ref11) {
  var form = _ref11.form,
      vpnCost = _ref11.vpnCost,
      interval = _ref11.interval;

  var vpnTotalCost = calculateVPN(vpnCost, form.properties.workstationsVPN);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      TextInputWithTextBox,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["TextInput"], {
        form: form,
        path: 'workstationsVPN',
        constraint: '#####',
        defaultValue: 1,
        maxLength: 5,
        textBoxAfter: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'increment-buttons' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                onClick: function onClick() {
                  return form.connector.setValues(function (chain) {
                    return chain.update('workstationsVPN', function (v) {
                      return Math.max(1, v - 1);
                    });
                  });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_components__["Icon"], {
                icon: 'minus' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                onClick: function onClick() {
                  return form.connector.setValues(function (chain) {
                    return chain.update('workstationsVPN', function (v) {
                      return Math.min(99999, v + 1);
                    });
                  });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_components__["Icon"], {
                icon: 'plus' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            vpnTotalCost === 0 ? 'Free' : '$' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["d" /* toPrice */])(vpnTotalCost) + ' USD / ' + interval
          )
        )
      })
    )
  );
};

var getNextCharge = function getNextCharge(interval, nextPaymentAttempt, saldo, cost) {
  var intervals = saldo <= 0 ? -saldo / cost : 0;
  var nextChargeDate = nextPaymentAttempt ? new Date(nextPaymentAttempt * 1000) : new Date();
  if (intervals > 0) {
    if (interval === 'yearly') {
      nextChargeDate.setFullYear(nextChargeDate.getFullYear() + Math.ceil(intervals));
    } else {
      nextChargeDate.setMonth(nextChargeDate.getMonth() + Math.ceil(intervals));
    }
  }
  var nextCharge = intervals === 0 ? saldo : cost + saldo % cost;
  return [nextCharge, nextChargeDate];
};

var OrderPreview = function OrderPreview(_ref12) {
  var form = _ref12.form,
      stripePlans = _ref12.stripePlans,
      changePlanButton = _ref12.changePlanButton,
      couponDiscount = _ref12.couponDiscount,
      vpnCost = _ref12.vpnCost,
      finalPlan = _ref12.finalPlan,
      confirmCoupon = _ref12.confirmCoupon,
      appliedCoupon = _ref12.appliedCoupon,
      couponLoading = _ref12.couponLoading,
      prorate = _ref12.prorate,
      couponError = _ref12.couponError,
      finished = _ref12.finished;

  var interval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["f" /* stripeIntervalToInterval */])(finalPlan.interval);
  var planType = getUnvolumedPlanName(finalPlan.name);
  var planTitle = STORAGE_PLAN_TYPE_HEADER[planType];
  var volume = form.properties.volume;
  var workstationsVPN = form.properties.workstationsVPN;
  var vpnTotalCost = planType === 'STORAGE_PRO' ? calculateVPN(vpnCost, workstationsVPN) : 0;
  var totalCost = vpnTotalCost + finalPlan.amount;
  var discount = couponDiscount ? couponDiscount.percentOff ? totalCost * couponDiscount.percentOff / 100 : couponDiscount.amountOff || 0 : 0;
  var hasProrateCredit = prorate && prorate.lines && prorate.lines.data && prorate.lines.data && prorate.lines.data.filter(function (_) {
    return _.amount < 0;
  });
  var startingBalance = prorate && prorate.startingBalance || 0;
  var prorateCredit = hasProrateCredit ? -hasProrateCredit.reduce(function (sum, _ref13) {
    var amount = _ref13.amount;
    return sum + Number(amount);
  }, 0) - startingBalance : 0;
  var discountedPrice = totalCost - discount - prorateCredit;

  var _getNextCharge = getNextCharge(interval, prorate && prorate.nextPaymentAttempt, discountedPrice, totalCost),
      _getNextCharge2 = _slicedToArray(_getNextCharge, 2),
      nextCharge = _getNextCharge2[0],
      nextPaymentDate = _getNextCharge2[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["o" /* OrderSummaryWrapper */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'heading-text' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        null,
        'Your Order ',
        changePlanButton
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'card order' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'order-table' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'b',
              null,
              planTitle,
              ' Plan'
            ),
            ' (',
            interval,
            ')'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            volume,
            ' studies/month storage:'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'amount' },
            '$',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["d" /* toPrice */])(finalPlan.amount),
            ' USD'
          )
        ),
        planType === 'STORAGE_PRO' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            workstationsVPN,
            ' workstations access:'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'amount' },
            '$',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["d" /* toPrice */])(vpnTotalCost),
            ' USD'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'total' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'b',
              null,
              'Total'
            ),
            ' (',
            interval,
            ')'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'amount' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'b',
              null,
              '$',
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["d" /* toPrice */])(totalCost),
              ' USD'
            )
          )
        ),
        discount > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Promo code discount (',
            couponDiscount.percentOff ? couponDiscount.percentOff + '%' : '$' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["d" /* toPrice */])(couponDiscount.amountOf) + ' USD',
            '):'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'discount amount' },
            '-$',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["d" /* toPrice */])(discount),
            ' USD'
          )
        ),
        prorateCredit > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Credit from current subscription:'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'discount amount' },
            '-$',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["d" /* toPrice */])(prorateCredit),
            ' USD'
          )
        ),
        discountedPrice !== totalCost && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'b',
              null,
              'Your first payment (',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_report_components_src_components_timer__["a" /* Timer */], { language: 'en', dateFormat: 'L dd, yyyy', noHours: true, time: nextPaymentDate }),
              ')'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'amount' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'b',
              null,
              '$',
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["d" /* toPrice */])(nextCharge),
              ' USD'
            )
          )
        )
      ),
      !finished && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["p" /* PromoCodeContainer */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: confirmCoupon },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["Field"],
            { label: 'Promo Code' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["q" /* TextInputWithButton */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'input-container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["TextInput"], { form: form, path: 'coupon', placeholder: 'Insert your promo code' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_components__["Button"],
                { small: true, isLoading: couponLoading.isOpen, type: 'submit' },
                'Apply'
              )
            )
          )
        ),
        couponDiscount && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["r" /* CouponFeedback */],
          { success: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'applied-coupon' },
            appliedCoupon
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'b',
            null,
            'Coupon successfully applied.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            couponDiscount.percentOff ? couponDiscount.percentOff + '% off on first payment.' : '$' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_index__["d" /* toPrice */])(couponDiscount.amountOf) + ' USD off.'
          )
        ),
        couponError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["r" /* CouponFeedback */],
          { error: true },
          appliedCoupon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'applied-coupon' },
            appliedCoupon
          ),
          couponError === 'invalid.coupon' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            'Sorry, the coupon you entered is not valid.'
          ),
          couponError === 'invalid.coupon.plan' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            'This coupon is valid only for annual plan subscriptions and upgrades.'
          )
        )
      ),
      finished && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["p" /* PromoCodeContainer */],
        null,
        (__WEBPACK_IMPORTED_MODULE_5__user_Billing__["f" /* STORAGE_PLAN_TYPE_DETAILS */][planType] || function () {
          return 0;
        })()
      )
    )
  );
};

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarUploadForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icepath__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reselect__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var AvatarUploadForm = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["withFormImageInput"])(function preValidate(file) {
  if (file.size > 4194304) {
    return ['Your file needs to be smaller than 4mb.'];
  }
  if (['image/gif', 'image/png', 'image/jpeg', 'image/jpg'].indexOf(file.type.toLowerCase()) < 0) {
    return ['Invalid file format. Please select a .JPG or .PNG file.'];
  }
}, function uploadFetcher(file, props) {
  var formData = new FormData();
  formData.append('file', file);
  return props.uploadFetcher(formData, '').then(function (_ref) {
    var resourceUID = _ref.resourceUID;
    return { image: resourceUID, uploadStatus: 'upload-finished' };
  });
}), _dec(_class = function (_React$Component) {
  _inherits(AvatarUploadForm, _React$Component);

  function AvatarUploadForm() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, AvatarUploadForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = AvatarUploadForm.__proto__ || Object.getPrototypeOf(AvatarUploadForm)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {}, _this.handleDrop = function (e) {
      var handleFile = _this.props.handleFile;

      e.preventDefault();
      var files = (e.nativeEvent.dataTransfer || e.nativeEvent.target).files;
      if (files.length > 0) {
        var file = files[0];
        handleFile(file);
      }
      _this.setState({ isDragging: false });
    }, _this.removePicture = function () {
      return _this.props.form.connector.setValue(_this.props.path, _this.props.defaultPicture);
    }, _this.memoizedBackground = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_reselect__["defaultMemoize"])(function (i) {
      return typeof i === "string" ? 'url("' + _this.props.getResource(i) + '")' : 'url("' + URL.createObjectURL(i) + '")';
    }), _this.getImage = function () {
      return __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].get(_this.props.form.properties, _this.props.path) || _this.props.defaultPicture;
    }, _this.getBackground = function () {
      return _this.getImage() && !_this.state.isDragging ? { backgroundImage: _this.memoizedBackground(_this.getImage()) } : {};
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AvatarUploadForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          form = _props.form,
          path = _props.path;
      // const {isDragging} = this.state

      var uploadStatus = __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].get(form.meta, __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].toPath(path).concat('uploadStatus'));
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { className: 'user-avatar-form ' + uploadStatus + ' box' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'img-wrapper user-avatar', style: this.getBackground() },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { className: 'img-upload' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["FileInput"], { onChange: this.handleDrop, tabIndex: -1 })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'actions-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'hidden', value: 'avatar', name: '_imageName', tabIndex: -1 }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'button highlight' },
            'Upload new',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["FileInput"], { onChange: this.handleDrop, tabIndex: -1 })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
            { onClick: this.removePicture, tabIndex: -1 },
            'Remove picture'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'loader-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'uploading-image-loader' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'loader' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'loader-text' },
              'Uploading'
            )
          )
        )
      );
    }
  }]);

  return AvatarUploadForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class);

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfirmLeaveDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ConfirmLeaveDialog = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withDialogError"])(_class = function (_React$Component) {
  _inherits(ConfirmLeaveDialog, _React$Component);

  function ConfirmLeaveDialog() {
    _classCallCheck(this, ConfirmLeaveDialog);

    return _possibleConstructorReturn(this, (ConfirmLeaveDialog.__proto__ || Object.getPrototypeOf(ConfirmLeaveDialog)).apply(this, arguments));
  }

  _createClass(ConfirmLeaveDialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          closeDialog = _props.closeDialog,
          save = _props.save,
          discard = _props.discard,
          isLoading = _props.isLoading;

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Dialog"],
        {
          closeDialog: closeDialog,
          onConfirm: save,
          className: 'confirm-close-dialog',
          title: 'Your changes won\'t be saved'
        },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Dialog"].Content,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
              'p',
              null,
              'The changes made in this screen were not saved. Would you like to quit anyway?'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Dialog"].Footer,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
            { onClick: closeDialog },
            'Cancel'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
            { onClick: save, isLoading: isLoading, success: isLoading, hover: 'success' },
            'Save changes'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
            { type: 'submit', onClick: discard, alert: true },
            'Discard changes'
          )
        )
      );
    }
  }]);

  return ConfirmLeaveDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])) || _class;

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dashboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icepath__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_report_components__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__report_ReportViewerHeader__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ReportInfoCard__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__public_FirstSteps__ = __webpack_require__(76);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class, _dec4, _dec5, _dec6, _class3;

var _templateObject = _taggedTemplateLiteral(['\n  margin: 3rem auto 0;\n'], ['\n  margin: 3rem auto 0;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: fixed;\n  bottom: 2rem;\n  right: 2rem;\n'], ['\n  position: fixed;\n  bottom: 2rem;\n  right: 2rem;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', ' ~ & {\n    margin-left: .5rem;\n  }\n  width: 2rem;\n  padding: 0;\n  span {\n    transform: translate(50%,-50%);\n    right: 50%;\n  }\n'], ['\n  ', ' ~ & {\n    margin-left: .5rem;\n  }\n  width: 2rem;\n  padding: 0;\n  span {\n    transform: translate(50%,-50%);\n    right: 50%;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  .card {\n    margin-bottom: 1rem;\n  }\n'], ['\n  .card {\n    margin-bottom: 1rem;\n  }\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }


















var SEARCH_TIMEOUT = 300;
var LOAD_MORE_WHEN_PX_SCROLL_TO_BOTTOM = 200;
var EMPTY_REPORT_RECIPIENTS = { registeredUsers: [], suggestedUsers: []
  // const DEV_TEST_ALWAYS_RELOAD = false//process.env.NODE_ENV === 'development'

};var ReportsLoader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Loading"])(_templateObject);

var DevTools = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject2);

var DropdownButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"])(_templateObject3, __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"]);

var DeleteReportDialog = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Dialog"])(_templateObject4);

var reportsQueryFilter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_reselect__["defaultMemoize"])(function (reports, query) {
  return query ? reports.filter(function (r) {
    return r.patientName.toLowerCase().indexOf(query.toLowerCase()) >= 0 || r.studydesc.toLowerCase().indexOf(query.toLowerCase()) >= 0;
  }) : reports;
});

var compare = function compare(a, b) {
  return a === b ? 0 : a < b ? -1 : 1;
};

var defaultSort = function defaultSort(selector) {
  return function (a, b) {
    return compare(selector(a), selector(b));
  };
};

var reportsSorting = function reportsSorting(sortingType) {
  return sortingType === 'patientName' ? defaultSort(function (e) {
    return e.patientName;
  }) : defaultSort(function (e) {
    return -e.lastSaved;
  });
};

var reportSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_6__selectors__["a" /* getReports */], function (_, props) {
  return props;
}, function (reports, _ref) {
  var query = _ref.query,
      sorting = _ref.sorting;
  return __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].sort(reportsQueryFilter(reports, query.isOpen), reportsSorting(sorting.isOpen));
});

var sortBooleanToQueryString = function sortBooleanToQueryString(sort) {
  return sort ? 'patient_name,asc' : 'last_Saved,desc';
};

var Dashboard = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__["withToggles"])('query', 'sorting', 'isLoading', 'searching'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__["withPopupToggles"])('sortingPopup'), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__["fetchConnect"])(function (state, props) {
  return {
    reportsMeta: state.reports,
    user: state.user,
    reports: reportSelector(state, props)
  };
}, { connectFetcher: __WEBPACK_IMPORTED_MODULE_8__reducers__["f" /* loadReports */], loadReports: __WEBPACK_IMPORTED_MODULE_8__reducers__["f" /* loadReports */] }), _dec(_class = _dec2(_class = _dec3(_class = function (_React$PureComponent) {
  _inherits(Dashboard, _React$PureComponent);

  function Dashboard() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Dashboard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { isMobile: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["isSmallDevice"])(470) }, _this.setQuery = function (e) {
      _this.props.query.open(e.target.value);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["smoothScroll"])(0, 500);
    }, _this.addReportDev = function () {
      return "production" === 'development' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        DevTools,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
          { onClick: function onClick() {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs__["postFetcher"])('/api/otp-tokens', {
                'dicomInfo': { patientname: _this.props.user.firstName, studydate: '20180312', studydesc: 'Dev Study' },
                'recordSetId': 'test' + Date.now()
              }).then(function (_ref3) {
                var otpToken = _ref3.otpToken;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs__["getFetcher"])('/api/load-report?otpToken=' + otpToken);
              }).then(console.log).catch(console.log);
            } },
          '[Dev] New Report'
        )
      );
    }, _this.resizeEvent = function () {
      if (_this.state.isMobile !== __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["isSmallDevice"])(470)) {
        _this.setState({ isMobile: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["isSmallDevice"])(470) });
      }
    }, _this.loaderPromise = false, _this.queryThrotle = -1, _this.loadMoreReports = function (resetPagesOrEvent) {
      var resetPages = resetPagesOrEvent === true;
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          searching = _this$props.searching,
          loadReports = _this$props.loadReports,
          query = _this$props.query,
          sorting = _this$props.sorting,
          _this$props$reportsMe = _this$props.reportsMeta,
          finished = _this$props$reportsMe.finished,
          page = _this$props$reportsMe.page,
          total = _this$props$reportsMe.total,
          usedQuery = _this$props$reportsMe.query;

      _this.loaderPromise = resetPages ? null : _this.loaderPromise;
      if (finished && !resetPages || _this.loaderPromise || total === 0 && !usedQuery) {
        return;
      }
      if (window.innerHeight + window.scrollY + LOAD_MORE_WHEN_PX_SCROLL_TO_BOTTOM < document.body.scrollHeight) return;
      var sort = sortBooleanToQueryString(sorting.isOpen);
      isLoading.open();
      var nextPage = resetPages ? 0 : page + 1;
      var thisLoader = _this.loaderPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs__["getFetcher"])('/api/reports', {
        page: nextPage,
        size: 40,
        query: query.isOpen || undefined,
        sort: sort
      }).then(function (result) {
        if (thisLoader === _this.loaderPromise) {
          isLoading.close();
          searching.close();
          _this.loaderPromise = false;
          loadReports(result, { _dontFetch: true, _payload: { page: nextPage, query: query.isOpen || undefined, sort: sort } });
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dashboard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs__["getFetcher"])("/api/pdfrenderer").then(function (pdfRenderer) {
        _this2.setState({ pdfRenderer: pdfRenderer });
        _this2.loadMoreReports();
      });
      window.addEventListener('resize', this.resizeEvent);
      window.addEventListener('scroll', this.loadMoreReports);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeEvent);
      window.removeEventListener('scroll', this.loadMoreReports);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (this.props.sorting.isOpen !== prevProps.sorting.isOpen) {
        // if (DEV_TEST_ALWAYS_RELOAD || !this.props.reportsMeta.finished) {
        this.props.loadReports({ content: [], first: true }, { _dontFetch: true });
        // }
        this.loadMoreReports(true);
      } else if (this.props.query.isOpen !== prevProps.query.isOpen) {
        clearTimeout(this.queryThrotle);
        this.props.searching.open();
        this.queryThrotle = setTimeout(function () {
          return _this3.loadMoreReports(true);
        }, SEARCH_TIMEOUT);
      } else {
        this.loadMoreReports();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          reportsMeta = _props.reportsMeta,
          isLoading = _props.isLoading,
          reports = _props.reports,
          query = _props.query,
          sorting = _props.sorting,
          user = _props.user,
          searching = _props.searching,
          sortingPopup = _props.sortingPopup;
      var _state = this.state,
          isMobile = _state.isMobile,
          pdfRenderer = _state.pdfRenderer;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content dashboard' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'header-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header heading' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              query.isOpen ? searching.isOpen ? 'Searching...' : 'Search results' : 'Your reports'
            ),
            !(isLoading.isOpen && !reports.length || searching.isOpen) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'found-results' },
              reportsMeta.total,
              ' report',
              reports.length > 1 && "s",
              ' found'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: "search-with-icon" + (searching.isOpen ? " search-loading" : "") },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: 'Search', value: query.isOpen || '', onChange: this.setQuery }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon loader' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
                { outline: true, withDropdown: !isMobile, onlyIcon: isMobile, icon: isMobile ? 'sort' : undefined,
                  onClick: sortingPopup.toggle },
                !isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                  null,
                  'Sort by ',
                  sorting.isOpen ? 'patient name' : 'date modified'
                ),
                sortingPopup.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["ContextMenu"],
                  { fixed: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Li"], { icon: !sorting.isOpen ? 'check' : undefined, onClick: sorting.close, label: 'Date modified' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Li"], { icon: sorting.isOpen === 'patientName' ? 'check' : undefined,
                    onClick: function onClick() {
                      return sorting.open('patientName');
                    }, label: 'Patient name' })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'card-list two-columns' },
          reports.map(function (report) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReportCard, { key: report.uid, user: user, pdfRenderer: pdfRenderer, report: report });
          })
        ),
        isLoading.isOpen && !searching.isOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReportsLoader, { size: 36, borderWidth: 5 }) : reportsMeta.total === 0 ? reportsMeta.query ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'no-results-message' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            'No reports matched your search query.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Try searching for a different term or return to home and ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { onClick: query.close },
              'view all reports.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
            { onClick: query.close },
            'View all reports'
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14__public_FirstSteps__["b" /* FirstStepsGuide */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'guide-content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              null,
              'To create a report or share a study please launch Horos on macOS'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"].a,
              { highlight: true, href: 'horos://', className: 'horos-download-button' },
              'Launch Horos'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'download-message' },
              'Do not have Horos App installed yet? ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'link nowrap', target: '_blank', href: 'https://horosproject.org/download-horos/' },
                'Download here'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'screenshot-image', alt: 'instructions', src: '/public/firststeps-screenshot.png' })
          )
        ) : null,
        this.addReportDev()
      );
    }
  }]);

  return Dashboard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class) || _class) || _class);

var ReportCard = (_dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__["withToggles"])('deleteReportDialog', 'sendViaEmail'), _dec5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__["withPopupToggles"])('reportContextMenu'), _dec6 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react_redux__["connect"])(function (state) {
  return { deleteIsLoading: state.appUI.loadings[__WEBPACK_IMPORTED_MODULE_8__reducers__["g" /* deleteReport */]] };
}, { deleteReport: __WEBPACK_IMPORTED_MODULE_8__reducers__["g" /* deleteReport */], setNotifications: __WEBPACK_IMPORTED_MODULE_8__reducers__["c" /* setNotifications */] }), _dec4(_class3 = _dec5(_class3 = _dec6(_class3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__["withRouteTo"])(_class3 = function (_React$PureComponent2) {
  _inherits(ReportCard, _React$PureComponent2);

  function ReportCard() {
    var _ref4;

    var _temp2, _this4, _ret2;

    _classCallCheck(this, ReportCard);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, (_ref4 = ReportCard.__proto__ || Object.getPrototypeOf(ReportCard)).call.apply(_ref4, [this].concat(args))), _this4), _this4.savePdfUrl = function (save) {
      var queryString = new URLSearchParams();
      queryString.append("save", save);
      queryString.append("endpoint", _this4.props.pdfRenderer.reportLoaderEnpoint);
      var url = _this4.props.pdfRenderer.reportRendererEndpoint + _this4.props.report.uid + "?" + queryString.toString();
      window.open(url, "_blank");
    }, _this4.deleteReport = function () {
      _this4.props.deleteReport(_this4.props.report.uid).then(function () {
        _this4.props.setNotifications('Report deleted successfully.');
      });
    }, _this4.openJustSent = function () {
      _this4.props.setNotifications('Report successfully sent via e-mail.');
    }, _temp2), _possibleConstructorReturn(_this4, _ret2);
  }

  _createClass(ReportCard, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props2 = this.props,
          report = _props2.report,
          deleteIsLoading = _props2.deleteIsLoading,
          routeTo = _props2.routeTo,
          user = _props2.user,
          sendViaEmail = _props2.sendViaEmail,
          deleteReportDialog = _props2.deleteReportDialog,
          reportContextMenu = _props2.reportContextMenu;

      var lastSaved = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_report_components__["a" /* formatDate */])(new Date(report.lastSaved), __WEBPACK_IMPORTED_MODULE_10_report_components__["b" /* en_US */], 'L dd, yyyy - hh:mm');
      var studyToDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_report_components__["c" /* dicomDateToDate */])(report.studydate);
      var studydate = isNaN(studyToDate.getTime()) ? report.studydate : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_report_components__["a" /* formatDate */])(studyToDate, __WEBPACK_IMPORTED_MODULE_10_report_components__["b" /* en_US */], 'L dd, yyyy');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { href: '/report/' + report.uid, className: 'card with-icon clickable',
          onClick: function onClick(e) {
            return e.ctrlKey || e.metaKey ? undefined : e.preventDefault() || routeTo('/report/' + report.uid);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'card-content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'buttons-container', onClick: function onClick(e) {
                e.stopPropagation();e.preventDefault();reportContextMenu.close();
              } },
            report.finished ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
              { small: true, icon: 'view', onClick: function onClick(e) {
                  return e.ctrlKey || e.metaKey ? undefined : e.preventDefault() || routeTo('/report/' + report.uid);
                } },
              'View'
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
              { small: true, icon: 'edit', onClick: function onClick(e) {
                  return e.ctrlKey || e.metaKey ? undefined : e.preventDefault() || routeTo('/report/' + report.uid);
                } },
              'Edit'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              DropdownButton,
              {
                small: true,
                withDropdown: true,
                onClick: function onClick(e) {
                  e.stopPropagation();e.preventDefault();reportContextMenu.toggle();
                }
              },
              reportContextMenu.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["ContextMenu"],
                null,
                report.finished && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Li"], { key: 'email', onClick: sendViaEmail.open, label: 'Send via email', icon: 'email' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Li"], { key: 'download', onClick: function onClick() {
                    return _this5.savePdfUrl(true);
                  }, target: '_blank', label: 'Download PDF', icon: 'download' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Li"], { key: 'print', onClick: function onClick() {
                    return _this5.savePdfUrl(false);
                  }, label: 'Print', icon: 'print' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["ListSeparator"], { key: 'separator' })],
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Li"], { onClick: deleteReportDialog.open, label: 'Delete report', icon: 'delete' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'card-icon' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Icon"], { icon: report.finished ? 'checked-report' : 'report' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'card-title' },
            report.patientName
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'card-detail' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'b',
              null,
              'Study: '
            ),
            report.studydesc,
            ' (',
            studydate,
            ')'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'card-detail' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'b',
              null,
              'Referred by: '
            ),
            report.refphysician ? report.refphysician : "Unknown"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'card-footer' },
          (report.finished ? 'Finished on ' : 'Last draft saved on ') + lastSaved
        ),
        deleteReportDialog.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          DeleteReportDialog,
          {
            closeDialog: deleteReportDialog.close,
            title: 'Confirm report deletion'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Dialog"].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'You are about to delete the following report and all its content:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ReportInfoCard__["a" /* ReportInfoCard */], { report: report }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'Are you sure you want to delete it?'
              ),
              ' Once confirmed this cannot be undone.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Dialog"].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
              { onClick: deleteReportDialog.close },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
              { isLoading: deleteIsLoading, alert: true, onClick: this.deleteReport },
              'Confirm deletion'
            )
          )
        ),
        sendViaEmail.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_report_components__["d" /* SendEmailDialog */], {
          reportRecipients: EMPTY_REPORT_RECIPIENTS,
          closeDialog: sendViaEmail.close,
          confirmSent: this.openJustSent,
          userEmail: user.email,
          attachedReport: true,
          reportInfoCard: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ReportInfoCard__["a" /* ReportInfoCard */], { report: report }),
          sendEmailFetcher: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__report_ReportViewerHeader__["a" /* sendEmailFetcher */])(report.uid)
        })
      );
    }
  }]);

  return ReportCard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class3) || _class3) || _class3) || _class3);

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteAccountFinished; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExpiredShare__ = __webpack_require__(34);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DeleteAccountFinished = function (_React$PureComponent) {
  _inherits(DeleteAccountFinished, _React$PureComponent);

  function DeleteAccountFinished() {
    _classCallCheck(this, DeleteAccountFinished);

    return _possibleConstructorReturn(this, (DeleteAccountFinished.__proto__ || Object.getPrototypeOf(DeleteAccountFinished)).apply(this, arguments));
  }

  _createClass(DeleteAccountFinished, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__ExpiredShare__["b" /* ExpiredPageComponent */],
        { centered: true, grayNavbar: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'navbar' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Link"],
            { skipTo: '/', className: 'logo' },
            'Horos Cloud'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__ExpiredShare__["c" /* ContentBox */],
          { topImage: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: '/public/account-deleted.png', alt: 'Expired' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            'Account deleted successfully.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Thank you for using Horos Cloud'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'useful-links' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            'Here are some useful links'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'link', href: 'https://horosproject.org' },
            'Horos Project website'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'link', href: 'https://horosproject.org/download-horos/' },
            'Download Horos'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Link"],
            { className: 'link', skipTo: '/' },
            'Horos Cloud home'
          )
        )
      );
    }
  }]);

  return DeleteAccountFinished;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpiredDeletionLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExpiredShare__ = __webpack_require__(34);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ExpiredDeletionLink = function (_React$PureComponent) {
  _inherits(ExpiredDeletionLink, _React$PureComponent);

  function ExpiredDeletionLink() {
    _classCallCheck(this, ExpiredDeletionLink);

    return _possibleConstructorReturn(this, (ExpiredDeletionLink.__proto__ || Object.getPrototypeOf(ExpiredDeletionLink)).apply(this, arguments));
  }

  _createClass(ExpiredDeletionLink, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__ExpiredShare__["b" /* ExpiredPageComponent */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'navbar' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Link"],
            { to: '/', className: 'logo' },
            'Horos Cloud'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__ExpiredShare__["c" /* ContentBox */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: '/public/expired-icon.png', alt: 'Expired' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            'This link has expired.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'The deletion link you are accessing has expired and you are no longer able to proceed. Deletion links expire after one hour for security reasons.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'In case you still need to delete your data, please access your Horos Cloud account and request for the data deletion one more time.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"].Link,
            { highlight: true, skipTo: '/signIn' },
            'Access Horos Cloud'
          )
        )
      );
    }
  }]);

  return ExpiredDeletionLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageNotFound; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExpiredShare__ = __webpack_require__(34);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  ', ' {\n    padding: 3.5rem 6rem;\n    h2 {\n      margin-bottom: 0;\n      padding-bottom: 0;\n    }\n    .error-code {\n      font-size: 11px;\n      color: ', ';\n      margin-bottom: 1rem;\n    }\n  }\n  @media (max-width: 440px) {\n    ', ' {\n      padding: 2rem 3rem;\n    }\n  }\n'], ['\n  ', ' {\n    padding: 3.5rem 6rem;\n    h2 {\n      margin-bottom: 0;\n      padding-bottom: 0;\n    }\n    .error-code {\n      font-size: 11px;\n      color: ', ';\n      margin-bottom: 1rem;\n    }\n  }\n  @media (max-width: 440px) {\n    ', ' {\n      padding: 2rem 3rem;\n    }\n  }\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }







var NotFoundPage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4__ExpiredShare__["b" /* ExpiredPageComponent */])(_templateObject, __WEBPACK_IMPORTED_MODULE_4__ExpiredShare__["c" /* ContentBox */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib__["getColor"])('gray180'), __WEBPACK_IMPORTED_MODULE_4__ExpiredShare__["c" /* ContentBox */]);

var PageNotFound = function (_React$PureComponent) {
  _inherits(PageNotFound, _React$PureComponent);

  function PageNotFound() {
    _classCallCheck(this, PageNotFound);

    return _possibleConstructorReturn(this, (PageNotFound.__proto__ || Object.getPrototypeOf(PageNotFound)).apply(this, arguments));
  }

  _createClass(PageNotFound, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        NotFoundPage,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'navbar' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Link"],
            { to: '/', className: 'logo' },
            'Horos Cloud'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__ExpiredShare__["c" /* ContentBox */],
          { topImage: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: '/public/404-icon.png', alt: 'Expired' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            'Oops! Something is not right...'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'error-code' },
            'Error status: 404 - Not found'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'We can\u2019t find the page you\u2019re looking for, it is possible that it does not exist or has been removed.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Consider double-checking that the link is correct, or follow one of the links below to get back on track.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"].Link,
            { highlight: true, skipTo: '/' },
            'Go to Horos Cloud home'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'useful-links' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            'Here are some other useful links'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'link', href: 'https://horosproject.org' },
            'Horos Project website'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'link', href: 'https://horosproject.org/download-horos/' },
            'Download Horos'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Link"],
            { className: 'link', skipTo: '/signUp' },
            'Sign up to Horos Cloud'
          )
        )
      );
    }
  }]);

  return PageNotFound;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Terms; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  .print-license-terms {\n      background-color: #fff;\n      color: @gray90;\n      .header-wrapper {\n          text-align: center;\n          margin-bottom: 1rem;\n          img {\n              margin: 0 auto;\n              width: 80px;\n              margin-bottom: 2rem;\n          }\n      }\n  }\n\n  @media screen {\n      body {\n          background-color: @gray210;\n      }\n      .print-license-terms {\n          position: relative;\n          width: 800px;\n          padding: 4rem;\n          margin: 2rem auto;\n          border-radius: 2px;\n          border: 1px solid @gray180;\n          button, .button {\n              position: absolute;\n              &.highlight {\n                  right: 4rem\n              }\n              &.return-home {\n                  padding-left: 2.2rem;\n                  .icon {\n                      font-size: 18px;\n                      width: 1.5rem;\n                  }\n              }\n          }\n      }\n  }\n\n  @media print {\n      body {\n          background-color: #fff;\n          padding: 0;\n          margin: 0;\n      }\n      .print-license-terms {\n          -webkit-print-color-adjust: exact;\n          padding: 0;\n          margin: 0;\n          button, .button {\n              display: none;\n          }\n      }\n  }\n\n'], ['\n  .print-license-terms {\n      background-color: #fff;\n      color: @gray90;\n      .header-wrapper {\n          text-align: center;\n          margin-bottom: 1rem;\n          img {\n              margin: 0 auto;\n              width: 80px;\n              margin-bottom: 2rem;\n          }\n      }\n  }\n\n  @media screen {\n      body {\n          background-color: @gray210;\n      }\n      .print-license-terms {\n          position: relative;\n          width: 800px;\n          padding: 4rem;\n          margin: 2rem auto;\n          border-radius: 2px;\n          border: 1px solid @gray180;\n          button, .button {\n              position: absolute;\n              &.highlight {\n                  right: 4rem\n              }\n              &.return-home {\n                  padding-left: 2.2rem;\n                  .icon {\n                      font-size: 18px;\n                      width: 1.5rem;\n                  }\n              }\n          }\n      }\n  }\n\n  @media print {\n      body {\n          background-color: #fff;\n          padding: 0;\n          margin: 0;\n      }\n      .print-license-terms {\n          -webkit-print-color-adjust: exact;\n          padding: 0;\n          margin: 0;\n          button, .button {\n              display: none;\n          }\n      }\n  }\n\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }




var LicensePrint = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);

var Terms = function (_React$PureComponent) {
    _inherits(Terms, _React$PureComponent);

    function Terms() {
        _classCallCheck(this, Terms);

        return _possibleConstructorReturn(this, (Terms.__proto__ || Object.getPrototypeOf(Terms)).apply(this, arguments));
    }

    _createClass(Terms, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                LicensePrint,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'style',
                    { type: 'text/css' },
                    "@page { margin: 20mm; }"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'print-license-terms' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { className: 'button return-home with-icon', href: '/' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon icon-arrow-left' }),
                        ' Horos Cloud'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'highlight with-icon', onClick: window.print },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon icon-print' }),
                        ' Print'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'header-wrapper' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'site-logo' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: 'public/favicon.png' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            'Horos Cloud license terms'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'license-terms' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            'These Terms of Service (the "Agreement") govern your use of this service (the "Services") from Nimble Co, LLC d/b/a Purview (referred to herein as "Purview", "we", "us", and "our"). BY ACCEPTING THIS AGREEMENT, EITHER BY CLICKING A BOX INDICATING YOUR ACCEPTANCE OR USING THIS PRODUCT, YOU AGREE TO BE LEGALLY BOUND BY THE TERMS AND CONDITIONS OF THIS AGREEMENT. IF YOU ARE ENTERING INTO THIS AGREEMENT ON BEHALF OF A COMPANY OR OTHER LEGAL ENTITY, YOU REPRESENT THAT YOU HAVE THE AUTHORITY TO BIND SUCH ENTITY AND ITS AFFILIATES TO THESE TERMS AND CONDITIONS, IN WHICH CASE THE TERMS "YOU", "YOUR", OR "PARTY" SHALL REFER TO SUCH ENTITY AND ITS AFFILIATES. IF YOU DO NOT HAVE SUCH AUTHORITY, OR IF YOU DO NOT AGREE WITH THESE TERMS AND CONDITIONS, YOU MUST NOT ACCEPT THIS AGREEMENT AND MAY NOT USE THE SERVICES.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            'You may not access the Services for the purposes of monitoring the availability, performance or functionality of the Service, or for any other comparative or competitive purposes.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            'This Agreement was last updated on November 10, 2018. It is effective between you and us as of the date of your acceptance of this Agreement.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            'TERMS AND CONDITIONS'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '1. AGREEMENT. As referred to herein, "Agreement" means these Terms of Service, together with all policies and addenda that are incorporated herein by reference in the attached Exhibits. Definitions of terms are found in this Terms of Service Agreement.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '2. SERVICES; FEES; RESTRICTIONS ON USE; REGULATORY & INTENDED USES.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '2.1 Services. Subject to the terms and conditions of this Agreement, Purview grants to you a limited, non-transferable, non-exclusive license to access and use the Services for your own or your practice\u2019s use and not to be resold, relicensed or otherwise re-marketed as a product or service. You are responsible for: (a) complying with this Agreement; (b) the confidentiality and security of your or your patients\u2019 personal health information; (c) the accuracy, integrity, quality and legality of your images and information; (d) using commercially reasonable efforts to prevent unauthorized access to or use of the Services, and notifying us promptly of any such unauthorized access or use; (e) ensuring all of your data is backed up or archived elsewhere; and (f) using the Services only in accordance your applicable laws and government regulations.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '2.2 Fees. Your use of the Services is subject to license or usage fees established from time to time by Purview. Fees are subject to change during the Term. Failure to pay current fees when due or the failure to maintain a current payment method (credit or debit card, prepayment, or electronic funds transfer) may cause termination of your Services. Should you later wish to reinstate your Service, you will be responsible for all fees incurred for the duration of time from termination until reinstatement of your Services. You are responsible for all taxes associated with the Services other than U.S. taxes based on Purview\u2019s net income.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '2.3 Availability. Uploaded patient data, reports or other information will be available only for as long as you remain current on the payment of your Fees. Should your Services terminate for any reason, Purview will retain your stored information for ninety (90) days from such termination and shall make this data or information available to you for your electronic download for a fee equal to your last month\u2019s Service fee. Alternatively you may reinstate your account by paying the fees stated in Paragraph 2.2. Purview shall not otherwise be responsible for the return of stored data or other uploaded information for an account that has been terminated.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '2.4 Restrictions on Use. You agree not to: (i) resell the Services or use Services that have been resold; (ii) modify, decompile, reverse engineer, disassemble, attempt to discover the source code or algorithms of, or create derivative works based on, any of the Services or any part thereof; (iii) disable or circumvent any access control or related device, process or procedure established with respect to the Services or any part thereof; (iv) copy, rent, lease, lend, assign, sublicense, transfer, or otherwise make available, the Services or any rights under this Agreement to any Third Party except as expressly permitted by this Agreement; or (v) remove or obscure Purview\'s proprietary rights notices. Further, you agree not to: (vi) use the Services to transmit or store infringing, libelous, inappropriate, or otherwise unlawful or tortuous information or images; (v) use the Services to transmit or store information or images in violation of third-party privacy rights, (vi) use the Services to transmit or store Malicious Code; (vii) interfere with or disrupt the integrity or performance of the Services or third-party information contained therein, or (viii) attempt to gain unauthorized access to the Services or their related systems or networks, including impersonating other users or fictitious persons.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            'Purview, in its sole discretion, may delete or restrict access to the Services if it determines any of the restrictions on use have been violated. Purview may also delete any information, images or other material associated with an account deemed to be in violation of this Section 2.4.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '2.5 Intended Uses. The Services are intended for: (i) the storage and (ii) viewing of images acquired from CT, MR, CR, DR, US, NM and other DICOM compliant medical imaging systems when installed on suitable commercial standard hardware; (iii) the generation and storage of information related to these images; and (iv) the sharing of medical images with medical and healthcare personnel to facilitate clinical discussions. Unless otherwise stated, Purview Services are NOT intended to be used: (i) for primary diagnosis use by radiologists or diagnostic use by non-radiologists; (ii) within the standard radiology workflow; and (iii) for use as a pre-operative surgical planning tool and must not be used for this purpose. Horos itself is not a part of this Service and is covered by a separate LGPL license agreement.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '2.6 Regulatory. By using the Services, You acknowledge and agree that your or your patient\u2019s personal private health information may be transmitted and stored outside of your local geography or country. You hereby waive any and all objection to your local laws, statues or other regulations that prohibit the transmittal or storage of such information beyond your local geographic boundaries and/or you agree that if required, you have obtained explicit authorization from any person whose personal information is stored using our Services and that you have given that person a clear and unambiguous option to disallow the storage of such person\u2019s personal information.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '3. YOUR OBLIGATIONS. In addition to other obligations under this Agreement:'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '3.1 You will cooperate with Purview in the performance of Purview\'s obligations hereunder, including without limitation, and in each instance subject to normal security requirements and in a manner that is not unnecessarily disruptive to you or your business, by: (i) providing to Purview such information, Data, management decisions, approvals and acceptances as may be reasonable to permit Purview to provide Services hereunder; (ii) providing Purview secure, remote access to your network and/or computing technology, as required; and (iii) abiding with all commercially reasonable security and privacy requests made by Purview.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '3.2 You acknowledge that, in connection with the Services from time to time and with the performance of any of its obligations hereunder, Purview may require the technical assistance and cooperation of you and you will provide, at no charge to Purview, such technical assistance and cooperation as Purview may from time to time reasonably request during the Term.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '3.3 You acknowledge that Services may be subject to other limitations, such as limits on storage space and on the number of times you are permitted to access or transfer Data to or from our website, applications, and other products or services.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '5. OWNERSHIP. As between the Parties, the Services are, and at all times shall remain, Purview or its Licensors\' sole and exclusive property, including all copyrights, trademarks, patents and other intellectual property rights. You agree that neither you nor any Third Party shall obtain any express or implied rights in or to any part of the Services. All rights not expressly granted are reserved by Purview. As between you and us, you exclusively own all rights, title and interest in and to all your uploaded information and images.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '6. EQUIPMENT NEEDS AND LIMITATIONS.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '6.1 Equipment. You are responsible for obtaining and maintaining all computer hardware, software and communications equipment needed to connect to, access and use the Services and for paying all Third Party access charges (e.g., ISP, telecommunications) incurred while using the Services.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '6.2 Backend Equipment. Purview reserves the right to establish a maximum amount of network bandwidth, memory, or other computer storage and a maximum amount of Data that you may store, post or transmit on or through the Services.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '7. CONDUCT. You shall be solely responsible for your actions and the actions of your users while using the Services and the contents of transmissions through the Services (including, without limitation, your Data). You agree not to knowingly upload or distribute in any way files that contain viruses, corrupted files, or any other similar software or programs that may damage the operation of the Services or any computer. You agree not to knowingly upload or distribute in any way image files that violate in any way protected health information (PHI), personal protected information, or patient identifiers as defined in the USA by the Health Information Privacy and Accountability Act of 1996 Privacy Rule (see 45 C.F.R. Part 160 and Subparts A & E of Part 164, as subsequently amended, as defined under the GDPR, or otherwise. You agree to immediately delete any series or studies that are discovered to contain any image files that violate in any way protected health information (PHI), personal protected information or patient identifiers, to delete records upon request of any patient subject to the protections offered by GDPR, or to immediately notify Purview by email at\xA0support@Purview.com\xA0if such images are encountered in shared series or studies that you do not have necessary permissions to delete.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '8. CONFIDENTIALITY; YOUR DATA.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '8.1 Confidentiality of Patient Information. You are responsible for maintaining the confidentiality of your own or your patients\u2019information.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '8.2 Confidential Information. Purview and You each agree to use commercially reasonable efforts to maintain the other\'s Confidential Information in confidence and to not use or disclose any portion of the other Party\'s Confidential Information to Third Parties, except as reasonably necessary to perform this Agreement and as required by law.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '8.3 Your Data. As between the Parties, You shall own all data, information or material that you enter into the Services or has entered on its behalf ("Your Data"). For purposes of clarity, Your Data does not include Purview Data. Purview may access your account and Your Data from time-to-time as Purview deems necessary, solely for purposes of support, administration and invoicing related to your use of the Services. Except as permitted in this Agreement, Purview will not edit, delete or disclose Your Data unless authorized by you or unless Purview is required to do so by law or in the good faith belief that such action is necessary to: (i) conform with applicable laws or comply with legal process served on Purview; (ii) protect and defend the rights or property of Purview; or (iii) enforce this Agreement. Purview may provide user statistical information related to the usage of the Services such as usage or traffic patterns in aggregate form to Third Parties, but such information will not include identifiable information of you or personally identifying information for you or you patients. Notwithstanding the above, you agree and acknowledge that Purview may completely anonymize your data and use such anonymized data to aggregate health information, results or other statistics that may be valuable and helpful to the future prevention and treatment of disease.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '8.4 You may request the deletion of or the return of your Data or that of your patients.  Upon such request, Purview will either delete that Data and provide you with such confirmation or will make that data available to you in electronic form.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '9. TERM AND TERMINATION.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '9.1 Term. This Agreement shall begin as of the start of your use of the Services and shall remain in full force and effect until you cease to use the Service or unless and until such terms are modified by Purview. In such event you will be notified and you may decide to discontinue the use of the Service.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '9.2 Termination Upon an Event of Default. Purview may terminate this agreement immediately if you materially breach this Agreement or fail to pay Fees when due.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '10. INDEMNIFICATION.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '10.1 Patents and Copyrights. If an unaffiliated Third Party claims that any of the Services or data infringe that party\'s patents or copyrights, Purview will, at Purview\'s expense, modify them to make them non-infringing, or to replace them with another service that is substantially a functional equivalent. If Purview determines that none of these options is reasonably available, then Purview may terminate this Agreement in whole or with respect to the affected Services. THIS IS Purview\'s ENTIRE OBLIGATION AND LIABILITY REGARDING INFRINGEMENT OR CLAIMS OF INFRINGEMENT.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '10.2 Your Indemnity. You will, at your expense, defend Purview against all claims by unaffiliated Third Parties arising from or related to the Your Data or your use or misuse of the Services, and you shall pay costs, losses, damages, and attorneys\' fees that a court finally awards, and all associated settlements.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '10.3 Indemnification Procedure. The indemnification obligations under Sections 10.1 and 10.2 are conditioned on the indemnifying Party receiving (i) prompt written notice of the claim, (ii) the necessary assistance, information and authority to defend the claim and perform its obligations, and (iii) sole control of the defense and settlement of such claim and all associated negotiations. This Section 10 states the indemnifying party\'s sole liability to, and the indemnified party\'s exclusive remedy against, the other party for any type of Claim described in this Section.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '11. DISCLAIMER. PURVIEW MAKES NO WARRANTIES, GUARANTEES OR REPRESENTATIONS OF ANY KIND, EXPRESS OR IMPLIED, WITH RESPECT TO THE OPERATION, CAPACITY, SPEED, FUNCTIONALITY, QUALIFICATIONS OR CAPABILITIES OF THE SERVICES OR ANY GOODS OR PERSONNEL RESOURCES PROVIDED HEREUNDER, INCLUDING, WITHOUT LIMITATION, ANY IMPLIED WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE, TITLE OR NON-INFRINGEMENT. Purview DOES NOT WARRANT ANY PARTICULAR RESULTS THAT MAY BE OBTAINED BY THE USE OF THE SERVICES OR THAT THE SERVICES OR ASSOCIATED SYSTEMS WILL OPERATE IN AN ERROR-FREE OR UNINTERRUPTED MANNER, OR IN COMBINATION WITH THIRD PARTY PRODUCTS.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '12. MISCELLANEOUS.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '12.1 Assignment. You may not assign, transfer, or sell any of yours rights or delegate any of yours responsibilities under this Agreement, without Purview\'s prior written consent. Any purported assignment of rights or delegation of performance in violation of this Section 12.1 is void.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '12.2 Force Majeure. Neither Party shall be liable for any delay or failure due to force majeure and other causes beyond its control, including for acts of God, labor disputes, changes in government policy/law, war, epidemics, acts or omissions of vendors or suppliers, disruptions caused by failures of the Internet or service providers (including those providing electricity, telecommunications links and/or Internet connectivity), or other occurrences which are beyond its reasonable control. This provision shall not apply to any of your payment obligations. In the event that either Party is excused from the performance of its obligations hereunder pursuant to this Section 12.2, then that Party shall use all efforts that are reasonable under the circumstances to resume performance of its obligations hereunder as soon as feasible.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '12.3 Compliance with Laws. The Services are provided solely for lawful purposes and use. Without limiting the other terms of this Agreement, you shall be solely responsible for, and agree to comply with, all laws, statutes, ordinances and/or regulations (including without limitation the laws and regulations governing export control, unfair competition, anti-discrimination, false advertising, privacy and data protection, and publicity) (collectively, "Laws") applicable to you and your business and its use of the Services. You will not directly or indirectly ship, transfer, export or transmit the Services into any country or permit or authorize use by any Person in any manner prohibited by the United States Export Administration Act, the International Traffic in Arms Regulations of the U.S. State Department, or any other export laws, restrictions, or regulations of any jurisdiction. The Parties agree that Purview may in its sole discretion make changes to any of the Services from time to time as may be reasonably necessary or appropriate for Purview to comply with applicable Laws. The Parties further agree that if a change in applicable Laws makes the continued performance of this Agreement (or any part thereof), in Purview\'s sole reasonable discretion, unduly burdensome or unlawful, Purview may terminate this Agreement in whole or in part upon notice to you.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '12.4 Entire Agreement. This Agreement constitutes the entire agreement and understanding of the Parties with respect to the subject matter hereof, superseding any prior oral or written communications. Sections 5, 7, 8, 10, 11 and 12 shall survive the termination or expiration of this Agreement. The Parties are independent contractors for all purposes under this Agreement.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '12.5 Governing Law. This Agreement shall be governed by the laws of the State of Maryland, USA without regard to its conflict of law provisions. Any dispute arising out of or related to this Agreement shall be resolved only in the state and federal courts located in Anne Arundel County, Maryland.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '12.7 Amendments and Waivers. No amendment to this Agreement shall be valid unless it is in writing and is signed by each of the Parties. Except where a specific period for action or inaction is provided herein, no delay on the part of either Party in exercising any right, power or privilege hereunder shall operate as a waiver thereof. No waiver on the part of either Party of any such right, power or privilege shall preclude any further exercise thereof or the exercise of any other such right, power or privilege.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            '12.8 Severability. If any provision of this Agreement is held to be illegal or unenforceable for any reason, then such provision shall be deemed to be restated so as to be enforceable to the maximum extent permissible under law; the remainder of this Agreement shall remain in full force and effect.'
                        )
                    )
                )
            );
        }
    }]);

    return Terms;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Report; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_slot_fill__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReportEditorHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReportHeader__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ReportTitle__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReportBasicInfo__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ReportFields__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ReportSignatures__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ReportViewerHeader__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReportPreview__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_report_components_lib_reducers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ReportNavbar__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ReportFooter__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ReportKeyImages__ = __webpack_require__(165);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _dec2, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var Report = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__["fetchConnect"])(function (_ref) {
  var user = _ref.user,
      report = _ref.report,
      appUI = _ref.appUI;
  return {
    isPreviewOpen: report.isPreviewOpen,
    isReportFinished: report.finished,
    readOnly: report.readOnly,
    userEmail: user.email,
    isChangingTemplate: appUI.loadings[__WEBPACK_IMPORTED_MODULE_13_report_components_lib_reducers__["m" /* changeTemplate */]]
  };
}, { connectFetcher: __WEBPACK_IMPORTED_MODULE_2__reducers__["n" /* setReport */] }), _dec(_class = function (_React$Component) {
  _inherits(Report, _React$Component);

  function Report() {
    _classCallCheck(this, Report);

    return _possibleConstructorReturn(this, (Report.__proto__ || Object.getPrototypeOf(Report)).apply(this, arguments));
  }

  _createClass(Report, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          readOnly = _props.readOnly,
          isChangingTemplate = _props.isChangingTemplate,
          location = _props.location,
          isReportFinished = _props.isReportFinished,
          isPreviewOpen = _props.isPreviewOpen;

      var showView = isPreviewOpen || isReportFinished || readOnly;
      var isEmbedded = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib__["i" /* queryHasValue */])(location.search, 'embedded', "true");
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_slot_fill__["Fill"],
          { name: 'Navbar-Center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ReportNavbar__["a" /* ReportNavbar */], { navigationDisabled: isEmbedded })
        ),
        showView ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReportViewer, { isEmbedded: isEmbedded }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReportEditor, { isEmbedded: isEmbedded, isChangingTemplate: isChangingTemplate }),
        !isReportFinished && !readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ReportKeyImages__["a" /* ReportKeyImagesLoader */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ReportFooter__["a" /* ReportFooter */], { navigationDisabled: isEmbedded })
      );
    }
  }]);

  return Report;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class);

var ReportEditor = (_dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__["withToggles"])('dragging'), _dec2(_class2 = function (_React$PureComponent) {
  _inherits(ReportEditor, _React$PureComponent);

  function ReportEditor() {
    var _ref2;

    var _temp, _this2, _ret;

    _classCallCheck(this, ReportEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref2 = ReportEditor.__proto__ || Object.getPrototypeOf(ReportEditor)).call.apply(_ref2, [this].concat(args))), _this2), _this2.postFetcher = function (formData) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs__["postFetcher"])('t', formData);
    }, _this2.setDragging = function (element) {
      _this2.props.dragging.toggle(!!element);
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(ReportEditor, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          isChangingTemplate = _props2.isChangingTemplate,
          isEmbedded = _props2.isEmbedded,
          dragging = _props2.dragging;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content viva-report-builder' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ReportEditorHeader__["a" /* ReportEditorHeader */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'report-page' + (isChangingTemplate ? ' loading' : '') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ReportHeader__["a" /* ReportHeader */], { isEmbedded: isEmbedded }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ReportTitle__["a" /* ReportTitle */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ReportBasicInfo__["a" /* ReportBasicInfo */], { setDragRef: this.setDragging }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ReportFields__["a" /* ReportFields */], { setDragRef: this.setDragging }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ReportSignatures__["a" /* ReportSignatures */], { isEmbedded: isEmbedded, setDragRef: this.setDragging })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ReportKeyImages__["b" /* ReportKeyImagesPanel */], { dragging: dragging })
      );
    }
  }]);

  return ReportEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class2);

var ReportViewer = function (_React$PureComponent2) {
  _inherits(ReportViewer, _React$PureComponent2);

  function ReportViewer() {
    _classCallCheck(this, ReportViewer);

    return _possibleConstructorReturn(this, (ReportViewer.__proto__ || Object.getPrototypeOf(ReportViewer)).apply(this, arguments));
  }

  _createClass(ReportViewer, [{
    key: 'render',
    value: function render() {
      var isEmbedded = this.props.isEmbedded;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content viva-report-preview' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ReportViewerHeader__["b" /* ReportViewerHeader */], {
          hideSavePdfButton: isEmbedded
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ReportPreview__["a" /* ReportPreview */], null)
      );
    }
  }]);

  return ReportViewer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportBasicInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_report_components__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_report_components_lib_selectors__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var autoSaveType = { type: 'reportField' };

var ReportBasicInfoEditor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_report_components_lib_selectors__["e" /* makeMapStateToProps */])({ getNewId: __WEBPACK_IMPORTED_MODULE_5_report_components_lib_selectors__["f" /* getNewId */], getItems: __WEBPACK_IMPORTED_MODULE_5_report_components_lib_selectors__["c" /* getItems */] })(function (_ref) {
  var getNewId = _ref.getNewId,
      getItems = _ref.getItems;
  return function (_ref2) {
    var report = _ref2.report;
    return {
      basicInfos: getItems(report.reportBasicInfos),
      labels: report.templates.infoLabels,
      dicomInfo: report.dicomInfo,
      newId: getNewId(report.reportBasicInfos),
      language: report.reportSettings.layout.language,
      dateFormat: report.reportSettings.layout.dateFormat,
      autoSaveType: autoSaveType
    };
  };
}), function (dispatch) {
  return {
    addNew: function addNew(field, index) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["F" /* addReportBasicInfo */])(field, { index: index }));
    },
    updateOrder: function updateOrder(newOrder) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["G" /* updateReportBasicInfosOrder */])(newOrder));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["l" /* autoSaveOrder */])(newOrder, autoSaveType));
    },
    updateItem: function updateItem(item) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["H" /* updateReportBasicInfo */])(item));
    },
    removeItem: function removeItem(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["I" /* deleteReportBasicInfo */])(id));
    },
    confirmRemoveItem: function confirmRemoveItem(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["k" /* autoSaveRemove */])(id, autoSaveType));
    },
    autoSaveUpdate: function autoSaveUpdate(item) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["j" /* autoSaveUpdate */])(item, autoSaveType));
    }
  };
})(__WEBPACK_IMPORTED_MODULE_3_report_components__["k" /* BasicInfoEditor */]);

var ReportDicomDateFormatter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (_ref3) {
  var report = _ref3.report;
  return {
    dicomInfo: report.dicomInfo,
    language: report.reportSettings.layout.language,
    dateFormat: report.reportSettings.layout.dateFormat
  };
}, function (dispatch) {
  return {
    updateItem: function updateItem(item) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["H" /* updateReportBasicInfo */])(item));
    },
    autoSaveUpdate: function autoSaveUpdate(item) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["j" /* autoSaveUpdate */])(item, autoSaveType));
    }
  };
})(__WEBPACK_IMPORTED_MODULE_3_report_components__["l" /* DicomDateFormatter */]);

var ReportBasicInfo = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_report_components_lib_selectors__["e" /* makeMapStateToProps */])({ getItems: __WEBPACK_IMPORTED_MODULE_5_report_components_lib_selectors__["c" /* getItems */] })(function (_ref4) {
  var getItems = _ref4.getItems;
  return function (_ref5) {
    var report = _ref5.report;
    return {
      basicInfos: getItems(report.reportBasicInfos),
      dicomInfo: report.dicomInfo
    };
  };
})), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withToggles"])('editor'), _dec(_class = _dec2(_class = function (_React$Component) {
  _inherits(ReportBasicInfo, _React$Component);

  function ReportBasicInfo() {
    _classCallCheck(this, ReportBasicInfo);

    return _possibleConstructorReturn(this, (ReportBasicInfo.__proto__ || Object.getPrototypeOf(ReportBasicInfo)).apply(this, arguments));
  }

  _createClass(ReportBasicInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          basicInfos = _props.basicInfos,
          editor = _props.editor;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'report-basic-info', id: 'basicInfoAnchor' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'field-label' },
            'Report basic info'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'box report-basic-info-box' },
          !editor.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-wrapper' },
            basicInfos.filter(function (_, i) {
              return (i + 1) % 2;
            }).map(function (info) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'report-basic-info-item', key: info.id },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  info.label,
                  ':'
                ),
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  info.value
                )
              );
            })
          ),
          !editor.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-wrapper' },
            basicInfos.filter(function (_, i) {
              return i % 2;
            }).map(function (info) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'report-basic-info-item', key: info.id },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  info.label,
                  ':'
                ),
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  info.value
                )
              );
            })
          ),
          editor.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReportBasicInfoEditor, {
            setDragRef: this.props.setDragRef,
            close: editor.close
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReportDicomDateFormatter, { fields: ['dob', 'studydate'], basicInfos: basicInfos }),
          !editor.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'button small-button edit-button', onClick: editor.open },
            'Edit'
          )
        )
      );
    }
  }]);

  return ReportBasicInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class) || _class);

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportEditorHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_report_components__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_report_components_lib_reducers__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var getAvailableSignatures = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["c" /* getItems */])();

var prepareTemplateToSave = function prepareTemplateToSave(_ref) {
  var templateId = _ref.templateId,
      label = _ref.label,
      keepContent = _ref.keepContent,
      keepSignatures = _ref.keepSignatures;
  return function (report) {
    var reportSignatures = report.reportSignatures,
        reportFields = report.reportFields,
        reportBasicInfos = report.reportBasicInfos,
        reportTitle = report.reportTitle;

    var withoutId = function withoutId(_ref2) {
      var id = _ref2.id,
          obj = _objectWithoutProperties(_ref2, ['id']);

      return obj;
    };
    var withoutModified = function withoutModified(_ref3) {
      var modified = _ref3.modified,
          obj = _objectWithoutProperties(_ref3, ['modified']);

      return obj;
    };
    var withoutIsCustom = function withoutIsCustom(_ref4) {
      var isCustom = _ref4.isCustom,
          obj = _objectWithoutProperties(_ref4, ['isCustom']);

      return obj;
    };
    var toList = function toList(map) {
      return map.order.map(function (id) {
        return withoutModified(withoutId(map[id]));
      });
    };
    return {
      id: templateId,
      label: label,
      fields: {
        reportSignatures: keepSignatures ? toList(reportSignatures).map(withoutIsCustom) : [],
        reportFields: keepContent ? toList(reportFields) : toList(reportFields).map(function (_ref5) {
          var value = _ref5.value,
              field = _objectWithoutProperties(_ref5, ['value']);

          return _extends({}, field, {
            value: ''
          });
        }),
        reportBasicInfos: toList(reportBasicInfos).map(function (_ref6) {
          var value = _ref6.value,
              info = _objectWithoutProperties(_ref6, ['value']);

          return _extends({}, info, {
            value: ''
          });
        }),
        reportTitle: { title: reportTitle.title }
      }
    };
  };
};

var ReportEditorHeader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (_ref7) {
  var report = _ref7.report,
      appUI = _ref7.appUI;
  return {
    lastSaved: report.lastSaved,
    isRetryNotificationOpen: report.appUI.retryAutoSave,
    isSaving: appUI.loadings[__WEBPACK_IMPORTED_MODULE_3_report_components_lib_reducers__["j" /* autoSaveUpdate */]] || appUI.loadings[__WEBPACK_IMPORTED_MODULE_3_report_components_lib_reducers__["k" /* autoSaveRemove */]] || appUI.loadings[__WEBPACK_IMPORTED_MODULE_3_report_components_lib_reducers__["l" /* autoSaveOrder */]] || appUI.loadings[__WEBPACK_IMPORTED_MODULE_3_report_components_lib_reducers__["K" /* autoSaveRetry */]],
    selectedTemplate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["h" /* getSelectedTemplate */])(report),
    dicomInfo: report.dicomInfo,
    templates: report.templates,
    availableSignatures: getAvailableSignatures(report.availableSignatures),
    reportTitle: report.reportTitle,
    studies: report.dicomInfo.studies,
    readOnly: report.readOnly,
    patientName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["b" /* getPatientName */])(report),
    language: report.reportSettings.layout.language,
    dateFormat: report.reportSettings.layout.dateFormat,
    prepareTemplateToSave: prepareTemplateToSave
  };
}, function (dispatch) {
  return {
    saveTemplate: function saveTemplate(fn) {
      return dispatch(function (dispatch, getState) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_report_components_lib_reducers__["L" /* saveTemplate */])(fn(getState().report))(dispatch);
      });
    }
  };
})(__WEBPACK_IMPORTED_MODULE_1_report_components__["o" /* EditorHeader */]);

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportFields; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_report_components__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_report_components_lib_selectors__ = __webpack_require__(20);





var autoSaveType = { type: 'reportField' };

var ReportFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_report_components_lib_selectors__["e" /* makeMapStateToProps */])({ getNewId: __WEBPACK_IMPORTED_MODULE_3_report_components_lib_selectors__["f" /* getNewId */], getItems: __WEBPACK_IMPORTED_MODULE_3_report_components_lib_selectors__["c" /* getItems */] })(function (_ref) {
  var getNewId = _ref.getNewId,
      getItems = _ref.getItems;
  return function (_ref2) {
    var report = _ref2.report;
    return {
      fields: getItems(report.reportFields),
      newId: getNewId(report.reportFields),
      labels: report.templates.fieldsLabels
    };
  };
}), function (dispatch) {
  return {
    addNew: function addNew(field, index) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["B" /* addReportField */])(field, { index: index }));
    },
    deleteField: function deleteField(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["C" /* deleteReportField */])(id));
    },
    updateOrder: function updateOrder(newOrder) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["D" /* updateReportFieldsOrder */])(newOrder));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["l" /* autoSaveOrder */])(newOrder, autoSaveType));
    },
    updateItem: function updateItem(item) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["E" /* updateReportField */])(item));
    },
    removeItem: function removeItem(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["C" /* deleteReportField */])(id));
    },
    confirmRemoveItem: function confirmRemoveItem(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["k" /* autoSaveRemove */])(id, autoSaveType));
    },
    autoSaveUpdate: function autoSaveUpdate(item) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["j" /* autoSaveUpdate */])(item, autoSaveType));
    }
  };
})(__WEBPACK_IMPORTED_MODULE_1_report_components__["j" /* Fields */]);

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reportTemplate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_report_components_lib_selectors__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__);
var _templateObject = _taggedTemplateLiteral(['\n  height: 3rem;\n  color: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  ', ' {\n    font-size: 16px;\n  }\n  .link {\n    color: rgba(0,0,0,0.5);\n    margin-left: .5rem;\n  }\n  &:hover, &:hover .link {\n    color: ', ';\n  }\n'], ['\n  height: 3rem;\n  color: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  ', ' {\n    font-size: 16px;\n  }\n  .link {\n    color: rgba(0,0,0,0.5);\n    margin-left: .5rem;\n  }\n  &:hover, &:hover .link {\n    color: ', ';\n  }\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }










var DeleteLink = __WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject, __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Icon"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('alert'));

var reportTemplate = {
  title: function title(editing) {
    return editing ? 'Report Viewer' : 'Report Editor';
  },
  finishLabel: 'Finish report',
  editLabel: 'Edit report'
};

var ReportFooter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (_ref, ownProps) {
  var report = _ref.report,
      appUI = _ref.appUI;
  return {
    isChangingTemplate: appUI.loadings[__WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["m" /* changeTemplate */]],
    isFinishing: appUI.loadings[__WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["M" /* finishDocument */]],
    isUnfinishing: appUI.loadings[__WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["N" /* unfinishDocument */]],

    isDocumentFinished: report.finished,
    isPreviewOpen: report.isPreviewOpen,
    isReport: report.reportUID !== null,
    isUploadingKeyImages: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_report_components_lib_selectors__["a" /* isUploadingKeyImages */])(report.reportKeyImages),
    readOnly: report.readOnly,
    navigationDisabled: ownProps.navigationDisabled || report.navigationDisabled
  };
}, { togglePreview: __WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["O" /* togglePreview */], unfinishDocument: __WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["N" /* unfinishDocument */], finishDocument: __WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["M" /* finishDocument */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__["withToggles"])('keyImagesDialog')(function (_ref2) {
  var isChangingTemplate = _ref2.isChangingTemplate,
      isFinishing = _ref2.isFinishing,
      isUnfinishing = _ref2.isUnfinishing,
      isDocumentFinished = _ref2.isDocumentFinished,
      isPreviewOpen = _ref2.isPreviewOpen,
      isReport = _ref2.isReport,
      isUploadingKeyImages = _ref2.isUploadingKeyImages,
      readOnly = _ref2.readOnly,
      navigationDisabled = _ref2.navigationDisabled,
      togglePreview = _ref2.togglePreview,
      finishDocument = _ref2.finishDocument,
      unfinishDocument = _ref2.unfinishDocument,
      isLocked = _ref2.isLocked,
      keyImagesDialog = _ref2.keyImagesDialog,
      _ref2$template = _ref2.template,
      template = _ref2$template === undefined ? reportTemplate : _ref2$template;

  var viewing = isPreviewOpen || isDocumentFinished;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'report-footer' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'footer-content' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'left-container' },
        !navigationDisabled && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
          { TAG: __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Link"], to: '/', icon: 'arrow-left', className: 'return-button' },
          'Reports list'
        ),
        false && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          DeleteLink,
          { className: 'link' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Icon"], { icon: 'delete' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { className: 'link' },
            'Delete this report'
          )
        )
      ),
      !readOnly && !isLocked && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'right-container' },
        !viewing && isReport && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
          { disabled: isChangingTemplate, onClick: togglePreview },
          'Preview'
        ),
        isPreviewOpen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
          { icon: 'edit', onClick: togglePreview },
          template.editLabel
        ),
        isDocumentFinished && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
          { isLoading: isFinishing || isUnfinishing, icon: 'edit', onClick: unfinishDocument },
          template.editLabel
        ),
        !isDocumentFinished && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
          { isLoading: isFinishing || isUnfinishing,
            success: true,
            onClick: isUploadingKeyImages ? keyImagesDialog.open : finishDocument,
            disabled: isChangingTemplate },
          template.finishLabel
        )
      ),
      isLocked && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'right-container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
          { locked: true, icon: 'lock', disabled: true },
          'Editing is Locked'
        )
      )
    )
  );
}));

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_report_components__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_startlibs__);






var uploadFetcher = function uploadFetcher(formData) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs__["postFetcher"])('/api/upload-logo', formData);
};

var ReportHeader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (_ref) {
  var report = _ref.report;
  return {
    reportSettings: report.reportSettings,
    action: __WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["n" /* updateReportSettings */],
    getResource: __WEBPACK_IMPORTED_MODULE_3__lib__["h" /* getResource */],
    uploadFetcher: uploadFetcher
  };
})(__WEBPACK_IMPORTED_MODULE_1_report_components__["n" /* Header */]);

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReportKeyImages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReportKeyImagesPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportKeyImagesLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_report_components__ = __webpack_require__(14);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var autoSaveType = { type: 'reportSignature' };
var uploadFetcher = function uploadFetcher(formData, reportUID) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs__["postFetcher"])('/api/upload-key-image/' + reportUID, formData).then(function (_ref) {
    var resourceUID = _ref.resourceUID;
    return { success: { keyImage: resourceUID } };
  });
};
var emptyErrors = {};
var needsUpgrade = function needsUpgrade(user) {
  return !(user.accountStatus === 'trialing' || user.authorities.indexOf('KEY_IMAGES') >= 0 && ['past_due', 'trialing', 'active'].indexOf(user.accountStatus) >= 0);
};

var ReportKeyImages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["e" /* makeMapStateToProps */])({ getNewId: __WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["f" /* getNewId */], getItems: __WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["c" /* getItems */] })(function (_ref2) {
  var getNewId = _ref2.getNewId;
  return function (_ref3) {
    var user = _ref3.user,
        report = _ref3.report,
        appUI = _ref3.appUI;
    return {
      needsUpgrade: needsUpgrade(user),
      isHorosCloud: true,
      reportKeyImages: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["d" /* getReportKeyImages */])(report.reportKeyImages),
      deletedReportKeyImages: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["g" /* getDeletedReportKeyImages */])(report.reportKeyImages),
      newId: getNewId(report.reportKeyImages),
      reportUID: report.reportUID,
      errors: appUI.errors[__WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["e" /* addReportKeyImage */]] || emptyErrors
    };
  };
}), function (dispatch) {
  return {
    uploadFetcher: uploadFetcher,
    getResource: __WEBPACK_IMPORTED_MODULE_4__lib__["h" /* getResource */],
    clearErrors: function clearErrors() {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs__["clearErrors"])(__WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["e" /* addReportKeyImage */]));
    },
    setErrors: function setErrors(error) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs__["setErrors"])(error, { actionKey: __WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["e" /* addReportKeyImage */] }));
    },
    update: function update(keyImage) {
      var r = dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["r" /* updateReportKeyImage */])(keyImage));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["j" /* autoSaveUpdate */])(keyImage, autoSaveType));
      return r;
    },
    retryFailed: function retryFailed(props) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["s" /* retryFailedReportKeyImages */])(props));
    },
    addNew: function addNew(keyImage, index) {
      var r = dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["e" /* addReportKeyImage */])(keyImage, { index: index }));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["j" /* autoSaveUpdate */])(keyImage, autoSaveType));
      return r;
    },
    remove: function remove(id) {
      var r = dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["t" /* deleteReportKeyImage */])(id));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["k" /* autoSaveRemove */])(id, autoSaveType));
      return r;
    },
    updateOrder: function updateOrder(newOrder) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["u" /* updateReportKeyImagesOrder */])(newOrder));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["l" /* autoSaveOrder */])(newOrder, autoSaveType));
    },
    deleteResource: function deleteResource(resourceUID) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs__["postFetcher"])('/api/report-resources/' + resourceUID, '', { method: 'DELETE' });
    }
  };
})(__WEBPACK_IMPORTED_MODULE_6_report_components__["g" /* KeyImages */]);

var ReportKeyImagesPanel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (_ref4) {
  var report = _ref4.report;
  return { reportKeyImages: report.reportKeyImages };
})(function (_ref5) {
  var props = _objectWithoutProperties(_ref5, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_report_components__["h" /* KeyImagesPanel */], _extends({}, props, { KeyImages: function KeyImages(props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReportKeyImages, props);
    } }));
});



var ReportKeyImagesLoader = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (_ref6) {
  var report = _ref6.report,
      user = _ref6.user;
  return {
    reportUID: report.reportUID,
    needsUpgrade: needsUpgrade(user),
    reportKeyImages: report.reportKeyImages
  };
}, {
  update: __WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["r" /* updateReportKeyImage */],
  addNew: __WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["e" /* addReportKeyImage */],
  save: __WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["v" /* autoSaveAll */],
  deleteImage: __WEBPACK_IMPORTED_MODULE_1_report_components_lib_reducers__["t" /* deleteReportKeyImage */]
}), _dec(_class = function (_React$Component) {
  _inherits(ReportKeyImagesLoader, _React$Component);

  function ReportKeyImagesLoader() {
    var _ref7;

    var _temp, _this, _ret;

    _classCallCheck(this, ReportKeyImagesLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref7 = ReportKeyImagesLoader.__proto__ || Object.getPrototypeOf(ReportKeyImagesLoader)).call.apply(_ref7, [this].concat(args))), _this), _this.fetch = function () {
      var existingResourcers = Object.values(_this.props.reportKeyImages).map(function (_) {
        return _.resourceUID;
      }).filter(function (_) {
        return _;
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs__["getFetcher"])('/api/report-key-images/' + _this.props.reportUID).then(function (resourcesUID) {
        var newResources = resourcesUID.filter(function (_) {
          return existingResourcers.indexOf(_) < 0;
        }).map(function (missingResourceUID) {
          return new Promise(function (res) {
            if (Object.values(_this.props.reportKeyImages).map(function (_) {
              return _.resourceUID;
            }).filter(function (_) {
              return _;
            }).indexOf(missingResourceUID) < 0) {
              _this.props.addNew({
                id: missingResourceUID,
                description: '',
                name: '',
                resourceUID: missingResourceUID
              });
              var image = document.createElement('img');
              image.onload = function () {
                var imageWidth = image.naturalWidth,
                    imageHeight = image.naturalHeight;

                _this.props.update({
                  id: missingResourceUID,
                  description: '',
                  name: '',
                  imageWidth: imageWidth,
                  imageHeight: imageHeight,
                  resourceUID: missingResourceUID
                });
                res(1);
              };
              image.onerror = function () {
                res(0);
              };
              image.src = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["h" /* getResource */])(missingResourceUID);
            }
          });
        });
        var deletedResources = existingResourcers.filter(function (_) {
          return resourcesUID.indexOf(_) < 0;
        }).map(function (deleted) {
          return new Promise(function (res) {
            var deletedImage = Object.values(_this.props.reportKeyImages).find(function (_) {
              return _.resourceUID === deleted;
            });
            if (deletedImage) {
              _this.props.deleteImage(deletedImage.id).then(function (_) {
                return res(1);
              });
            } else {
              res(0);
            }
          });
        });
        var modifiedResources = newResources.concat(deletedResources);
        if (modifiedResources.length > 0) {
          Promise.all(modifiedResources).then(function () {
            return _this.props.save();
          });
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReportKeyImagesLoader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.needsUpgrade) {
        this.interval = setInterval(this.fetch, 5000);
        this.fetch();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return ReportKeyImagesLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class);

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reportTemplate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportNavbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_report_components_lib_selectors__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_report_components_lib_reducers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__);
var _templateObject = _taggedTemplateLiteral(['\n  padding-top: 10px;\n  padding-bottom: 10px;\n  line-height: 1;\n  box-shadow: none;\n  min-height: 32px;\n  white-space: nowrap;\n  ', ' {\n    font-size: 19px;\n    margin-right: 6px;\n    margin-left: -6px;\n  }\n  ~ .styled-button {\n    margin-left: 0.75rem;\n  }\n  :focus {\n    :before {\n      box-shadow: none;\n    }\n    :after {\n      content: none;\n    }\n  }\n'], ['\n  padding-top: 10px;\n  padding-bottom: 10px;\n  line-height: 1;\n  box-shadow: none;\n  min-height: 32px;\n  white-space: nowrap;\n  ', ' {\n    font-size: 19px;\n    margin-right: 6px;\n    margin-left: -6px;\n  }\n  ~ .styled-button {\n    margin-left: 0.75rem;\n  }\n  :focus {\n    :before {\n      box-shadow: none;\n    }\n    :after {\n      content: none;\n    }\n  }\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }









var NavbarButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"])(_templateObject, __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Icon"]);

var reportTemplate = {
  title: function title(editing) {
    return editing ? 'Report Viewer' : 'Report Editor';
  },
  finishLabel: 'Finish report',
  editLabel: 'Edit report'
};

var ReportNavbar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (_ref, ownProps) {
  var report = _ref.report,
      appUI = _ref.appUI;
  return {
    isChangingTemplate: appUI.loadings[__WEBPACK_IMPORTED_MODULE_5_report_components_lib_reducers__["m" /* changeTemplate */]],
    isFinishing: appUI.loadings[__WEBPACK_IMPORTED_MODULE_5_report_components_lib_reducers__["M" /* finishDocument */]],
    isUnfinishing: appUI.loadings[__WEBPACK_IMPORTED_MODULE_5_report_components_lib_reducers__["N" /* unfinishDocument */]],

    isDocumentFinished: report.finished,
    isPreviewOpen: report.isPreviewOpen,
    isReport: report.reportUID !== null,
    isUploadingKeyImages: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_report_components_lib_selectors__["a" /* isUploadingKeyImages */])(report.reportKeyImages),
    readOnly: report.readOnly,
    navigationDisabled: ownProps.navigationDisabled || report.navigationDisabled
  };
}, { togglePreview: __WEBPACK_IMPORTED_MODULE_5_report_components_lib_reducers__["O" /* togglePreview */], unfinishDocument: __WEBPACK_IMPORTED_MODULE_5_report_components_lib_reducers__["N" /* unfinishDocument */], finishDocument: __WEBPACK_IMPORTED_MODULE_5_report_components_lib_reducers__["M" /* finishDocument */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__["withToggles"])('keyImagesDialog')(function (_ref2) {
  var isChangingTemplate = _ref2.isChangingTemplate,
      isFinishing = _ref2.isFinishing,
      isUnfinishing = _ref2.isUnfinishing,
      isDocumentFinished = _ref2.isDocumentFinished,
      isPreviewOpen = _ref2.isPreviewOpen,
      isReport = _ref2.isReport,
      isUploadingKeyImages = _ref2.isUploadingKeyImages,
      readOnly = _ref2.readOnly,
      navigationDisabled = _ref2.navigationDisabled,
      togglePreview = _ref2.togglePreview,
      finishDocument = _ref2.finishDocument,
      unfinishDocument = _ref2.unfinishDocument,
      isLocked = _ref2.isLocked,
      keyImagesDialog = _ref2.keyImagesDialog,
      _ref2$template = _ref2.template,
      template = _ref2$template === undefined ? reportTemplate : _ref2$template;

  var viewing = isPreviewOpen || isDocumentFinished;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'navbar-content report-navbar center-container' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'left-container' },
      !navigationDisabled ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        NavbarButton,
        { TAG: __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Link"], to: '/', icon: 'arrow-left', outline: true, white: true, className: 'return-button' },
        'Reports list'
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'logo-container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'logo' },
          'Horos Cloud'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'central-container' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'report-status' },
        isPreviewOpen ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon icon-view' }),
          'Previewing'
        ) : template.title(isDocumentFinished || readOnly)
      )
    ),
    !readOnly && !isLocked && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'right-container' },
      !viewing && isReport && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        NavbarButton,
        { outline: true, white: true, disabled: isChangingTemplate, onClick: togglePreview },
        'Preview'
      ),
      isPreviewOpen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        NavbarButton,
        { outline: true, white: true, icon: 'edit', onClick: togglePreview },
        template.editLabel
      ),
      isDocumentFinished && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        NavbarButton,
        { isLoading: isFinishing || isUnfinishing, icon: 'edit', outline: true, white: true, onClick: unfinishDocument },
        template.editLabel
      ),
      !isDocumentFinished && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        NavbarButton,
        { isLoading: isFinishing || isUnfinishing,
          success: true,
          onClick: isUploadingKeyImages ? keyImagesDialog.open : finishDocument,
          disabled: isChangingTemplate },
        template.finishLabel
      )
    ),
    isLocked && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'right-container' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        NavbarButton,
        { locked: true, icon: 'lock', disabled: true },
        'Editing is Locked'
      )
    )
  );
}));

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportPreview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_report_components__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__ = __webpack_require__(8);






var infoItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["c" /* getItems */])();
var signatureItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["c" /* getItems */])();
var fieldItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["c" /* getItems */])();

var ReportPreview = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (_ref) {
  var _ref$report = _ref.report,
      isPdfPrinter = _ref$report.isPdfPrinter,
      lastSaved = _ref$report.lastSaved,
      finished = _ref$report.finished,
      reportSettings = _ref$report.reportSettings,
      reportTitle = _ref$report.reportTitle,
      reportBasicInfos = _ref$report.reportBasicInfos,
      reportKeyImages = _ref$report.reportKeyImages,
      reportFields = _ref$report.reportFields,
      reportSignatures = _ref$report.reportSignatures,
      availableSignatures = _ref$report.availableSignatures,
      dicomInfo = _ref$report.dicomInfo;
  return {
    reportSettings: reportSettings, reportTitle: reportTitle, availableSignatures: availableSignatures,
    reportBasicInfos: infoItems(reportBasicInfos),
    reportFields: fieldItems(reportFields),
    reportSignatures: signatureItems(reportSignatures),
    reportKeyImages: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["d" /* getReportKeyImages */])(reportKeyImages),
    patientName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["b" /* getPatientName */])({ reportBasicInfos: reportBasicInfos, dicomInfo: dicomInfo }),
    finished: finished,
    lastSaved: lastSaved,
    isPdfPrinter: isPdfPrinter,
    getResource: __WEBPACK_IMPORTED_MODULE_3__lib__["h" /* getResource */]
  };
}, function (dispatch) {
  return {
    setImagesLoaded: function setImagesLoaded(v) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_report_components_lib_reducers__["q" /* imagesLoaded */])(v));
    }
  };
})(__WEBPACK_IMPORTED_MODULE_1_report_components__["f" /* Preview */]);

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportSignatures; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_report_components__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_report_components_lib_selectors__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs__);







var autoSaveType = { type: 'reportSignature' };

var uploadFetcher = function uploadFetcher(formData) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs__["postFetcher"])('/api/upload-signature', formData);
};

var ReportSignatures = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_report_components_lib_selectors__["e" /* makeMapStateToProps */])({ getNewId: __WEBPACK_IMPORTED_MODULE_3_report_components_lib_selectors__["f" /* getNewId */], getItems: __WEBPACK_IMPORTED_MODULE_3_report_components_lib_selectors__["c" /* getItems */], getItems2: __WEBPACK_IMPORTED_MODULE_3_report_components_lib_selectors__["c" /* getItems */] })(function (_ref) {
  var getNewId = _ref.getNewId,
      getItems = _ref.getItems,
      getItems2 = _ref.getItems2;
  return function (_ref2) {
    var report = _ref2.report;
    return {
      reportSignatures: getItems(report.reportSignatures),
      newId: getNewId(report.reportSignatures),
      availableSignatures: report.availableSignatures,
      availableSignaturesArray: getItems2(report.availableSignatures),
      newSignatureAction: __WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["w" /* addAvailableSignature */],
      hidePermissionsSettings: true,
      getResource: __WEBPACK_IMPORTED_MODULE_4__lib__["h" /* getResource */],
      uploadFetcher: uploadFetcher
    };
  };
}), function (dispatch) {
  return {
    update: function update(signature) {
      var r = dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["x" /* updateReportSignature */])(signature));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["j" /* autoSaveUpdate */])(signature, autoSaveType));
      return r;
    },
    addNew: function addNew(signature, index) {
      var r = dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["y" /* addReportSignature */])(signature, { index: index }));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["j" /* autoSaveUpdate */])(signature, autoSaveType));
      return r;
    },
    confirmRemoveItem: function confirmRemoveItem(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["k" /* autoSaveRemove */])(id, autoSaveType));
    },
    remove: function remove(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["z" /* deleteReportSignature */])(id));
    },
    updateOrder: function updateOrder(newOrder) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["A" /* updateReportSignaturesOrder */])(newOrder));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["l" /* autoSaveOrder */])(newOrder, autoSaveType));
    }
  };
})(__WEBPACK_IMPORTED_MODULE_1_report_components__["i" /* Signatures */]);

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_report_components__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__ = __webpack_require__(8);




var autoSaveType = { type: "reportTitle" };

var ReportTitle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (_ref) {
  var report = _ref.report;
  return {
    reportTitle: report.reportTitle,
    language: report.reportSettings.layout.language,
    dateFormat: report.reportSettings.layout.dateFormat
  };
}, function (dispatch) {
  return {
    update: function update(props) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["J" /* updateReportTitle */])(props));
    },
    saveUpdate: function saveUpdate(item) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_reducers__["j" /* autoSaveUpdate */])(item, autoSaveType));
    }
  };
})(__WEBPACK_IMPORTED_MODULE_1_report_components__["m" /* Title */]);

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return required; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return minLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return confirmPasswords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return confirmEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return emailValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return responseFailure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs__);



var erorrsOrSuccess = function erorrsOrSuccess(success, errors) {
  return Object.keys(errors).length ? { errors: errors } : success;
};

var required = function required(s, k) {
  return !s && 'Required field(s).';
};

var minLength = function minLength(n) {
  return function (s, k) {
    return s && s.length < n && 'Field must have at least ' + n + ' characters.';
  };
};

var confirmPasswords = function confirmPasswords(passwordKey) {
  return function (confirm, k, props) {
    return props[passwordKey] !== confirm && 'Passwords didn\'t match, try again.';
  };
};
var confirmEmail = function confirmEmail(passwordKey) {
  return function (confirm, k, props) {
    return props[passwordKey] !== confirm && 'Email didn\'t match, try again.';
  };
};

var emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
var emailValidation = function emailValidation(s, k) {
  return !emailRegex.test(s) && 'Invalid e-mail.';
};

var buildValidation = function buildValidation(validations, transform) {
  return function (props) {
    return erorrsOrSuccess({ success: transform ? transform(props) : props }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_icepath__["ice"])(validations).map(function (v, k) {
      return [].concat(v).map(function (fn) {
        return fn(props[k], k, props);
      }).filter(function (_) {
        return _;
      });
    }).filter(function (v, k) {
      return v.length;
    }).value());
  };
};

var responseFailure = function responseFailure(form, fn) {
  return function (_, _ref) {
    var response = _ref.response;

    var setErrors = form.connector.setErrors;
    if (response) {
      var error = fn(response);
      if (error) {
        setErrors(error);
      } else {
        setErrors({ "": [__WEBPACK_IMPORTED_MODULE_1_startlibs__["AJAX_ERROR"]] });
      }
    }
  };
};

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DOBAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SharingComponents__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(15);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var DOBAuth = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["withForm"])(), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withToggles"])('loading'), _dec(_class = _dec2(_class = function (_React$PureComponent) {
  _inherits(DOBAuth, _React$PureComponent);

  function DOBAuth() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DOBAuth);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DOBAuth.__proto__ || Object.getPrototypeOf(DOBAuth)).call.apply(_ref, [this].concat(args))), _this), _this.preValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_validation__["a" /* buildValidation */])({
      patientDOB: function patientDOB(v) {
        return !new Date(v).getTime() && "Invalid date.";
      }
    }), _this.onSubmit = function (e) {
      e.preventDefault();
      if (!_this.props.form.connector.validate()) {
        return;
      }
      _this.props.loading.open();
      var patientDOB = _this.props.form.properties.patientDOB.split(/\//);
      var patientParam = patientDOB ? 'dobCheck=' + window.encodeURIComponent(patientDOB[2] + patientDOB[0] + patientDOB[1]) : '';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["j" /* simpleFetch */])('/api/share/download/' + _this.props.uuid + '?' + patientParam, { method: "HEAD" }).then(function (result) {
        return _this.props.onSuccess(patientParam);
      }).catch(function (e) {
        _this.props.loading.close();
        if (e && e.status === 403) {
          _this.props.form.connector.setErrors({ 'patientDOB': ['Invalid date of birth. Check the date formatting and the patient records\' date of birth and try again'] });
        } else {
          _this.props.expired();
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DOBAuth, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          form = _props.form,
          loading = _props.loading,
          studyInfo = _props.studyInfo;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__SharingComponents__["e" /* CardContent */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            'Shared study details'
          ),
          studyInfo.patientName && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'patient-name' },
            'Patient: ',
            studyInfo.patientName
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["Form"],
            {
              form: form,
              preValidation: this.preValidation,
              onSubmit: this.onSubmit
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["TextInput"], {
              form: form,
              path: 'patientDOB',
              constraint: '##/##/####',
              label: 'Insert patient\u2019s date of birth to access the study:',
              placeholder: 'MM/DD/YYYY'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"],
              { isLoading: loading.isOpen, type: 'submit', highlight: true },
              'Download study'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["Errors"], { form: form })
          )
        )
      );
    }
  }]);

  return DOBAuth;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class) || _class);

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DownloadStudyPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DOBAuth__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SharingComponents__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_dicom_icon_svg__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_dicom_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__public_dicom_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(15);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var DownloadStudyPage = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withToggles"])('loading'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (_ref) {
  var user = _ref.user;
  return { user: user };
}), _dec(_class = _dec2(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["withRouter"])(_class = function (_React$PureComponent) {
  _inherits(DownloadStudyPage, _React$PureComponent);

  function DownloadStudyPage() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, DownloadStudyPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = DownloadStudyPage.__proto__ || Object.getPrototypeOf(DownloadStudyPage)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { checked: false }, _this.check = function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["j" /* simpleFetch */])('/api/share/check/' + _this.getUUID()).then(function (_ref3) {
        var studyInfo = _ref3.studyInfo,
            sharingOptions = _ref3.sharingOptions,
            fileInfo = _ref3.fileInfo;

        _this.setState({ status: 'available', sharingOptions: sharingOptions, studyInfo: studyInfo, fileInfo: fileInfo });
      }).catch(function (_ref4) {
        var status = _ref4.status,
            rest = _objectWithoutProperties(_ref4, ['status']);

        if (status === 424) {
          _this.setState({ status: 'uploading' });
          setTimeout(_this.check, 30 * 1000);
        } else {
          _this.setState({ status: 'error' });
        }
      });
    }, _this.checkAndDownload = function () {
      _this.setState({ status: 'download' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["j" /* simpleFetch */])('/api/share/download/' + _this.getUUID(), { method: "HEAD" }).then(_this.download).catch(_this.expired);
    }, _this.download = function (patienParam) {
      _this.setState({ status: 'finished' });
      var link = document.createElement('a');
      link.href = '/api/share/download/' + _this.getUUID() + '?' + patienParam;
      link.setAttribute('download', '');
      link.click();
    }, _this.getUUID = function () {
      return _this.props.match.params.uuid;
    }, _this.expired = function () {
      return _this.setState({ status: 'error' });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DownloadStudyPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.phiAuthenticationActive) {
        this.check();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var user = this.props.user;
      var _state = this.state,
          status = _state.status,
          studyInfo = _state.studyInfo,
          sharingOptions = _state.sharingOptions;
      //const status = 'finished'
      //const studyInfo = {patientName:'Bolsonaro'}
      //const sharingOptions = {dobCheck: true}

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__SharingComponents__["a" /* PageContainer */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'navbar' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'navbar-content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'left-container logo-container' },
              user.id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Link"],
                { to: '/', className: 'logo' },
                'Horos Cloud'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Link"],
                { skipTo: '/', className: 'logo' },
                'Horos Cloud'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__SharingComponents__["b" /* PageCard */],
          null,
          status && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__SharingComponents__["c" /* CardIcon */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: 'Dicom icon', src: __WEBPACK_IMPORTED_MODULE_6__public_dicom_icon_svg___default.a })
          ),
          !status ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__App__["b" /* LoadingUser */], null) : status === 'uploading' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StudyUploading, null) : status === 'error' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StudyNotFound, null) : status === 'finished' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ThankYou, { studyInfo: studyInfo }) : (status === 'available' || status === 'download') && (sharingOptions.dobCheck ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DOBAuth__["a" /* DOBAuth */], { studyInfo: studyInfo, uuid: this.getUUID(), onSuccess: this.download, expired: this.expired }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConfirmDownload, { studyInfo: studyInfo, download: this.checkAndDownload, isDownloading: status === 'download' }))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__SharingComponents__["d" /* PageFooter */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: 'https://www.horosproject.org/' },
            'Horos'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: 'https://horoscloud.io/' },
            'Horos Cloud'
          )
        )
      );
    }
  }]);

  return DownloadStudyPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class) || _class) || _class);

var ConfirmDownload = function ConfirmDownload(_ref5) {
  var studyInfo = _ref5.studyInfo,
      download = _ref5.download,
      isDowloading = _ref5.isDowloading;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__SharingComponents__["e" /* CardContent */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      null,
      'Shared study details'
    ),
    studyInfo.patientName && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'patient-name' },
      'Patient: ',
      studyInfo.patientName
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'main-text download-text' },
      'Click below to download the study.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
      { isLoading: isDowloading, highlight: true, onClick: download },
      'Download study'
    )
  );
};

var StudyNotFound = function StudyNotFound() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__SharingComponents__["e" /* CardContent */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      { className: 'error-title' },
      'Study expired or non-existent'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'main-text' },
      'Study sharing links expire in 48 hours for security reasons.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Plesae check if this is the correct link or reach out to the person who shared this study with you and ask for them to sharing again.'
    )
  );
};

var StudyUploading = function StudyUploading() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__SharingComponents__["e" /* CardContent */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      null,
      'This study is still being uploaded'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SharingComponents__["f" /* DownloadLoading */], { size: 60, borderWidth: 8 }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'main-text' },
      'Please wait, or come back later.'
    )
  );
};

var ThankYou = function ThankYou(_ref6) {
  var studyInfo = _ref6.studyInfo,
      retry = _ref6.retry;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__SharingComponents__["e" /* CardContent */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      null,
      'Your download will begin shortly'
    ),
    studyInfo.patientName && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'patient-name' },
      'Patient: ',
      studyInfo.patientName
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SharingComponents__["g" /* SuccessIcon */], { icon: 'check' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'main-text' },
      'If your download has not started automatically, ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { onClick: retry, className: 'link' },
        'try again'
      ),
      '.'
    )
  );
};

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PasswordRecoveryFooter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PasswordRecovery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignInLayout__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var PasswordRecoveryContent = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["withForm"])(__WEBPACK_IMPORTED_MODULE_5_startlibs__["formFetch"]), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__["withToggles"])('successFeedback', 'isLoggingOut'), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(undefined, { logout: __WEBPACK_IMPORTED_MODULE_8__reducers__["h" /* logout */] }), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
  _inherits(PasswordRecoveryContent, _React$Component);

  function PasswordRecoveryContent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PasswordRecoveryContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PasswordRecoveryContent.__proto__ || Object.getPrototypeOf(PasswordRecoveryContent)).call.apply(_ref, [this].concat(args))), _this), _this.onFailure = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_validation__["d" /* responseFailure */])(_this.props.form, function (_ref2) {
      var message = _ref2.message,
          title = _ref2.title;
      return message === "Invalid e-mail, retry typing or sign up." && { email: [message] } || title === "Email address not registered" && { email: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          'No Horos Cloud account found using this e-mail. ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],
            { to: 'signUp' },
            'Sign up'
          ),
          ' or try using a different e-mail.'
        )] };
    }), _this.preValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_validation__["a" /* buildValidation */])({
      email: __WEBPACK_IMPORTED_MODULE_7__lib_validation__["g" /* emailValidation */]
    }, function (_) {
      return _.email;
    }), _this.onSuccess = function () {
      _this.props.isLoggingOut.open();
      _this.props.logout().catch(function () {
        return 0;
      }).then(function () {
        _this.props.successFeedback.open();
        _this.props.isLoggingOut.close();
        _this.props.form.connector.setValue('email', '');
      });
    }, _this.trySubmit = function (e) {
      e.preventDefault();
      _this.props.successFeedback.close();
      if (!_this.props.form.isLoading && !_this.props.isLoggingOut.isOpen) {
        _this.props.form.connector.submitProperties();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PasswordRecoveryContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          form = _props.form,
          isLoggingOut = _props.isLoggingOut,
          successFeedback = _props.successFeedback;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'opening-section' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Horos Cloud password recovery'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Fill in bellow and we\'ll send a recovery link to your e-mail'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["Form"],
          { url: '/api/account/reset-password/init', preValidation: this.preValidation,
            onFailure: this.onFailure,
            onSuccess: this.onSuccess,
            onSubmit: this.trySubmit,
            form: form
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["TextInput"], {
            tabIndex: 1,
            label: 'E-mail:',
            placeholder: 'example@email.com',
            form: form,
            path: 'email'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-actions sign-up-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"],
              { isLoading: form.isLoading || isLoggingOut.isOpen, type: 'submit', tabIndex: 1, className: 'highlight with-loader' },
              'Recover password'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["Errors"], { form: form }),
          successFeedback.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'successContainer' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Recovery e-mail sent successfully.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon icon-x', onClick: successFeedback.close })
            )
          )
        )
      );
    }
  }]);

  return PasswordRecoveryContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class) || _class) || _class);


function PasswordRecoveryFooter() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'signup-question' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      'Remember your password?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],
      { className: 'button outline', to: '/' },
      'Sign in'
    )
  );
}

var PasswordRecovery = function PasswordRecovery() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SignInLayout__["a" /* SignInLayout */], { Content: PasswordRecoveryContent, Footer: PasswordRecoveryFooter });
};

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RedefinePasswordFooter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RedefinePassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignInLayout__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SignUp__ = __webpack_require__(47);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var RedefinePasswordContent = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["withForm"])(__WEBPACK_IMPORTED_MODULE_5_startlibs__["formFetch"]), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(undefined, { getAccount: __WEBPACK_IMPORTED_MODULE_6__reducers__["d" /* getAccount */], setNotifications: __WEBPACK_IMPORTED_MODULE_6__reducers__["c" /* setNotifications */] }), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["withRouter"])(_class = _dec2(_class = function (_React$Component) {
  _inherits(RedefinePasswordContent, _React$Component);

  function RedefinePasswordContent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RedefinePasswordContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RedefinePasswordContent.__proto__ || Object.getPrototypeOf(RedefinePasswordContent)).call.apply(_ref, [this].concat(args))), _this), _this.onSuccess = function () {
      localStorage.setItem('hasLogged', 'true');
      _this.props.getAccount().then(function () {
        return _this.props.history.push("/");
      });
      _this.props.setNotifications(["Changes saved successfully"]);
    }, _this.getKey = function () {
      return _this.props.match.params.key;
    }, _this.preValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_validation__["a" /* buildValidation */])({
      confirmPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_validation__["e" /* confirmPasswords */])("password"),
      password: [__WEBPACK_IMPORTED_MODULE_8__lib_validation__["b" /* required */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_validation__["c" /* minLength */])(6)]
    }, function (_ref2) {
      var password = _ref2.password;
      return { key: _this.getKey(), newPassword: password };
    }), _this.onFailure = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_validation__["d" /* responseFailure */])(_this.props.form, function () {
      return 0;
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RedefinePasswordContent, [{
    key: 'render',
    value: function render() {
      var form = this.props.form;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'opening-section' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Define new password'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Enter and confirm your new password below'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["Form"],
          { form: form,
            onFailure: this.onFailure,
            preValidation: this.preValidation, url: '/api/account/reset-password/finish', onSuccess: this.onSuccess },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["TextInput"], {
            form: form,
            type: 'password',
            path: 'password',
            label: 'New password:',
            placeholder: 'Enter your new password'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["TextInput"], {
            form: form,
            type: 'password',
            path: 'confirmPassword',
            label: 'Confirm new password:',
            placeholder: 'Confirm your new password'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__SignUp__["b" /* FieldRequirements */],
            null,
            'Your password shall contain at least 6 characteres.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"],
              { type: 'submit', highlight: true, isLoading: form.isLoading },
              'Update and sign in'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["Errors"], { form: form })
        )
      );
    }
  }]);

  return RedefinePasswordContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class) || _class) || _class);


function RedefinePasswordFooter() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'signup-question' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      'Remember your password?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],
      { className: 'button outline', to: '/' },
      'Sign in'
    )
  );
};

var RedefinePassword = function RedefinePassword() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SignInLayout__["a" /* SignInLayout */], { Content: RedefinePasswordContent, Footer: RedefinePasswordFooter });
};

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_icepath__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__signin_SignUp__ = __webpack_require__(47);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class;

var _templateObject = _taggedTemplateLiteral(['\n  .card {\n    padding: 2rem 2rem 3rem;\n  }\n  h3 {\n    position: relative;\n    font-size: 16px;\n    ', ' {\n      color: rgba(0,0,0,0.4);\n      font-size: 21px;\n      position: absolute;\n    }\n    .title {\n      padding-left: 2rem;\n    }\n  }\n  h4 {\n    font-size: 15px;\n    margin-bottom: .5rem;\n  }\n'], ['\n  .card {\n    padding: 2rem 2rem 3rem;\n  }\n  h3 {\n    position: relative;\n    font-size: 16px;\n    ', ' {\n      color: rgba(0,0,0,0.4);\n      font-size: 21px;\n      position: absolute;\n    }\n    .title {\n      padding-left: 2rem;\n    }\n  }\n  h4 {\n    font-size: 15px;\n    margin-bottom: .5rem;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-grow: 1;\n  padding-top: 1rem;\n}'], ['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-grow: 1;\n  padding-top: 1rem;\n}']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 1rem;\n  p {\n    margin-bottom: 0;\n  }\n  .heading-text {\n    flex-grow: 1;\n  }\n  ', ' {\n    flex-basis: 20rem;\n    margin-left: 2rem;\n  }\n  @media (max-width: 600px) {\n    .heading-text {\n      flex-shrink: 1;\n      flex-basis: 0;\n    }\n  }\n  @media (max-width: 475px) {\n    ', ' {\n      flex-basis: 14rem;\n    }\n  }\n  @media (max-width: 380px) {\n    flex-wrap: wrap;\n    .heading-text {\n      flex-grow: 1;\n      flex-basis: 100%;\n    }\n    ', ' {\n      flex-basis: 100%;\n      margin-left: 0;\n      margin-top: 1rem;\n    }\n  }\n'], ['\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 1rem;\n  p {\n    margin-bottom: 0;\n  }\n  .heading-text {\n    flex-grow: 1;\n  }\n  ', ' {\n    flex-basis: 20rem;\n    margin-left: 2rem;\n  }\n  @media (max-width: 600px) {\n    .heading-text {\n      flex-shrink: 1;\n      flex-basis: 0;\n    }\n  }\n  @media (max-width: 475px) {\n    ', ' {\n      flex-basis: 14rem;\n    }\n  }\n  @media (max-width: 380px) {\n    flex-wrap: wrap;\n    .heading-text {\n      flex-grow: 1;\n      flex-basis: 100%;\n    }\n    ', ' {\n      flex-basis: 100%;\n      margin-left: 0;\n      margin-top: 1rem;\n    }\n  }\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }














var SettingsWrapper = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Icon"]);

var CardFooter = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject2);

var ChangePassHeading = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject3, __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"], __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"], __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"]);

var EMPTY_FORM = { password: '' };

var AccountSettings = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["withForm"])(__WEBPACK_IMPORTED_MODULE_4_startlibs__["formFetch"]), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(function (_ref) {
  var user = _ref.user;
  return { user: user };
}, { setNotifications: __WEBPACK_IMPORTED_MODULE_6__reducers__["c" /* setNotifications */] }), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__["withToggles"])('redirect', 'sendingEmailAccount', 'sendingEmailReports', 'confirmDeleteDialog', 'sendingResetPassword'), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
  _inherits(AccountSettings, _React$Component);

  function AccountSettings() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, AccountSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = AccountSettings.__proto__ || Object.getPrototypeOf(AccountSettings)).call.apply(_ref2, [this].concat(args))), _this), _this.preValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_validation__["a" /* buildValidation */])({
      newPassword: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_validation__["c" /* minLength */])(6), __WEBPACK_IMPORTED_MODULE_8__lib_validation__["b" /* required */]],
      confirmPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_validation__["e" /* confirmPasswords */])('newPassword')
    }, function (_ref3) {
      var newPassword = _ref3.newPassword,
          oldPassword = _ref3.oldPassword;
      return { newPassword: newPassword, oldPassword: oldPassword };
    }), _this.onSuccess = function () {
      _this.props.setNotifications(["Changes saved successfully"]);
      _this.props.redirect.open();
    }, _this.onFailure = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_validation__["d" /* responseFailure */])(_this.props.form, function (response) {
      return response.title === "Incorrect password" && { oldPassword: ["Incorrect current password, please retry typing it."] };
    }), _this.openDeleteAccount = function () {
      _this.props.sendingEmailAccount.open();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs__["postFetcher"])('/api/account/data-cleanup/init', '').then(function (_ref4) {
        var errors = _ref4.errors;

        _this.props.sendingEmailAccount.close();
        if (!errors) {
          _this.props.confirmDeleteDialog.open("account");
        }
      }).catch(function (e) {
        return _this.onFailure;
      });
    }, _this.openDeleteReports = function () {
      _this.props.sendingEmailReports.open();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs__["postFetcher"])('/api/account/report-cleanup/init', '').then(function (_ref5) {
        var errors = _ref5.errors;

        _this.props.sendingEmailReports.close();
        if (!errors) {
          _this.props.confirmDeleteDialog.open("reports");
        }
      });
    }, _this.resetPassword = function () {
      _this.props.sendingResetPassword.open();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs__["postFetcher"])("/api/account/reset-password/init", _this.props.user.email).then(function () {
        _this.props.sendingResetPassword.close();
        _this.props.setNotifications(["Password reset email sent successfully."]);
      }).catch(function () {
        _this.props.sendingResetPassword.close();
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AccountSettings, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          form = _props.form,
          redirect = _props.redirect,
          sendingEmailAccount = _props.sendingEmailAccount,
          sendingResetPassword = _props.sendingResetPassword,
          sendingEmailReports = _props.sendingEmailReports,
          confirmDeleteDialog = _props.confirmDeleteDialog;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content edit-profile' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"].Link,
            { className: 'return-home-button', icon: 'arrow-left', to: '/' },
            'Home'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Account settings'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'profile-menu' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Link"],
              { className: 'button nav-tab', to: '/profile' },
              'Profile'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Link"],
              { className: 'button nav-tab active', skipTo: '/account-settings' },
              'Account settings'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Link"],
              { className: 'button nav-tab', to: '/workstations' },
              'Manage workstations'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          SettingsWrapper,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            ChangePassHeading,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'heading-text' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                null,
                'Change password'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'To change your password fill in the fields below.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
              { icon: 'email', isLoading: sendingResetPassword.isOpen, onClick: this.resetPassword },
              'Forgot password? Reset by email'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'card' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["Form"],
              {
                form: form,
                defaultProperties: EMPTY_FORM,
                preValidation: this.preValidation,
                url: '/api/account/change-password',
                onFailure: this.onFailure,
                onSuccess: this.onSuccess
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
                form: form,
                type: 'password',
                path: 'oldPassword',
                label: 'Old password:',
                placeholder: 'Enter your old password'
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["SplitColumnsContainer"],
                { viewportMinWidth: 610 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
                  form: form,
                  type: 'password',
                  path: 'newPassword',
                  label: 'New password:',
                  placeholder: 'Enter your new password'
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
                  form: form,
                  type: 'password',
                  path: 'confirmPassword',
                  label: 'Confirm new password:',
                  placeholder: 'Confirm your new password'
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11__signin_SignUp__["b" /* FieldRequirements */],
                null,
                'Your password shall contain at least 6 characteres.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["Errors"], { form: form }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                CardFooter,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
                    { onClick: function onClick() {
                        form.connector.setValues(function (i) {
                          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_icepath__["ice"])({});
                        });form.connector.setHasChanged(false);
                      }, disabled: !form.hasChanged },
                    'Cancel'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
                    { type: 'submit', disabled: !form.hasChanged, isLoading: form.isLoading, highlight: true },
                    'Change password'
                  )
                )
              )
            ),
            redirect.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: '/' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Icon"], { icon: 'warning' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'title' },
              'Delete account data'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'For deleting your account or its reports data, read carefully and advance below.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'card' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              'Requesting data deletion'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'You will receive an email to confirm your request before we perform the data deletion.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              CardFooter,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
                { onClick: this.openDeleteAccount, isLoading: sendingEmailAccount.isOpen, hover: 'alert' },
                'Delete account and reports'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
                { onClick: this.openDeleteReports, isLoading: sendingEmailReports.isOpen, hover: 'alert' },
                'Delete all reports'
              )
            )
          ),
          confirmDeleteDialog.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"],
            {
              title: 'Check your email to confirm deletion',
              closeDialog: confirmDeleteDialog.close },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"].Content,
              { icon: 'warning' },
              confirmDeleteDialog.isOpen === "account" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'strong',
                    null,
                    'You have requested to delete your account and all your reports. '
                  ),
                  'Please check your email and confirm your request to proceed. The confirmation link expires in 1h if not used.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'Ignore the email if you don\'t want to proceed with the account and reports deletion.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'Be aware that the deletion of account and reports is irreversible once you confirm the request.'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'strong',
                    null,
                    'You have requested to delete all reports in your account. '
                  ),
                  'Please check your email and confirm your request to proceed. The confirmation link expires in 1h if not used.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'Ignore the email if you don\'t want to proceed with the reports deletion.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'Be aware that the deletion of reports is irreversible once you confirm the request.'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"].Footer,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
                { onClick: confirmDeleteDialog.close },
                'Close'
              )
            )
          )
        )
      );
    }
  }]);

  return AccountSettings;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class) || _class) || _class);

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfirmDeleteAccount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkout_CheckoutComponents__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_report_components_src_components_timer__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducers__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class;

var _templateObject = _taggedTemplateLiteral(['\n  h1 {\n    display: flex;\n    align-items: center;\n    ', ' {\n      font-size: 32px;\n      color: rgba(0,0,0,0.3);\n      margin-right: .5rem;\n    }\n  }\n  h3 {\n    color: rgba(0,0,0,0.5);\n    font-size: 16px;\n    margin-top: 2rem;\n  }\n  ', ' {\n    margin-top: 1rem;\n    margin-bottom: 0;\n  }\n  &.content.edit-profile .card.account-card {\n    margin-bottom: 1rem;\n  }\n  .account-card {\n    padding: 2rem;\n    display: flex;\n    flex-wrap: wrap;\n    .user-avatar {\n      width: 9rem;\n      height: 9rem;\n      border-radius: 5px;\n      background: rgba(0,0,0,0.1);\n      background: url(\'/public/user-avatar.png\');\n      background-size: cover;\n      margin-right: 1rem;\n    }\n    .account-details {\n      color: rgba(0,0,0,0.6);\n      h4 {\n        font-size: 14px;\n        margin-bottom: 0;\n      }\n      flex-grow: 1;\n      ul {\n        list-style-type: disc;\n        padding-left: 1.5rem;\n      }\n      .help-text {\n        font-size: 12px;\n        line-height: 1.2;\n        color: rgba(0,0,0,0.5);\n        display: block;\n        margin-top: .75rem;\n      }\n    }\n    .actions {\n      width: 196px;\n      margin-left: 10px;\n      position: relative;\n      .forgot-pass {\n        position: absolute;\n        top: 1px;\n        right: 0;\n        color: rgba(0,0,0,0.4);\n      }\n      ', ' {\n        width: 100%;\n      }\n    }\n    @media (max-width: 670px) {\n      .user-avatar {\n        display: none;\n      }\n    }\n    @media (max-width: 550px) {\n      .actions {\n        width: 100%;\n        margin-top: 1rem;\n        margin-left: 0;\n      }\n    }\n  }\n'], ['\n  h1 {\n    display: flex;\n    align-items: center;\n    ', ' {\n      font-size: 32px;\n      color: rgba(0,0,0,0.3);\n      margin-right: .5rem;\n    }\n  }\n  h3 {\n    color: rgba(0,0,0,0.5);\n    font-size: 16px;\n    margin-top: 2rem;\n  }\n  ', ' {\n    margin-top: 1rem;\n    margin-bottom: 0;\n  }\n  &.content.edit-profile .card.account-card {\n    margin-bottom: 1rem;\n  }\n  .account-card {\n    padding: 2rem;\n    display: flex;\n    flex-wrap: wrap;\n    .user-avatar {\n      width: 9rem;\n      height: 9rem;\n      border-radius: 5px;\n      background: rgba(0,0,0,0.1);\n      background: url(\'/public/user-avatar.png\');\n      background-size: cover;\n      margin-right: 1rem;\n    }\n    .account-details {\n      color: rgba(0,0,0,0.6);\n      h4 {\n        font-size: 14px;\n        margin-bottom: 0;\n      }\n      flex-grow: 1;\n      ul {\n        list-style-type: disc;\n        padding-left: 1.5rem;\n      }\n      .help-text {\n        font-size: 12px;\n        line-height: 1.2;\n        color: rgba(0,0,0,0.5);\n        display: block;\n        margin-top: .75rem;\n      }\n    }\n    .actions {\n      width: 196px;\n      margin-left: 10px;\n      position: relative;\n      .forgot-pass {\n        position: absolute;\n        top: 1px;\n        right: 0;\n        color: rgba(0,0,0,0.4);\n      }\n      ', ' {\n        width: 100%;\n      }\n    }\n    @media (max-width: 670px) {\n      .user-avatar {\n        display: none;\n      }\n    }\n    @media (max-width: 550px) {\n      .actions {\n        width: 100%;\n        margin-top: 1rem;\n        margin-left: 0;\n      }\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  text-align: center;\n  display: flex;\n  padding: 3.5rem 2rem;\n  justify-content: center;\n  align-items: center;\n  background: rgba(0,0,0,0.1);\n  border-radius: 5px;\n  ', ' {\n    margin-right: 1rem;\n  }\n'], ['\n  text-align: center;\n  display: flex;\n  padding: 3.5rem 2rem;\n  justify-content: center;\n  align-items: center;\n  background: rgba(0,0,0,0.1);\n  border-radius: 5px;\n  ', ' {\n    margin-right: 1rem;\n  }\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

















var ConfirmDeletionPage = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Icon"], __WEBPACK_IMPORTED_MODULE_5__checkout_CheckoutComponents__["e" /* InfoBox */], __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"]);

var LoadingEmail = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2, __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Loading"]);

var ConfirmDeleteAccount = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["withForm"])(__WEBPACK_IMPORTED_MODULE_7_startlibs__["formFetch"]), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_startlibs_lib_hocs__["fetchConnect"])(function (_ref) {
  var user = _ref.user;
  return { user: user };
}, { setNotifications: __WEBPACK_IMPORTED_MODULE_12__reducers__["c" /* setNotifications */], logout: __WEBPACK_IMPORTED_MODULE_12__reducers__["h" /* logout */] }, 'stripe'), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_startlibs_lib_hocs__["withToggles"])('isRouting', 'sendingResetPassword', 'resetPasswordDialog'), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* withRouter */])(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_startlibs_lib_hocs__["withRouteTo"])(_class = _dec2(_class = _dec3(_class = function (_React$PureComponent) {
  _inherits(ConfirmDeleteAccount, _React$PureComponent);

  function ConfirmDeleteAccount() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ConfirmDeleteAccount);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ConfirmDeleteAccount.__proto__ || Object.getPrototypeOf(ConfirmDeleteAccount)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {}, _this.onFailure = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_validation__["d" /* responseFailure */])(_this.props.form, function (_ref3) {
      var status = _ref3.status,
          detail = _ref3.detail;
      return detail === "Bad credentials" && { 'password': ['Invalid password'] } || (status === 403 || status === 404) && { '': ['This deletion URL is not valid. Try requesting for deletion again from account settings.'] } || status === 409 && { '': ['This deletion link has expired. Confirm deletion links expire in 1h for security reasons. You can request for deletion again from account settings.'] } || { '': [__WEBPACK_IMPORTED_MODULE_7_startlibs__["AJAX_ERROR"]] };
    }), _this.getAvatarBackground = function () {
      return { backgroundImage: 'url("' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* getResource */])(_this.props.user.picture || '/public/user-avatar.png') + '")' };
    }, _this.deleteReportsSuccess = function () {
      _this.props.isRouting.open();
      _this.props.setNotifications(['All reports successfully deleted']);
      _this.props.routeTo('/');
    }, _this.deleteAccountSuccess = function () {
      _this.props.isRouting.open();
      _this.props.logout().then(function () {
        return _this.props.history.push('/account-deleted');
      });
    }, _this.resetPassword = function () {
      _this.props.sendingResetPassword.open();
      _this.props.resetPasswordDialog.open();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs__["postFetcher"])("/api/account/reset-password/init", _this.props.user.email).then(function () {
        _this.props.sendingResetPassword.close();
      }).catch(function () {
        _this.props.sendingResetPassword.close();
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ConfirmDeleteAccount, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs__["getFetcher"])('/api/account/' + (this.props.isReportCleanup ? "report" : "data") + '-cleanup/verify/' + this.props.match.params.token)
      // Promise.resolve({})
      .then(function () {
        return _this2.setState({ verified: true });
      }).catch(function (e) {
        return _this2.props.history.push('/error/deletionExpired');
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs__["getFetcher"])('/api/reports', { size: 1, page: 0, sort: 'last_Saved,desc' }).then(function (_ref4) {
        var totalElements = _ref4.totalElements;
        return _this2.setState({ totalReports: totalElements });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isReportCleanup = _props.isReportCleanup,
          sendingResetPassword = _props.sendingResetPassword,
          resetPasswordDialog = _props.resetPasswordDialog,
          form = _props.form,
          isRouting = _props.isRouting,
          user = _props.user,
          customer = _props.stripe.customer,
          match = _props.match;
      var _state = this.state,
          totalReports = _state.totalReports,
          verified = _state.verified;

      if (totalReports === undefined || !verified) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__App__["b" /* LoadingUser */], null);
      }
      var subscription = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* normalizeSubscription */])(customer.subscriptions && customer.subscriptions.data[0]);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        ConfirmDeletionPage,
        { className: 'content edit-profile' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"].Link,
          { className: 'return-home-button', icon: 'arrow-left', to: '/' },
          'Home'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Icon"], { icon: 'warning' }),
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              'Confirm ',
              isReportCleanup ? 'data' : 'account',
              ' deletion'
            )
          )
        ),
        isReportCleanup ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            'You are about to delete all reports in your Horos Cloud account.'
          ),
          ' Please carefully review the details bellow and click on \u201CDelete all reports\u201D to proceed with the deletion.'
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            'You are about to delete your Horos Cloud account and all its data. '
          ),
          'Please carefully review the details bellow and click \u201CConfirm deletion\u201D to delete the account.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          'Account details'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'card account-card' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'user-avatar', style: this.getAvatarBackground() }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'account-details' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              user.firstName,
              ' ',
              user.lastName,
              '\u2019s account'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                null,
                user.email
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                null,
                'Member since ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_report_components_src_components_timer__["a" /* Timer */], { language: 'en', dateFormat: 'LL dd, yyyy', noHours: true,
                  time: new Date(customer.created * 1000) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                null,
                subscription.status === 'active' ? 'Active Horos Cloud subscription' : subscription.status === 'trialing' ? 'Account on Horos Cloud Trial' : 'No Horos Cloud subscription'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                null,
                totalReports,
                ' reports on Horos Cloud'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'help-text' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'Once confirmed, this action is irreversible.'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["Form"],
              {
                form: form,
                onSuccess: isReportCleanup ? this.deleteReportsSuccess : this.deleteAccountSuccess,
                onFailure: this.onFailure,
                preValidation: function preValidation(_ref5) {
                  var password = _ref5.password;
                  return { success: { password: password, key: match.params.token } };
                },
                alwaysSave: true,
                url: isReportCleanup ? '/api/account/report-cleanup/finish/' : '/api/account/data-cleanup/finish/'
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
                form: form,
                type: 'password',
                label: 'Password:',
                path: 'password',
                autocomplete: 'off',
                placeholder: 'Enter password'
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { onClick: this.resetPassword, className: 'link forgot-pass' },
                'Forgot password?'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
                { type: 'submit', isLoading: form.isLoading || isRouting.isOpen, alert: true, icon: 'warning' },
                isReportCleanup ? 'Delete all reports' : 'Confirm deletion'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["Errors"], { form: form }),
        subscription.status === 'active' && !isReportCleanup && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__checkout_CheckoutComponents__["e" /* InfoBox */],
          { gray: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Your active Horos Cloud subscription will be canceled upon account deletion, meaning no more charges will be made to this account\u2019s credit card unless you choose to reactivate it. Payments already made are not refundable.'
          )
        ),
        resetPasswordDialog.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"],
          {
            title: 'Sending password reset email'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"].Content,
            null,
            sendingResetPassword.isOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              LoadingEmail,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Loading"], null),
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Loading...'
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'We\'ve just sent you an email for defining a new password. '
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Check your email and click the link shared there to redefine your password. If you do not wish to redefine your password, just ignore the email and nothing will be changed.'
              )
            )
          ),
          !sendingResetPassword.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
              { onClick: resetPasswordDialog.close },
              'Close'
            )
          )
        )
      );
    }
  }]);

  return ConfirmDeleteAccount;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class) || _class) || _class) || _class) || _class);

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreditCardUpdate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_little_loader__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_little_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_little_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_StripeConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__checkout_CheckoutComponents__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_icepath__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__checkout_CaptchaUtils__ = __webpack_require__(46);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var CreditCardUpdate = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["withForm"])(), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react_redux__["connect"])(undefined, { setNotifications: __WEBPACK_IMPORTED_MODULE_10__reducers__["c" /* setNotifications */] }), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_hocs__["withToggles"])('loading'), _dec(_class = _dec2(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_hocs__["withRouteTo"])(_class = _dec3(_class = function (_React$PureComponent) {
  _inherits(CreditCardUpdate, _React$PureComponent);

  function CreditCardUpdate() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CreditCardUpdate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreditCardUpdate.__proto__ || Object.getPrototypeOf(CreditCardUpdate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.cardErrors = {
      cardCvc: { message: 'Your card\'s security code is incomplete.' },
      cardExpiry: { message: 'Your card\'s expiration date is incomplete.' },
      card: { message: 'Your card number is incomplete.' }
    }, _this.preValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_validation__["a" /* buildValidation */])({
      cardholder: __WEBPACK_IMPORTED_MODULE_9__lib_validation__["b" /* required */],
      country: __WEBPACK_IMPORTED_MODULE_9__lib_validation__["b" /* required */],
      zipCode: [__WEBPACK_IMPORTED_MODULE_9__lib_validation__["b" /* required */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_validation__["c" /* minLength */])(5)]
    }), _this.captchaRef = { current: null }, _this.loadStripe = function () {
      return window.Stripe ? Promise.resolve(window.Stripe) : new Promise(function (res, rej) {
        return __WEBPACK_IMPORTED_MODULE_4_little_loader___default()('https://js.stripe.com/v3/', function (err) {
          if (err) {
            rej();
          }
          res(window.Stripe);
        });
      });
    }, _this.stripeResult = null, _this.doSubmit = function (captchaToken) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs__["postFetcher"])('/api/update-stripe-token', {
        token: _this.stripeResult.token.id,
        captchaToken: captchaToken
      }, { method: 'PUT' }).then(function () {
        _this.props.setNotifications('Credit card successfully updated');
        _this.props.routeTo('/billing');
      }).catch(function (e) {
        _this.props.loading.close();
        _this.props.form.connector.setErrors({ "card": [e && e.errorResponse ? e.errorResponse.detail || e.errorResponse.title : __WEBPACK_IMPORTED_MODULE_7_startlibs__["AJAX_ERROR"]] });
      });
    }, _this.handleSubmit = function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          loading = _this$props.loading,
          form = _this$props.form;
      var stripe = _this.state.stripe;

      var validated = _this.preValidation(form.properties, {});
      var cardErrors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_icepath__["ice"])(_this.cardErrors).filter(function (v) {
        return v;
      }).map(function (v) {
        return [v.message];
      }).value();
      var stripeValidation = Object.keys(cardErrors).length ? stripe.createToken(_this.card).then(function (result) {
        return { card: [result.error.message] };
      }) : Promise.resolve({});

      if (validated.errors) {
        stripeValidation.then(function (stripeErrors) {
          return form.connector.setErrors(_extends({}, validated.errors, cardErrors));
        });
        return;
      }
      loading.open();
      var values = form.properties;
      stripe.createToken(_this.card, {
        address_zip: values.zipCode,
        address_country: values.country,
        name: values.cardholder
      }).then(function (stripeResult) {
        if (stripeResult.error) {
          // Inform the customer that there was an error.
          if (stripeResult.error) {
            form.connector.setErrors({ card: [stripeResult.error.message] });
          } else {
            form.connector.setErrors({ form: [__WEBPACK_IMPORTED_MODULE_7_startlibs__["AJAX_ERROR"]] });
          }
          loading.close();
        } else {
          // Send the token to your server.
          _this.stripeResult = stripeResult;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__checkout_CaptchaUtils__["b" /* executeCaptcha */])(values);
        }
      }).catch(function (e) {
        loading.close();
        form.connector.setErrors({ form: [__WEBPACK_IMPORTED_MODULE_7_startlibs__["AJAX_ERROR"]] });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CreditCardUpdate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      Promise.all([this.loadStripe(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__checkout_CaptchaUtils__["a" /* waitCaptcha */])(function (token) {
        return _this2.doSubmit(token);
      }, this.captchaRef)]).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            Stripe = _ref3[0],
            captcha = _ref3[1];

        return _this2.setState({ stripe: Stripe(__WEBPACK_IMPORTED_MODULE_5__config_StripeConfig__["a" /* STRIPE_KEY */]) });
      });
      window.scroll(0, 0);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps, oldState) {
      var _this3 = this;

      if (oldState.stripe !== this.state.stripe) {
        var elements = this.state.stripe.elements();
        var style = {
          base: {
            color: '#3c3c3c',
            lineHeight: '18px',
            fontFamily: '"Open Sans", sans-serif',
            fontSize: '14px',
            '::placeholder': {
              color: 'rgba(0,0,0,0.35)'
            }
          },
          invalid: {
            color: '#C3282D',
            iconColor: '#fa755a'
          }
        };

        var cardExpiry = elements.create('cardExpiry', { style: style });
        cardExpiry.mount('#card-expiry-element');
        cardExpiry.on('change', function (_ref4) {
          var error = _ref4.error;

          _this3.cardModified = true;
          _this3.cardErrors = _extends({}, _this3.cardErrors, { cardExpiry: error });
        });

        var cardCvc = elements.create('cardCvc', { style: style });
        cardCvc.mount('#card-cvc-element');
        cardCvc.on('change', function (_ref5) {
          var error = _ref5.error;

          _this3.cardModified = true;
          _this3.cardErrors = _extends({}, _this3.cardErrors, { cardCvc: error });
        });

        this.card = elements.create('cardNumber', { style: style });
        this.card.on('change', function (event) {
          _this3.setState({ cardBrand: event.brand });
          _this3.cardModified = true;
          _this3.cardErrors = _extends({}, _this3.cardErrors, { card: event.error });
        });
        this.card.mount('#card-element');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          form = _props.form,
          loading = _props.loading;
      var cardBrand = this.state.cardBrand;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content edit-profile' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-header checkout-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Change credit card'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__checkout_CheckoutComponents__["a" /* CreditCardWrapper */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'expanded-card' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'update-card-heading' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'heading-text' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    null,
                    'Credit card details'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'By changing your credit card, ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'b',
                      null,
                      'all subscriptions will be charged according to the new registered card'
                    ),
                    '.'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'card billing-card' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["TextInput"], {
                  form: form,
                  autoFocus: true,
                  type: 'text',
                  path: 'cardholder',
                  label: 'Name on card:',
                  placeholder: 'Ex: John Doe'
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["Field"],
                  { label: 'Card number:' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__checkout_CheckoutComponents__["c" /* StripeInput */], { id: 'card-element' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__checkout_CheckoutComponents__["d" /* CreditCardIcon */], { src: '/public/icon/' + (cardBrand || 'unknown') + '.svg' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["SplitColumnsContainer"],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["Field"],
                    { label: 'Expiration:' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__checkout_CheckoutComponents__["c" /* StripeInput */], { id: 'card-expiry-element' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["Field"],
                    { label: 'CVC:' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__checkout_CheckoutComponents__["c" /* StripeInput */], { id: 'card-cvc-element' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["SplitColumnsContainer"],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["TextInput"], {
                    form: form,
                    type: 'text',
                    path: 'country',
                    label: 'Country:',
                    placeholder: 'Ex: USA'
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["TextInput"], {
                    form: form,
                    type: 'text',
                    path: 'zipCode',
                    label: 'Zip code:',
                    placeholder: 'Ex: 21401'
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["Errors"], { form: form })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-footer' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
            { onClick: function onClick() {
                return window.history.back();
              } },
            'Cancel'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
            { highlight: true, isLoading: loading.isOpen, onClick: this.handleSubmit },
            'Update'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          ref: function ref(el) {
            return _this4.captchaRef.current = el;
          },
          className: 'g-recaptcha'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__checkout_CaptchaUtils__["c" /* RecaptchaBrandingText */],
            null,
            'This site is protected by reCAPTCHA and the Google ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                href: 'https://policies.google.com/privacy',
                rel: 'noopener noreferrer',
                target: '_blank'
              },
              'Privacy Policy'
            ),
            ' and ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                href: 'https://policies.google.com/terms',
                rel: 'noopener noreferrer',
                target: '_blank'
              },
              'Terms of Service'
            ),
            ' apply.'
          )
        )
      );
    }
  }]);

  return CreditCardUpdate;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class) || _class) || _class) || _class);

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Workstations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_report_components__ = __webpack_require__(14);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class, _dec3, _class3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Workstations = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__["fetchConnect"])(function (state) {
  return { workstations: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__selectors__["b" /* getWorkstations */])(state) };
}, { unlinkWorkstation: __WEBPACK_IMPORTED_MODULE_4__reducers__["j" /* unlinkWorkstation */], unlinkAllWorkstations: __WEBPACK_IMPORTED_MODULE_4__reducers__["k" /* unlinkAllWorkstations */], connectFetcher: __WEBPACK_IMPORTED_MODULE_4__reducers__["l" /* loadWorkstations */] }), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__["withToggles"])("unlinkAllDialog", "unlinkedAllDialog", "unlinkedOneDialog", "isLoading"), _dec(_class = _dec2(_class = function (_React$PureComponent) {
  _inherits(Workstations, _React$PureComponent);

  function Workstations() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Workstations);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Workstations.__proto__ || Object.getPrototypeOf(Workstations)).call.apply(_ref, [this].concat(args))), _this), _this.unlinkAll = function () {
      _this.props.isLoading.open();
      _this.props.unlinkAllWorkstations().then(_this.props.unlinkAllDialog.close).then(_this.props.isLoading.close).then(_this.props.unlinkedAllDialog.open);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Workstations, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps) {
      var _this2 = this;

      if (this.props.workstations.length < oldProps.workstations.length && !this.props.unlinkedAllDialog.isOpen && !this.props.unlinkAllDialog.isOpen) {
        var removed = oldProps.workstations.filter(function (_) {
          return _this2.props.workstations.indexOf(_) < 0;
        });
        this.props.unlinkedOneDialog.open(removed.map(function (_) {
          return _.stationName;
        })[0]);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          workstations = _props.workstations,
          unlinkAllDialog = _props.unlinkAllDialog,
          unlinkedAllDialog = _props.unlinkedAllDialog,
          unlinkWorkstation = _props.unlinkWorkstation,
          unlinkedOneDialog = _props.unlinkedOneDialog,
          isLoading = _props.isLoading;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content edit-profile workstations' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"].Link,
            { className: 'return-home-button', icon: 'arrow-left', to: '/' },
            'Home'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Horos workstations'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'profile-menu' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Link"],
              { className: 'button nav-tab', to: '/profile' },
              'Profile'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Link"],
              { className: 'button nav-tab', skipTo: '/account-settings' },
              'Settings'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Link"],
              { className: 'button nav-tab active', to: '/workstations' },
              'Manage workstations'
            )
          )
        ),
        workstations.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'no-results-message horos-download-message' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            'No workstations linked to your Horos Cloud'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'To link a workstation to your Horos Cloud account, open Horos app on your computer, click the "Cloud Report" icon and sign in.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"].a,
            { highlight: true, href: 'horos://', className: 'horos-download-button' },
            'Launch Horos'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Do not have Horos App installed yet? ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'link', href: 'https://horosproject.org/download-horos/', target: '_blank' },
              'Download here'
            ),
            '.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'card-list' },
          workstations.map(function (workstation) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkstationCard, { key: workstation.id, confirmUnlink: unlinkWorkstation, workstation: workstation });
          })
        ),
        workstations.length !== 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-footer' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
            { onClick: unlinkAllDialog.open },
            'Unlink all workstations'
          )
        ),
        unlinkAllDialog.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"],
          {
            closeDialog: unlinkAllDialog.close,
            title: 'Confirm unlink'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'You are about to unlink your Horos Cloud account for all of your workstations.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'By unlinking the workstations you will need to login again on your next access on each workstation. ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'b',
                null,
                'Would you like to confirm?'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
              { onClick: unlinkAllDialog.close },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
              { alert: true, isLoading: isLoading.isOpen, onClick: this.unlinkAll },
              'Confirm unlink'
            )
          )
        ),
        unlinkedAllDialog.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"],
          {
            closeDialog: unlinkedAllDialog.close,
            title: 'Workstations unlinked successfully'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'All workstations associated with this account have been successfully unlinked. For future sessions on these workstations users will be requested to login in order to properly use Horos Cloud.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
              { onClick: unlinkedAllDialog.close },
              'Close'
            )
          )
        ),
        unlinkedOneDialog.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"],
          {
            closeDialog: unlinkedOneDialog.close,
            title: 'Workstation unlinked successfully'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              unlinkedOneDialog.isOpen,
              ' has been successfully unlinked. For future sessions on that workstation users will be requested to login in order to properly use Horos Cloud.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
              { onClick: unlinkedOneDialog.close },
              'Close'
            )
          )
        )
      );
    }
  }]);

  return Workstations;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class) || _class);

var CardContent = function CardContent(_ref2) {
  var workstation = _ref2.workstation,
      children = _ref2.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'card-content' },
      children,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'card-title' },
        workstation.stationName
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'card-detail' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          'Latest access in:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_report_components__["a" /* formatDate */])(new Date(workstation.creationTimestamp), __WEBPACK_IMPORTED_MODULE_5_report_components__["b" /* en_US */], "L dd, yyyy")
        )
      )
    )
  );
};

var WorkstationCard = (_dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__["withToggles"])("unlinkDialog", "isLoading"), _dec3(_class3 = function (_React$PureComponent2) {
  _inherits(WorkstationCard, _React$PureComponent2);

  function WorkstationCard() {
    var _ref3;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, WorkstationCard);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref3 = WorkstationCard.__proto__ || Object.getPrototypeOf(WorkstationCard)).call.apply(_ref3, [this].concat(args))), _this3), _this3.confirmUnlink = function () {
      _this3.props.isLoading.open();
      _this3.props.confirmUnlink(_this3.props.workstation.id).then(_this3.props.isLoading.close);
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(WorkstationCard, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          workstation = _props2.workstation,
          unlinkDialog = _props2.unlinkDialog,
          isLoading = _props2.isLoading;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'card with-icon' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          CardContent,
          { workstation: workstation },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'buttons-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
              { small: true, onClick: unlinkDialog.open },
              'Unlink'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'card-icon' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Icon"], { icon: 'station' })
            )
          )
        ),
        unlinkDialog.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"],
          {
            title: 'Confirm unlink',
            closeDialog: unlinkDialog.close
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'You are about to unlink your Horos Cloud account for the following workstation:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'box-list' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'box with-icon' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  CardContent,
                  { workstation: workstation },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'card-icon' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Icon"], { icon: 'station' })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'By unlinking this workstation you will need to login again on your next access on that workstation. ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'b',
                null,
                'Would you like to confirm?'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Dialog"].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
              { onClick: unlinkDialog.close },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"],
              { alert: true, isLoading: isLoading.isOpen, onClick: this.confirmUnlink },
              'Confirm unlink'
            )
          )
        )
      );
    }
  }]);

  return WorkstationCard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class3);

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CheckoutPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ContentSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreditCardWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SubscriptionPlanList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PlanHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CurrentPlanLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SubscriptionPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PlanBillingOptionContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return InfoBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return OrderSummaryWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PromoCodeContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TextInputWithButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CouponFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StripeInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CreditCardIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PlanPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PlanPriceDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ServicesOfferingWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PlanRadio; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_form__);
var _templateObject = _taggedTemplateLiteral(['\n  .warning-text {\n    color: #9e2e32;\n    display: block;\n  }\n  .checkbox-list {\n    padding-bottom: .5rem;\n  }\n  @media (max-width: 675px) {\n    .profile-header.checkout-header.mobile-margin {\n      padding: 1rem 0;\n      margin-top: 0;\n      a {\n        margin-top: 1rem;\n      }\n    }\n  }\n'], ['\n  .warning-text {\n    color: #9e2e32;\n    display: block;\n  }\n  .checkbox-list {\n    padding-bottom: .5rem;\n  }\n  @media (max-width: 675px) {\n    .profile-header.checkout-header.mobile-margin {\n      padding: 1rem 0;\n      margin-top: 0;\n      a {\n        margin-top: 1rem;\n      }\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: 2rem;\n  .card {\n    padding: 1.5rem;\n  }\n'], ['\n  margin-top: 2rem;\n  .card {\n    padding: 1.5rem;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: 2rem;\n  .update-card-heading {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    .heading-text {\n      flex-grow: 1;\n      padding-right: 1rem;\n    }\n    .action-wrapper {\n      flex-shrink: 0;\n      padding-top: 2rem;\n    }\n  }\n  @media (max-width: 350px) {\n    .update-card-heading {\n      flex-wrap: wrap;\n      .heading-text, .action-wrapper {\n        flex-basis: 100%;\n        padding: 0;\n      }\n      ', ' {\n        width: 100%;\n        margin-bottom: 1rem;\n      }\n    }\n  }\n'], ['\n  margin-top: 2rem;\n  .update-card-heading {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    .heading-text {\n      flex-grow: 1;\n      padding-right: 1rem;\n    }\n    .action-wrapper {\n      flex-shrink: 0;\n      padding-top: 2rem;\n    }\n  }\n  @media (max-width: 350px) {\n    .update-card-heading {\n      flex-wrap: wrap;\n      .heading-text, .action-wrapper {\n        flex-basis: 100%;\n        padding: 0;\n      }\n      ', ' {\n        width: 100%;\n        margin-bottom: 1rem;\n      }\n    }\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  margin: -0.5rem;\n  display: flex;\n  @media (max-width: 620px) {\n    display: block;\n    margin: 0.5rem -0.5rem;\n  }\n  h3 + & {\n    margin-top: 1rem;\n  }\n'], ['\n  margin: -0.5rem;\n  display: flex;\n  @media (max-width: 620px) {\n    display: block;\n    margin: 0.5rem -0.5rem;\n  }\n  h3 + & {\n    margin-top: 1rem;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  background: ', ';\n  padding: 1.25rem;\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n  text-align: center;\n  margin: -1.5rem -1.5rem 1.25rem;\n'], ['\n  background: ', ';\n  padding: 1.25rem;\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n  text-align: center;\n  margin: -1.5rem -1.5rem 1.25rem;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  padding: 2px 4px 3px;\n  font-size: 10px;\n  line-height: 1;\n  border-radius: 4px;\n  background: rgba(0,0,0,0.1);\n  align-self: flex-end;\n  margin-left: auto;\n  margin-right: -8px;\n  margin-bottom: -5px;\n'], ['\n  padding: 2px 4px 3px;\n  font-size: 10px;\n  line-height: 1;\n  border-radius: 4px;\n  background: rgba(0,0,0,0.1);\n  align-self: flex-end;\n  margin-left: auto;\n  margin-right: -8px;\n  margin-bottom: -5px;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  position: relative;\n  background: white;\n  border: 1px solid ', ';\n  border-radius: 5px;\n  overflow: hidden;\n  margin: 0.5rem;\n  flex-basis: 0;\n  flex-grow: 1;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  ', '\n  ', '\n'], ['\n  position: relative;\n  background: white;\n  border: 1px solid ', ';\n  border-radius: 5px;\n  overflow: hidden;\n  margin: 0.5rem;\n  flex-basis: 0;\n  flex-grow: 1;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  ', '\n  ', '\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n    &:after {\n      content: \'\';\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      position: absolute;\n      border-radius: 4px;\n      border: 1px solid ', ';\n      pointer-events: none;\n    }\n  '], ['\n    &:after {\n      content: \'\';\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      position: absolute;\n      border-radius: 4px;\n      border: 1px solid ', ';\n      pointer-events: none;\n    }\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n    padding: 1rem;\n    margin: -0.5rem 0 1.25rem;\n    flex-direction: row;\n    flex-wrap: wrap;\n    ', ' {\n      padding: 0.75rem 1rem;\n      margin: -1rem -1rem 0.75rem;\n      text-align: left;\n      font-size: 14px;\n      flex-basis: 100%;\n      flex-grow: 1;\n      background: ', ';\n    }\n    ul, li {\n      margin-bottom: 0;\n      font-size: 12px;\n    }\n  '], ['\n    padding: 1rem;\n    margin: -0.5rem 0 1.25rem;\n    flex-direction: row;\n    flex-wrap: wrap;\n    ', ' {\n      padding: 0.75rem 1rem;\n      margin: -1rem -1rem 0.75rem;\n      text-align: left;\n      font-size: 14px;\n      flex-basis: 100%;\n      flex-grow: 1;\n      background: ', ';\n    }\n    ul, li {\n      margin-bottom: 0;\n      font-size: 12px;\n    }\n  ']),
    _templateObject10 = _taggedTemplateLiteral(['\n  @media (min-width:380px) and (max-width:620px) {\n    display: flex;\n    justify-content: space-between;\n  }\n'], ['\n  @media (min-width:380px) and (max-width:620px) {\n    display: flex;\n    justify-content: space-between;\n  }\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  padding: 1rem;\n  background: ', ';\n  border: 1px solid ', ';\n  color: ', ';\n  ', '\n  border-radius: 4px;\n  margin-bottom: 1.5rem;\n  margin-top: 1.5rem;\n'], ['\n  padding: 1rem;\n  background: ', ';\n  border: 1px solid ', ';\n  color: ', ';\n  ', '\n  border-radius: 4px;\n  margin-bottom: 1.5rem;\n  margin-top: 1.5rem;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n    background: ', ';\n    border: 0px;\n    color: white;\n  '], ['\n    background: ', ';\n    border: 0px;\n    color: white;\n  ']),
    _templateObject13 = _taggedTemplateLiteral(['\n  .order {\n    display: flex;\n    > * {\n      flex-basis: 50%;\n    }\n    .order-table {\n      font-size: 13px;\n      > div {\n        display: flex;\n        justify-content: space-between;\n        ~ div {\n          margin-top: 0.5rem;\n        }\n      }\n    }\n    .amount {\n      white-space: nowrap;\n      margin-left: 1rem;\n    }\n    .discount {\n      color: ', ';\n    }\n    .total {\n      border-top: 1px solid rgba(0,0,0,0.25);\n      padding-top: 0.5rem;\n      margin-top: 0.5rem;\n    }\n  }\n'], ['\n  .order {\n    display: flex;\n    > * {\n      flex-basis: 50%;\n    }\n    .order-table {\n      font-size: 13px;\n      > div {\n        display: flex;\n        justify-content: space-between;\n        ~ div {\n          margin-top: 0.5rem;\n        }\n      }\n    }\n    .amount {\n      white-space: nowrap;\n      margin-left: 1rem;\n    }\n    .discount {\n      color: ', ';\n    }\n    .total {\n      border-top: 1px solid rgba(0,0,0,0.25);\n      padding-top: 0.5rem;\n      margin-top: 0.5rem;\n    }\n  }\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n    padding-left: 1.5rem;\n    margin-left: 1.5rem;\n    border-left: 1px solid rgba(0,0,0,0.15);\n'], ['\n    padding-left: 1.5rem;\n    margin-left: 1.5rem;\n    border-left: 1px solid rgba(0,0,0,0.15);\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-bottom: -1rem;\n  .input-container {\n    flex-grow: 1;\n  }\n  ', ' {\n    margin-bottom: 1rem;\n    margin-left: 0.5rem;\n  }\n'], ['\n  display: flex;\n  margin-bottom: -1rem;\n  .input-container {\n    flex-grow: 1;\n  }\n  ', ' {\n    margin-bottom: 1rem;\n    margin-left: 0.5rem;\n  }\n']),
    _templateObject16 = _taggedTemplateLiteral(['\n  margin-top: -1.5rem;\n  color: ', ';\n  .applied-coupon {\n    padding: 1px 0.5rem;\n    font-size: 11px;\n    border-radius: 5px;\n    color: white;\n    font-weight: 600;\n    display: inline-block;\n    margin-right: 0.25rem;\n    margin-bottom: 0.25rem;\n    background-color: ', ';\n  }\n'], ['\n  margin-top: -1.5rem;\n  color: ', ';\n  .applied-coupon {\n    padding: 1px 0.5rem;\n    font-size: 11px;\n    border-radius: 5px;\n    color: white;\n    font-weight: 600;\n    display: inline-block;\n    margin-right: 0.25rem;\n    margin-bottom: 0.25rem;\n    background-color: ', ';\n  }\n']),
    _templateObject17 = _taggedTemplateLiteral(['\n  width: 100%;\n  border: 1px solid ', ';\n  border-radius: 5px;\n  background: white;\n  position: relative;\n  height: 3rem;\n  padding: 0.7rem;\n  &.StripeElement--focus {\n    border-color: ', ';\n    box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.1);\n  }\n  &.StripeElement--invalid {\n    border-color: ', ' !important;\n  }\n'], ['\n  width: 100%;\n  border: 1px solid ', ';\n  border-radius: 5px;\n  background: white;\n  position: relative;\n  height: 3rem;\n  padding: 0.7rem;\n  &.StripeElement--focus {\n    border-color: ', ';\n    box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.1);\n  }\n  &.StripeElement--invalid {\n    border-color: ', ' !important;\n  }\n']),
    _templateObject18 = _taggedTemplateLiteral(['\n  width: 29px;\n  position: absolute;\n  bottom: 0.75rem;\n  right: 0.75rem;\n'], ['\n  width: 29px;\n  position: absolute;\n  bottom: 0.75rem;\n  right: 0.75rem;\n']),
    _templateObject19 = _taggedTemplateLiteral(['\n  line-height: 1;\n  font-weight: 600;\n  font-size: 13px;\n  padding-right: 1.25rem;\n  color: ', ';\n  flex-basis: 100%;\n'], ['\n  line-height: 1;\n  font-weight: 600;\n  font-size: 13px;\n  padding-right: 1.25rem;\n  color: ', ';\n  flex-basis: 100%;\n']),
    _templateObject20 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 11px;\n  font-weight: 600;\n  padding-right: 0.25rem;\n'], ['\n  color: ', ';\n  font-size: 11px;\n  font-weight: 600;\n  padding-right: 0.25rem;\n']),
    _templateObject21 = _taggedTemplateLiteral(['\n  padding: 0.5rem 0.75rem;\n  display: inline-block;\n  border-radius: 5px;\n  border: 1px solid rgba(0,0,0,0.15);\n  margin-top: 0.5rem;\n  min-height: 4rem;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  cursor: pointer;\n  align-self: flex-start;\n  ', ';\n  input {\n    opacity: 0;\n    position: absolute;\n    left: -20000000px;\n  }\n  ', ' {\n    position: absolute;\n    right: 8px;\n    top: 5px;\n    font-size: 16px;\n    color: white;\n  }\n  ', '\n'], ['\n  padding: 0.5rem 0.75rem;\n  display: inline-block;\n  border-radius: 5px;\n  border: 1px solid rgba(0,0,0,0.15);\n  margin-top: 0.5rem;\n  min-height: 4rem;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  cursor: pointer;\n  align-self: flex-start;\n  ', ';\n  input {\n    opacity: 0;\n    position: absolute;\n    left: -20000000px;\n  }\n  ', ' {\n    position: absolute;\n    right: 8px;\n    top: 5px;\n    font-size: 16px;\n    color: white;\n  }\n  ', '\n']),
    _templateObject22 = _taggedTemplateLiteral(['\n    color: white;\n    background-color: ', ';\n    ', ', ', ' {\n      color: white !important;\n    }\n  '], ['\n    color: white;\n    background-color: ', ';\n    ', ', ', ' {\n      color: white !important;\n    }\n  ']),
    _templateObject23 = _taggedTemplateLiteral(['\n  margin-top: 2rem;\n  .card {\n    padding: 1.5rem 1.5rem 1.5rem 7.5rem;\n    position: relative;\n    background-color: #dcf3ff;\n    border-color: #b6d3e2;\n  }\n  img {\n    width: 100px;\n    position: absolute;\n    left: -1.75rem;\n    top: 1.5rem;\n  }\n'], ['\n  margin-top: 2rem;\n  .card {\n    padding: 1.5rem 1.5rem 1.5rem 7.5rem;\n    position: relative;\n    background-color: #dcf3ff;\n    border-color: #b6d3e2;\n  }\n  img {\n    width: 100px;\n    position: absolute;\n    left: -1.75rem;\n    top: 1.5rem;\n  }\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }








var CheckoutPage = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);

var ContentSection = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);

var CreditCardWrapper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(ContentSection)(_templateObject3, __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"]);

var SubscriptionPlanList = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4);

var PlanHeader = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('main'));

var CurrentPlanLabel = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject6);

var SubscriptionPlan = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject7, function (props) {
  return props.selected ? props.discontinuedPlan ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('gray120') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('main') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('gray210');
}, function (props) {
  return props.selected && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, function (props) {
    return props.discontinuedPlan ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('gray120') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('main');
  });
}, function (props) {
  return props.discontinuedPlan && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject9, PlanHeader, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('gray120'));
});

var PlanBillingOptionContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject10);

var InfoBox = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject11, function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten___default()(0.5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('main')(props));
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten___default()(0.35, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('main')(props));
}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('main'), function (props) {
  return props.gray && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject12, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('gray150'));
});

var OrderSummaryWrapper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(ContentSection)(_templateObject13, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('success'));
var PromoCodeContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject14);
var TextInputWithButton = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject15, __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"]);
var CouponFeedback = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject16, function (props) {
  return props.success ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('success') : props.error ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('alert') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('gray120');
}, function (props) {
  return props.success ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('success') : props.error ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('alert') : '';
});
var StripeInput = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject17, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('gray210'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('gray180'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('alert'));

var CreditCardIcon = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(_templateObject18);

var PlanPrice = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject19, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('gray90'));

var PlanPriceDetail = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject20, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('success'));

var PlanBillingOption = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].label(_templateObject21, function (props) {
  return props.selected ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject22, props.discontinuedPlan ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('gray120') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('main'), PlanPrice, PlanPriceDetail) : '\n    &:hover {\n      background: rgba(0,0,0,0.05);\n    }\n  ';
}, __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Icon"], function (props) {
  return !props.discontinuedPlan && '\n    @media (min-width:380px) and (max-width:620px) {\n      flex-basis: 49%;\n    }\n  ';
});

var ServicesOfferingWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject23);

var PlanRadio = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_form__["enhanceInput"])(function (_ref) {
  var value = _ref.value,
      disabled = _ref.disabled,
      className = _ref.className,
      name = _ref.name,
      hasErrors = _ref.hasErrors,
      toggle = _ref.toggle,
      children = _ref.children,
      tabIndex = _ref.tabIndex,
      stringifyValue = _ref.stringifyValue,
      fieldValue = _ref.fieldValue,
      setFromField = _ref.setFromField,
      discontinuedPlan = _ref.discontinuedPlan;

  var checked = stringifyValue ? stringifyValue(value) === stringifyValue(fieldValue) : value === fieldValue;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    PlanBillingOption,
    { onClick: function onClick(e) {
        return e.stopPropagation();
      }, disabled: disabled, selected: checked,
      discontinuedPlan: discontinuedPlan },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { disabled: disabled, type: 'radio', value: stringifyValue ? stringifyValue(fieldValue) : fieldValue, name: name,
      tabIndex: tabIndex,
      onChange: setFromField,
      checked: checked
    }),
    children,
    checked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Icon"], { icon: 'check' })
  );
});

/***/ }),

/***/ 228:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dicom-icon.6d2ffea8.svg";

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(124);
module.exports = __webpack_require__(125);


/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ExpiredPageComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ContentBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpiredShare; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  color: rgba(0,0,0,0.55);\n  padding: 0 2rem;\n  padding-top: 12rem;\n  font-size: 13px;\n  ', '\n  ', '\n  .useful-links {\n    text-align: center;\n    margin-top: 2rem;\n    a {\n      text-decoration: none;\n      ~ a {\n        margin-left: .5rem;\n        :before {\n          content: \'-\';\n          margin-right: .5rem;\n          text-decoration: none;\n          color: ', ';\n        }\n      }\n    }\n  }\n  @media (max-width: 440px) {\n    padding: 0 1rem;\n    padding-top: 6rem;\n    .useful-links a {\n      display: block;\n      text-align: center;\n      ~ a {\n        :before {\n          content: none;\n        }\n      }\n  }\n'], ['\n  color: rgba(0,0,0,0.55);\n  padding: 0 2rem;\n  padding-top: 12rem;\n  font-size: 13px;\n  ', '\n  ', '\n  .useful-links {\n    text-align: center;\n    margin-top: 2rem;\n    a {\n      text-decoration: none;\n      ~ a {\n        margin-left: .5rem;\n        :before {\n          content: \'-\';\n          margin-right: .5rem;\n          text-decoration: none;\n          color: ', ';\n        }\n      }\n    }\n  }\n  @media (max-width: 440px) {\n    padding: 0 1rem;\n    padding-top: 6rem;\n    .useful-links a {\n      display: block;\n      text-align: center;\n      ~ a {\n        :before {\n          content: none;\n        }\n      }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    text-align: center;\n  '], ['\n    text-align: center;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    .navbar {\n      background-color: ', ';\n    }\n  '], ['\n    .navbar {\n      background-color: ', ';\n    }\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  padding: 3rem;\n  background: white;\n  border-radius: 6px;\n  max-width: 44rem;\n  margin: 0 auto;\n  text-align: center;\n  box-shadow: 0 0 3px rgba(0,0,0,0.15);\n  h2 {\n    font-size: 19px;\n    font-weight: 600;\n    margin-bottom: .5rem;\n    line-height: 21px;\n  }\n  img {\n    width: 80px;\n    margin: 0 auto;\n    margin-bottom: 1rem;\n    ', '\n  }\n  ', ' {\n    margin-top: 1.5rem;\n  }\n  @media (max-width: 440px) {\n    padding: 3.5rem 2rem;\n    ', '\n  }\n'], ['\n  padding: 3rem;\n  background: white;\n  border-radius: 6px;\n  max-width: 44rem;\n  margin: 0 auto;\n  text-align: center;\n  box-shadow: 0 0 3px rgba(0,0,0,0.15);\n  h2 {\n    font-size: 19px;\n    font-weight: 600;\n    margin-bottom: .5rem;\n    line-height: 21px;\n  }\n  img {\n    width: 80px;\n    margin: 0 auto;\n    margin-bottom: 1rem;\n    ', '\n  }\n  ', ' {\n    margin-top: 1.5rem;\n  }\n  @media (max-width: 440px) {\n    padding: 3.5rem 2rem;\n    ', '\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n      width: 120px;\n      margin-top: -90px;\n    '], ['\n      width: 120px;\n      margin-top: -90px;\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      margin-top: 6rem;\n    '], ['\n      margin-top: 6rem;\n    ']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }






var ExpiredPageComponent = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (props) {
  return props.centered && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2);
}, function (props) {
  return props.grayNavbar && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib__["getColor"])('gray120'));
}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib__["getColor"])('gray180'));

var ContentBox = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4, function (props) {
  return props.topImage && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5);
}, __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"], function (props) {
  return props.topImage && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6);
});

var ExpiredShare = function (_React$PureComponent) {
  _inherits(ExpiredShare, _React$PureComponent);

  function ExpiredShare() {
    _classCallCheck(this, ExpiredShare);

    return _possibleConstructorReturn(this, (ExpiredShare.__proto__ || Object.getPrototypeOf(ExpiredShare)).apply(this, arguments));
  }

  _createClass(ExpiredShare, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        ExpiredPageComponent,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'navbar' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Link"],
            { to: '/', className: 'logo' },
            'Horos Cloud'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          ContentBox,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: '/public/expired-icon.png', alt: 'Expired' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            'This report is no longer available.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'The shared report link you are accessing has expired and you are no longer able to view it. Report links expire in 48 hours for security reasons.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'In case you need to be granted access again, please reach out to the person who shared this report with you and ask for sharing again.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"].Link,
            { highlight: true, skipTo: '/signIn' },
            'Access Horos Cloud'
          )
        )
      );
    }
  }]);

  return ExpiredShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SignInLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(3);
var _templateObject = _taggedTemplateLiteral(['\n  &.sign-up-screens.horos-cloud {\n    form {\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n      border: 1px solid rgba(0,0,0,0.1);\n      box-shadow: none;\n    }\n    .footer {\n      margin: 0 auto;\n      max-width: 400px;\n      padding: 1rem;\n      border: 1px solid rgba(0,0,0,0.1);\n      border-top: 0;\n      background: rgba(0,0,0,0.025);\n      border-bottom-left-radius: 5px;\n      border-bottom-right-radius: 5px;\n      margin-bottom: 2rem;\n    }\n  }\n'], ['\n  &.sign-up-screens.horos-cloud {\n    form {\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n      border: 1px solid rgba(0,0,0,0.1);\n      box-shadow: none;\n    }\n    .footer {\n      margin: 0 auto;\n      max-width: 400px;\n      padding: 1rem;\n      border: 1px solid rgba(0,0,0,0.1);\n      border-top: 0;\n      background: rgba(0,0,0,0.025);\n      border-bottom-left-radius: 5px;\n      border-bottom-right-radius: 5px;\n      margin-bottom: 2rem;\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: inline-block;\n  text-align: center;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n'], ['\n  display: inline-block;\n  text-align: center;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  max-width: 400px;\n  padding: 1rem 1.5rem;\n  background: rgba(0,0,0,0.5);\n  color: white;\n  margin: 0 auto;\n  border-radius: 4px;\n  a {\n    color: white;\n    font-weight: 600;\n  }\n  @-moz-document url-prefix() {\n    display: none;\n  }\n  @media screen and (-webkit-min-device-pixel-ratio:0) {\n    display: none;\n  }\n  @media (max-device-width: 600px) {\n    display: none;\n  }\n  @supports (-ms-ime-align:auto) {\n    display: none;\n  }\n'], ['\n  max-width: 400px;\n  padding: 1rem 1.5rem;\n  background: rgba(0,0,0,0.5);\n  color: white;\n  margin: 0 auto;\n  border-radius: 4px;\n  a {\n    color: white;\n    font-weight: 600;\n  }\n  @-moz-document url-prefix() {\n    display: none;\n  }\n  @media screen and (-webkit-min-device-pixel-ratio:0) {\n    display: none;\n  }\n  @media (max-device-width: 600px) {\n    display: none;\n  }\n  @supports (-ms-ime-align:auto) {\n    display: none;\n  }\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }




var SignInPageComponent = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);

var WistiaWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);

var IeWarning = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3);

var SignInLayout = function SignInLayout(_ref) {
  var Content = _ref.Content,
      Footer = _ref.Footer,
      contentProps = _ref.contentProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    SignInPageComponent,
    { className: 'sign-up-screens horos-cloud' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'horos-logo', src: '/public/favicon.png', alt: '' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content, contentProps),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'footer' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Footer, null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        WistiaWrapper,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'wistia_embed wistia_async_oa5uzcuxxp popover=true popoverContent=link' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'link', href: '#' },
            'Learn more about Horos Cloud'
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      IeWarning,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'Internet Explorer isn\'t supported by Horos Cloud. Use ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: 'https://www.google.com/chrome/', target: '_blank' },
          'Google Chrome'
        ),
        ', ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: 'https://www.mozilla.org/en-US/firefox/new/', target: '_blank' },
          'Firefox'
        ),
        ' or ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: 'https://support.apple.com/downloads/safari', target: '_blank' },
          'Safari'
        ),
        ' for a better experience.'
      )
    )
  );
};

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PlanDetails */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STORAGE_PLAN_TYPE_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PLAN_TYPE_DETAILS; });
/* unused harmony export SubscriptionDetailsCardComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCancelDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CreditCardDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Billing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_icepath__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__checkout_CheckoutComponents__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_report_components__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__checkout_CaptchaUtils__ = __webpack_require__(46);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class, _dec3, _dec4, _class3;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n  color: white;\n  display: inline-block;\n  line-height: 18px;\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-weight: 600;\n  font-size: 13px;\n  display: inline-block;\n  margin-left: 0.5rem;\n  @media (max-width: 560px) {\n    font-size: 12px;\n    vertical-align: 1px;\n  }\n'], ['\n  background-color: ', ';\n  color: white;\n  display: inline-block;\n  line-height: 18px;\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-weight: 600;\n  font-size: 13px;\n  display: inline-block;\n  margin-left: 0.5rem;\n  @media (max-width: 560px) {\n    font-size: 12px;\n    vertical-align: 1px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  &.card.with-icon.large-icon {\n    border: 1px solid ', ';\n    margin-bottom: 1rem;\n    & ~ .card.with-icon.large-icon {\n      margin-top: 0;\n    }\n    .card-detail {\n      ul {\n        color: ', ';\n        margin-bottom: 0;\n        font-size: 12px;\n        li {\n          margin-bottom: 0;\n        }\n      }\n    }\n    .card-content {\n      padding-left: 9.5rem;\n      display: flex;\n      min-height: 9.5rem;\n    }\n    .card-icon {\n      width: 7.5rem;\n      height: 7.5rem;\n      text-align: center;\n      background: rgba(0,0,0,0.05);\n      img {\n        max-width: 100%;\n        padding: 1rem;\n      }\n    }\n  }\n  .subscription-details {\n    flex-grow: 1;\n    .additional-info {\n      font-size: 11px;\n      margin-top: .25rem;\n      color: ', ';\n    }\n  }\n  .change-plan {\n    margin-top: .5rem;\n    width: 100%;\n  }\n  .plan-box {\n    padding: 0.5rem;\n    display: block;\n    border-radius: 5px;\n    border: 1px solid rgba(0,0,0,0.1);\n    position: relative;\n    .plan-price {\n      line-height: 1;\n      font-weight: 600;\n      font-size: 13px;\n      color: ', ';\n      margin-bottom: 3px;\n    }\n    .plan-detail {\n      color: ', ';\n      font-size: 11px;\n    }\n  }\n  @media (max-width: 600px) {\n    .card-icon {\n      display: none !important;\n    }\n    .card-content {\n      padding: 1rem !important;\n    }\n    .plans-wrapper {\n      margin-left: 1rem;\n    }\n  }\n  @media (max-width: 510px) {\n    .card-content {\n      flex-wrap: wrap;\n    }\n    .plans-wrapper {\n      max-width: 100%;\n      flex-basis: 100%;\n      margin-top: 1rem;\n      margin-left: 0;\n      display: flex;\n    }\n    .plan-box ~ .plan-box {\n      margin-left: .5rem;\n      margin-top: 0;\n    }\n    .change-plan {\n      margin-left: .5rem;\n      margin-top: 0;\n      width: inherit;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n'], ['\n  &.card.with-icon.large-icon {\n    border: 1px solid ', ';\n    margin-bottom: 1rem;\n    & ~ .card.with-icon.large-icon {\n      margin-top: 0;\n    }\n    .card-detail {\n      ul {\n        color: ', ';\n        margin-bottom: 0;\n        font-size: 12px;\n        li {\n          margin-bottom: 0;\n        }\n      }\n    }\n    .card-content {\n      padding-left: 9.5rem;\n      display: flex;\n      min-height: 9.5rem;\n    }\n    .card-icon {\n      width: 7.5rem;\n      height: 7.5rem;\n      text-align: center;\n      background: rgba(0,0,0,0.05);\n      img {\n        max-width: 100%;\n        padding: 1rem;\n      }\n    }\n  }\n  .subscription-details {\n    flex-grow: 1;\n    .additional-info {\n      font-size: 11px;\n      margin-top: .25rem;\n      color: ', ';\n    }\n  }\n  .change-plan {\n    margin-top: .5rem;\n    width: 100%;\n  }\n  .plan-box {\n    padding: 0.5rem;\n    display: block;\n    border-radius: 5px;\n    border: 1px solid rgba(0,0,0,0.1);\n    position: relative;\n    .plan-price {\n      line-height: 1;\n      font-weight: 600;\n      font-size: 13px;\n      color: ', ';\n      margin-bottom: 3px;\n    }\n    .plan-detail {\n      color: ', ';\n      font-size: 11px;\n    }\n  }\n  @media (max-width: 600px) {\n    .card-icon {\n      display: none !important;\n    }\n    .card-content {\n      padding: 1rem !important;\n    }\n    .plans-wrapper {\n      margin-left: 1rem;\n    }\n  }\n  @media (max-width: 510px) {\n    .card-content {\n      flex-wrap: wrap;\n    }\n    .plans-wrapper {\n      max-width: 100%;\n      flex-basis: 100%;\n      margin-top: 1rem;\n      margin-left: 0;\n      display: flex;\n    }\n    .plan-box ~ .plan-box {\n      margin-left: .5rem;\n      margin-top: 0;\n    }\n    .change-plan {\n      margin-left: .5rem;\n      margin-top: 0;\n      width: inherit;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: ', ' ;\n  background: ', ';\n  padding: 0.25rem 1rem 1rem;\n  font-size: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  justify-content: space-between;\n  .billing-detail {\n    margin-right: 1rem;\n    margin: 0.75rem 1rem 0 0;\n  }\n  .billing-history-link {\n    cursor: pointer;\n    margin: 0.75rem 0 0;\n    ', ' {\n      font-size: 20px;\n      margin-right: 0.5rem;\n      line-height: 0;\n      vertical-align: -4px;\n    }\n  }\n  a {\n    text-decoration: underline;\n  }\n  .payment-failure-details {\n    flex-basis: 100%;\n    margin-top: 0.75rem;\n    padding: .5rem .75rem;\n    background-color: rgba(255,255,255,0.2);\n    border-radius: 4px;\n  }\n  @media (max-width: 605px) {\n    .billing-history-link {\n      order: 3;\n    }\n  }\n'], ['\n  color: ', ' ;\n  background: ', ';\n  padding: 0.25rem 1rem 1rem;\n  font-size: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  justify-content: space-between;\n  .billing-detail {\n    margin-right: 1rem;\n    margin: 0.75rem 1rem 0 0;\n  }\n  .billing-history-link {\n    cursor: pointer;\n    margin: 0.75rem 0 0;\n    ', ' {\n      font-size: 20px;\n      margin-right: 0.5rem;\n      line-height: 0;\n      vertical-align: -4px;\n    }\n  }\n  a {\n    text-decoration: underline;\n  }\n  .payment-failure-details {\n    flex-basis: 100%;\n    margin-top: 0.75rem;\n    padding: .5rem .75rem;\n    background-color: rgba(255,255,255,0.2);\n    border-radius: 4px;\n  }\n  @media (max-width: 605px) {\n    .billing-history-link {\n      order: 3;\n    }\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  min-height: 5.25rem;\n  &.card {\n    padding: 1rem 1.5rem;\n  }\n  .credit-card-number {\n    font-size: 14px;\n    margin: 0.5rem 1rem 0.5rem 0;\n    color: ', ';\n    flex-shrink: 0;\n    span {\n      font-size: 18px;\n      vertical-align: -2px;\n    }\n  }\n  ', ' {\n    margin: 0.5rem 0;\n  }\n'], ['\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  min-height: 5.25rem;\n  &.card {\n    padding: 1rem 1.5rem;\n  }\n  .credit-card-number {\n    font-size: 14px;\n    margin: 0.5rem 1rem 0.5rem 0;\n    color: ', ';\n    flex-shrink: 0;\n    span {\n      font-size: 18px;\n      vertical-align: -2px;\n    }\n  }\n  ', ' {\n    margin: 0.5rem 0;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: 29px;\n  margin-right: 1rem;\n  vertical-align: text-bottom;\n  display: inline-block;\n'], ['\n  width: 29px;\n  margin-right: 1rem;\n  vertical-align: text-bottom;\n  display: inline-block;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  max-height: 100%;\n  ', ' {\n    display: flex;\n    flex-direction: column;\n  }\n  ', ' {\n    flex-shrink: 0;\n  }\n  .box {\n    min-height: 25rem;\n    margin-bottom: 1rem;\n    padding: 0;\n    overflow: hidden;\n    display: flex;\n    position: relative;\n  }\n  .table-container {\n    overflow: auto;\n    width: 100%\n  }\n  table {\n    width: 100%;\n    border-spacing: 0;\n    padding: 0.25rem 0.5rem;\n    th, td {\n      padding: 0.75rem;\n      text-align: left;\n      border-bottom: 1px solid ', ';\n    }\n    tr:last-child td {\n      border-bottom: none;\n    }\n  }\n  p:last-child {\n    margin-bottom: 0;\n  }\n'], ['\n  max-height: 100%;\n  ', ' {\n    display: flex;\n    flex-direction: column;\n  }\n  ', ' {\n    flex-shrink: 0;\n  }\n  .box {\n    min-height: 25rem;\n    margin-bottom: 1rem;\n    padding: 0;\n    overflow: hidden;\n    display: flex;\n    position: relative;\n  }\n  .table-container {\n    overflow: auto;\n    width: 100%\n  }\n  table {\n    width: 100%;\n    border-spacing: 0;\n    padding: 0.25rem 0.5rem;\n    th, td {\n      padding: 0.75rem;\n      text-align: left;\n      border-bottom: 1px solid ', ';\n    }\n    tr:last-child td {\n      border-bottom: none;\n    }\n  }\n  p:last-child {\n    margin-bottom: 0;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  margin-bottom: 0.5rem;\n  color: ', ';\n  font-size: 13px;\n  flex-grow: 1;\n  li {\n    margin-bottom: 0.5rem;\n  }\n'], ['\n  margin-bottom: 0.5rem;\n  color: ', ';\n  font-size: 13px;\n  flex-grow: 1;\n  li {\n    margin-bottom: 0.5rem;\n  }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  margin-top: 2rem;\n  .card {\n    padding: 1.5rem;\n  }\n  h4 {\n    font-size: 14px;\n    margin-bottom: 0.25rem;\n    span {\n      font-weight: 400;\n      font-size: 12px;\n      display: inline-block;\n      color: rgba(0,0,0,0.5);\n    }\n  }\n  .upgrade-cta {\n    font-size: 12px;\n  }\n'], ['\n  margin-top: 2rem;\n  .card {\n    padding: 1.5rem;\n  }\n  h4 {\n    font-size: 14px;\n    margin-bottom: 0.25rem;\n    span {\n      font-weight: 400;\n      font-size: 12px;\n      display: inline-block;\n      color: rgba(0,0,0,0.5);\n    }\n  }\n  .upgrade-cta {\n    font-size: 12px;\n  }\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n'], ['\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  height: 1rem;\n  width: 100%;\n  border-radius: 30px;\n  background-color: rgba(0,0,0,0.075);\n  margin: 0.25rem 0 .75rem;\n  display: inline-block;\n  overflow: hidden;\n  :after {\n    content: \'\';\n    width: ', '%;\n    height: 100%;\n    min-width: 4px;\n    display: block;\n    border-radius: 30px;\n    background-color: ', ';\n  }\n'], ['\n  height: 1rem;\n  width: 100%;\n  border-radius: 30px;\n  background-color: rgba(0,0,0,0.075);\n  margin: 0.25rem 0 .75rem;\n  display: inline-block;\n  overflow: hidden;\n  :after {\n    content: \'\';\n    width: ', '%;\n    height: 100%;\n    min-width: 4px;\n    display: block;\n    border-radius: 30px;\n    background-color: ', ';\n  }\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  margin-top: 0.5rem;\n  display: flex;\n  ', ' {\n    flex-grow: 1;\n  }\n'], ['\n  margin-top: 0.5rem;\n  display: flex;\n  ', ' {\n    flex-grow: 1;\n  }\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  width: 2rem;\n  padding: 0;\n  margin-left: 0.5rem !important;\n  span {\n    transform: translate(50%,-50%);\n    right: 50%;\n  }\n'], ['\n  width: 2rem;\n  padding: 0;\n  margin-left: 0.5rem !important;\n  span {\n    transform: translate(50%,-50%);\n    right: 50%;\n  }\n']);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }















var PLAN_STATUS_LABEL = {
  active: 'Active',
  trialing: 'Trial',
  canceled: 'Canceled',
  canceled_renewal: 'Canceled renewal',
  past_due: 'Pending',
  unpaid: 'Canceled'
};

var PLAN_STATUS_COLOR = {
  active: 'main',
  trialing: 'main',
  canceled: 'alert',
  canceled_renewal: 'alert',
  past_due: 'warning',
  unpaid: 'alert'
};

var FOOTER_COLOR = _extends({}, PLAN_STATUS_COLOR, {
  active: 'gray240',
  trialing: 'gray240'
});

var StatusLabel = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].div(_templateObject, function (props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["getColor"])(PLAN_STATUS_COLOR[props.status])(props);
});

var SubscriptionDetailsCard = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].div(_templateObject2, function (props) {
  return props.selected ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["getColor"])('main') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["getColor"])('gray210');
}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["getColor"])('gray150'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["getColor"])('gray180'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["getColor"])('gray90'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["getColor"])('gray150'));

var SubscriptionDetailsFooter = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].div(_templateObject3, function (props) {
  return FOOTER_COLOR[props.status] === 'gray240' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["getColor"])('gray120')(props) : 'white';
}, function (props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["getColor"])(FOOTER_COLOR[props.status])(props);
}, __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Icon"]);

var CreditCardDetailsCard = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].div(_templateObject4, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["getColor"])('gray90'), __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"]);

var CreditCardIcon = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].img(_templateObject5);

var BillingHistoryDialog = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Dialog"])(_templateObject6, __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Dialog"].Content, __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Dialog"].Footer, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["getColor"])('gray210'));
var PlanDetails = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].ul(_templateObject7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["getColor"])('gray90'));

var ResourcesUsageCardWrapper = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].div(_templateObject8);

var DialogContentLoading = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].div(_templateObject9);

var ProgressBar = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].div(_templateObject10, function (props) {
  return props.progress || 0;
}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["getColor"])('main'));
var PlanActionsContainer = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].div(_templateObject11, __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"]);

var DropdownButton = __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"].extend(_templateObject12);

var STORAGE_PLAN_TYPE_DETAILS = {
  'STORAGE_STANDARD': function STORAGE_STANDARD(extra) {
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      PlanDetails,
      null,
      extra,
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Ideal for animal studies or anonymized human studies'
      )
    );
  },
  'STORAGE_PRO': function STORAGE_PRO(extra) {
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      PlanDetails,
      null,
      extra,
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Ideal for studies that contain protected health information (PHI)'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Includes free software VPN to secure data in transit'
      )
    );
  }
};

var PLAN_TYPE_DETAILS = _extends({}, STORAGE_PLAN_TYPE_DETAILS, {
  'REPORT_BASIC': function REPORT_BASIC() {
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      PlanDetails,
      null,
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Create up to ',
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'b',
          null,
          '50 reports'
        ),
        ' per month.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Download and share reports in PDF format.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Historical reports storage.'
      )
    );
  },
  'REPORT_BASIC_V2': function REPORT_BASIC_V2() {
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      PlanDetails,
      null,
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Not able to create new reports.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Download and share reports in PDF format.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Historical reports storage.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Includes report key images.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Not able to make new study shares.'
      )
    );
  },
  'REPORT_BASIC_V3': function REPORT_BASIC_V3() {
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      PlanDetails,
      null,
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Create up to ',
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'b',
          null,
          '5 reports'
        ),
        ' per month.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Download and share reports in PDF format.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Historical reports storage.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Includes report key images.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'b',
          null,
          '5 study shares'
        ),
        ' per month.'
      )
    );
  },
  'REPORT_STANDARD': function REPORT_STANDARD() {
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      PlanDetails,
      null,
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Create up to ',
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'b',
          null,
          '50 reports'
        ),
        ' per month.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Download and share reports in PDF format.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Historical reports storage.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Includes report key images.'
      )
    );
  },
  'REPORT_STANDARD_V2': function REPORT_STANDARD_V2() {
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      PlanDetails,
      null,
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Create up to ',
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'b',
          null,
          '25 reports'
        ),
        ' per month.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Download and share reports in PDF format.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Historical reports storage.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Includes report key images.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'b',
          null,
          '25 study shares'
        ),
        ' per month.'
      )
    );
  },
  'REPORT_PRO': function REPORT_PRO() {
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      PlanDetails,
      null,
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Create ',
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'b',
          null,
          'unlimited reports'
        ),
        ' per month.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Download and share reports in PDF format.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Historical reports storage.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        'Includes report key images.'
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'li',
        null,
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'b',
          null,
          'Unlimited study shares'
        ),
        ' per month.'
      )
    );
  }
});

var SubscriptionDetailsCardComponent = function SubscriptionDetailsCardComponent(_ref) {
  var children = _ref.children,
      extraPlanDetails = _ref.extraPlanDetails,
      planType = _ref.planType,
      status = _ref.status,
      details = _ref.details,
      plans = _ref.plans,
      isBilling = _ref.isBilling,
      isStorage = _ref.isStorage,
      props = _objectWithoutProperties(_ref, ['children', 'extraPlanDetails', 'planType', 'status', 'details', 'plans', 'isBilling', 'isStorage']);

  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
    SubscriptionDetailsCard,
    _extends({
      className: 'card with-icon large-icon'
    }, props),
    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      'div',
      { className: 'card-content' },
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'div',
        { className: 'card-icon' },
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', { src: isStorage ? '/public/storage-plan.png' : '/public/report-plan.png',
          alt: 'Plan Icon' })
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'div',
        { className: 'subscription-details' },
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'div',
          { className: 'card-title' },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getPlanType */])(planType),
          ' plan',
          status && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            StatusLabel,
            { status: status },
            PLAN_STATUS_LABEL[status]
          )
        ),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'div',
          { className: 'card-detail' },
          details || PLAN_TYPE_DETAILS[planType](extraPlanDetails)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'div',
        { className: 'plans-wrapper' },
        plans
      )
    ),
    children
  );
};


var getCancelDate = function getCancelDate(subscriptionEnd, daysUntilCancel) {
  return new Date(subscriptionEnd * 1000 + daysUntilCancel * 1000 * 60 * 60 * 24);
};

var PastDueFooter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withToggles"])('details')(function (_ref2) {
  var subscription = _ref2.subscription,
      billingLink = _ref2.billingLink,
      details = _ref2.details,
      daysUntilCancel = _ref2.daysUntilCancel,
      paymentErrorDetail = _ref2.paymentErrorDetail;
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      'div',
      { className: 'billing-detail' },
      'Subscription will be canceled on ',
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(FormattedDate, {
        date: getCancelDate(subscription.currentPeriodEnd, daysUntilCancel), format: 'LL dd' }),
      ' unless normalized. ',
      paymentErrorDetail && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'a',
        { onClick: details.toggle },
        details.isOpen ? 'Hide details' : 'See details'
      )
    ),
    billingLink,
    details.isOpen && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      'div',
      { className: 'payment-failure-details' },
      paymentErrorDetail
    )
  );
});

var PlanStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withPopupToggles"])('popup')(function (_ref3) {
  var popup = _ref3.popup,
      checkoutUrl = _ref3.checkoutUrl,
      checkoutLabel = _ref3.checkoutLabel,
      openCancelSubscriptionDialog = _ref3.openCancelSubscriptionDialog,
      status = _ref3.status,
      plan = _ref3.plan;
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      'div',
      { className: 'plan-box static' },
      plan.amount === 0 ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'div',
        { className: 'plan-price' },
        'Free'
      ) : __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'div',
        { className: 'plan-price' },
        '$',
        plan ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* toPrice */])(plan.amount) : 'undefined',
        ' USD / ',
        plan ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["e" /* stripeIntervalToAbbreviation */])(plan.interval) : 'mo'
      ),
      plan.amount === 0 ? null : !status || status === 'active' || status === 'past_due' ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'div',
          { className: 'plan-detail' },
          'billed ',
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["f" /* stripeIntervalToInterval */])(plan.interval)
        )
      ) : __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'div',
          { className: 'plan-detail' },
          'billing canceled'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      PlanActionsContainer,
      null,
      checkoutLabel && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"].Link,
        { small: true, to: checkoutUrl },
        checkoutLabel
      ),
      plan.name !== 'REPORT_BASIC_V2' && status !== 'canceled' && status !== 'canceled_renewal' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        DropdownButton,
        { small: true, withDropdown: true, onClick: popup.open },
        popup.isOpen && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["ContextMenu"],
          null,
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Li"], {
            label: 'Cancel subscription',
            onClick: openCancelSubscriptionDialog
          })
        )
      )
    )
  );
});

var CARD_BRANDS_ICONS = {
  'American Express': 'amex',
  'Diners Club': 'diners',
  'Discover': 'discover',
  'JCB': 'jcb',
  'MasterCard': 'mastercard',
  'UnionPay': 'unionpay',
  'Visa': 'visa'
};

var CreditCardDetails = function CreditCardDetails(_ref4) {
  var children = _ref4.children,
      card = _ref4.card;
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
    CreditCardDetailsCard,
    { className: 'card' },
    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      'div',
      { className: 'credit-card-number' },
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(CreditCardIcon, {
        src: '/public/icon/' + (CARD_BRANDS_ICONS[card.brand] || 'unknown') + '.svg' }),
      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'span',
        null,
        '\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 '
      ),
      ' ',
      card.last4
    ),
    children
  );
};

var FormattedDate = function FormattedDate(_ref5) {
  var date = _ref5.date,
      format = _ref5.format;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_report_components__["a" /* formatDate */])(new Date(date), __WEBPACK_IMPORTED_MODULE_11_report_components__["b" /* en_US */], format || 'L dd, yyyy');
};

var CANCELED_SUBSCRIPTION = {
  status: 'canceled'
};

var Billing = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withToggles"])('billingHistoryDialog', 'cancelSubscriptionDialog', 'loadingLimits'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["fetchConnect"])(function (state) {
  return {
    user: state.user
  };
}, undefined, 'stripe'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withRouteTo"])(_class = _dec(_class = _dec2(_class = function (_React$PureComponent) {
  _inherits(Billing, _React$PureComponent);

  function Billing() {
    var _ref6;

    var _temp, _this, _ret;

    _classCallCheck(this, Billing);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref6 = Billing.__proto__ || Object.getPrototypeOf(Billing)).call.apply(_ref6, [this].concat(args))), _this), _this.state = {
      storageSubscription: __WEBPACK_IMPORTED_MODULE_4_icepath__["ice"].get(_this.props.stripe, ['customer', 'subscriptions', 'data']).find(function (_) {
        return _.metadata && _.metadata.type === 'STORAGE';
      }),
      reportSubscription: __WEBPACK_IMPORTED_MODULE_4_icepath__["ice"].get(_this.props.stripe, ['customer', 'subscriptions', 'data']).find(function (_) {
        return _.metadata && (!_.metadata.type || _.metadata.type === 'REPORT');
      })
    }, _this.getStoragePlanName = function () {
      var subItems = _this.state.storageSubscription.subscriptionItems.data;
      var subItemsId = subItems.map(function (_) {
        return _.plan.id;
      });
      var currentPlan = _this.props.stripe.storagePlans.plans.find(function (_) {
        return subItemsId.indexOf(_.id) >= 0;
      });
      var currentPlanType = currentPlan.name.split('_').slice(0, 2).join('_');
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getPlanType */])(currentPlanType);
    }, _this.getReportPlanName = function () {
      var subscription = _this.state.reportSubscription;
      var currentPlanInfo = subscription.plan && [].concat(_toConsumableArray(_this.props.stripe.stripePlans.plans), _toConsumableArray(_this.props.stripe.replacedPlans.plans)).find(function (_) {
        return _.id === subscription.plan.id;
      });
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getPlanType */])(currentPlanInfo.name);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Billing, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.stripe !== prevProps.stripe) {
        this.setState({
          storageSubscription: __WEBPACK_IMPORTED_MODULE_4_icepath__["ice"].get(this.props.stripe, ['customer', 'subscriptions', 'data']).find(function (_) {
            return _.metadata && _.metadata.type === 'STORAGE';
          }),
          reportSubscription: __WEBPACK_IMPORTED_MODULE_4_icepath__["ice"].get(this.props.stripe, ['customer', 'subscriptions', 'data']).find(function (_) {
            return _.metadata && (!_.metadata.type || _.metadata.type === 'REPORT');
          })
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.state.reportSubscription) return this.props.routeTo('/checkout?of=plan');
      if (this.state.reportSubscription && this.state.reportSubscription.status === 'active') {
        this.props.loadingLimits.open();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs__["getFetcher"])('/api/account/limits').then(function (limits) {
          _this2.setState({ limits: limits });
          _this2.props.loadingLimits.close();
        }).catch(function () {
          return _this2.props.loadingLimits.close();
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.reportSubscription) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Loading"], { absolute: true, size: 40, borderWidth: 6 });
      }

      var _props = this.props,
          refreshFetchedState = _props.refreshFetchedState,
          loadingLimits = _props.loadingLimits,
          _props$stripe = _props.stripe,
          sources = _props$stripe.customer.sources,
          daysUntilCancel = _props$stripe.daysUntilCancel,
          paymentErrorDetail = _props$stripe.paymentErrorDetail,
          replacedPlans = _props$stripe.replacedPlans.plans,
          plans = _props$stripe.stripePlans.plans,
          storagePlans = _props$stripe.storagePlans,
          vpnstationPrice = _props$stripe.vpnstationPrice,
          vpnstationPriceYear = _props$stripe.vpnstationPriceYear,
          billingHistoryDialog = _props.billingHistoryDialog,
          cancelSubscriptionDialog = _props.cancelSubscriptionDialog;
      var limits = this.state.limits;

      var allStripePlans = [].concat(_toConsumableArray(plans), _toConsumableArray(replacedPlans));
      var card = sources && sources.data && sources.data[0];
      var reportSubscription = this.state.reportSubscription || CANCELED_SUBSCRIPTION;
      var subscription = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* normalizeSubscription */])(reportSubscription, card);

      var currentPlanInfo = subscription.plan && allStripePlans.find(function (_) {
        return _.id === subscription.plan.id;
      });
      var currentPlanType = currentPlanInfo && currentPlanInfo.name || 'REPORT';

      var viewBillingHistoryLink = __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'span',
        { className: 'billing-history-link', onClick: billingHistoryDialog.open },
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Icon"], {
          icon: 'note' }),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'a',
          null,
          'View billing history'
        )
      );
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        'div',
        { className: 'content edit-profile' },
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"].Link,
            { className: 'return-home-button', icon: 'arrow-left', to: '/' },
            'Home'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'div',
          { className: 'profile-header' },
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'h1',
            null,
            'Horos Cloud billing'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'p',
          null,
          'Check your current subscription and billing details below:'
        ),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          SubscriptionDetailsCardComponent,
          {
            isBilling: true,
            status: subscription.status,
            planType: currentPlanType,
            plans: __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(PlanStatus, {
              checkoutUrl: '/checkout?of=plan',
              plan: currentPlanInfo || subscription.plan,
              checkoutLabel: (currentPlanInfo || subscription.plan) === 'REPORT_BASIC_V2' ? 'Upgrade' : 'Change plan',
              status: subscription.status,
              openCancelSubscriptionDialog: cancelSubscriptionDialog.open
            })
          },
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            SubscriptionDetailsFooter,
            { status: subscription.status },
            subscription.status === 'active' ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,
              null,
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'div',
                { className: 'billing-detail' },
                'Subscribed since ',
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(FormattedDate, {
                  date: subscription.created * 1000 }),
                '. ',
                reportSubscription.status === 'trialing' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* daysLeft */])(reportSubscription.trialEnd * 1000) > 0 && 'You have ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* daysLeft */])(reportSubscription.trialEnd * 1000) + ' free days remaining before first payment.'
              ),
              viewBillingHistoryLink
            ) : subscription.status === 'canceled' || subscription.status === 'unpaid' ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,
              null,
              subscription.canceledAt ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'div',
                { className: 'billing-detail' },
                'Subscription canceled on ',
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(FormattedDate, {
                  date: subscription.canceledAt * 1000 }),
                '.'
              ) : __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'div',
                { className: 'billing-detail' },
                'This subscription has been canceled.'
              ),
              viewBillingHistoryLink
            ) : subscription.status === 'canceled_renewal' ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,
              null,
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'div',
                { className: 'billing-detail' },
                'Subscription service will be interrupted on ',
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(FormattedDate, {
                  date: subscription.currentPeriodEnd * 1000 }),
                '.'
              ),
              viewBillingHistoryLink
            ) : subscription.status === 'past_due' ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(PastDueFooter, { billingLink: viewBillingHistoryLink, subscription: subscription,
              daysUntilCancel: daysUntilCancel, paymentErrorDetail: paymentErrorDetail }) : ' '
          )
        ),
        this.state.storageSubscription && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(StorageSubscriptionDetails, {
          openCancelSubscriptionDialog: function openCancelSubscriptionDialog() {
            return cancelSubscriptionDialog.open('STORAGE');
          },
          subscription: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* normalizeSubscription */])(this.state.storageSubscription, card),
          plans: storagePlans.plans,
          vpnPrices: { month: vpnstationPrice, year: vpnstationPriceYear }
        }),
        limits && limits.currentPlanReportLimits >= 0 && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          ResourcesUsageCardWrapper,
          null,
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'h3',
            null,
            'Resources usage'
          ),
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'div',
            { className: 'card' },
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'h4',
              null,
              'Reports ',
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'span',
                null,
                '(',
                limits.currentReports,
                ' of ',
                limits.currentPlanReportLimits,
                ' used this month)'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ProgressBar, { progress: limits.currentReports / limits.currentPlanReportLimits * 100 }),
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'h4',
              null,
              'Study sharing ',
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'span',
                null,
                '(',
                limits.currentShares,
                ' of ',
                limits.currentPlanShareLimits,
                ' used this month)'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ProgressBar, { progress: limits.currentShares / limits.currentPlanShareLimits * 100 }),
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'div',
              { className: 'upgrade-cta' },
              'Need more reports or sharing limits per month? ',
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Link"],
                { to: '/checkout?of=plan',
                  'class': 'link' },
                'Upgrade your plan now'
              ),
              '.'
            )
          )
        ),
        loadingLimits.isOpen && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', null),
        card && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__checkout_CheckoutComponents__["a" /* CreditCardWrapper */],
          null,
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'h3',
              null,
              'Credit card details'
            ),
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              CreditCardDetails,
              { card: card },
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"].Link,
                { small: true, skipTo: '/card-update' },
                'Change credit card'
              )
            )
          )
        ),
        false && !this.state.storageSubscription && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__checkout_CheckoutComponents__["b" /* ServicesOfferingWrapper */],
            null,
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'div',
              { className: 'card' },
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', { src: '/public/storage-plan-220x220.png', alt: 'Plan Icon' }),
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'h4',
                null,
                'Would you like to store and have access to your image studies using the cloud?'
              ),
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'p',
                null,
                'Securely store and easily access medical imaging studies in your Horos Cloud.',
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('br', null),
                'You can access them when and where you need to.'
              ),
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"].Link,
                { highlight: true, to: '/storage/checkout?of=plan' },
                'Check our plans'
              ),
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"].a,
                { target: '_blank', href: 'https://horosproject.org/cloud-access-pricing/', outline: true },
                'Learn more'
              )
            )
          )
        ),
        cancelSubscriptionDialog.isOpen === true && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(CancelSubscriptionDialog, {
          currentCard: card,
          stripePlanId: allStripePlans.find(function (_) {
            return _.name === 'REPORT_BASIC_V2';
          }).id,
          planName: this.getReportPlanName(),
          refreshFetchedState: refreshFetchedState,
          subscriptionType: 'REPORT',
          closeDialog: cancelSubscriptionDialog.close
        }),
        cancelSubscriptionDialog.isOpen === 'STORAGE' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(CancelSubscriptionDialog, {
          planName: this.getStoragePlanName(),
          isStorage: true,
          refreshFetchedState: refreshFetchedState,
          subscriptionType: 'STORAGE',
          closeDialog: cancelSubscriptionDialog.close
        }),
        billingHistoryDialog.isOpen && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(BillingHistoryDialogComponent, { closeDialog: billingHistoryDialog.close })
      );
    }
  }]);

  return Billing;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.PureComponent)) || _class) || _class) || _class);

var StorageSubscriptionDetails = function StorageSubscriptionDetails(_ref7) {
  var openCancelSubscriptionDialog = _ref7.openCancelSubscriptionDialog,
      subscription = _ref7.subscription,
      plans = _ref7.plans,
      viewBillingHistoryLink = _ref7.viewBillingHistoryLink,
      daysUntilCancel = _ref7.daysUntilCancel,
      paymentErrorDetail = _ref7.paymentErrorDetail,
      vpnPrices = _ref7.vpnPrices;

  var subItems = subscription.subscriptionItems.data;
  var subItemsId = subItems.map(function (_) {
    return _.plan.id;
  });
  var currentPlan = plans.find(function (_) {
    return subItemsId.indexOf(_.id) >= 0;
  });
  var currentPlanType = currentPlan.name.split('_').slice(0, 2).join('_');
  var vpnItem = subItems.find(function (_) {
    return _.plan.id !== currentPlan.id;
  }) || { quantity: 0 };

  var vpnCost = currentPlanType === 'STORAGE_PRO' ? vpnPrices[currentPlan.interval] * Math.max(0, vpnItem.quantity - 1) : 0;
  var currentPlanWithStations = _extends({}, currentPlan, { amount: currentPlan.amount + vpnCost, status: 'active' });

  var volume = currentPlan.name.split('_')[2];
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
    SubscriptionDetailsCardComponent,
    {
      isStorage: true,
      isBilling: true,
      status: subscription.status,
      planType: currentPlanType,
      extraPlanDetails: __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'li',
          null,
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'b',
            null,
            volume,
            ' studies/month storage'
          )
        ),
        currentPlanType === 'STORAGE_PRO' && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'li',
          null,
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'b',
            null,
            vpnItem.quantity,
            ' workstation(s) access'
          )
        )
      ),
      plans: __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(PlanStatus, {
        checkoutUrl: '/storage/checkout?of=plan',
        checkoutLabel: subscription.status === 'active' || subscription.status === 'past_due' ? 'Change plan' : 'Reactivate',
        plan: currentPlanWithStations,
        openCancelSubscriptionDialog: openCancelSubscriptionDialog,
        status: subscription.status
      })
    },
    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      SubscriptionDetailsFooter,
      { status: subscription.status },
      subscription.status === 'active' ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'div',
          { className: 'billing-detail' },
          'Subscribed since ',
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(FormattedDate, { date: subscription.created * 1000 }),
          '.'
        ),
        viewBillingHistoryLink
      ) : subscription.status === 'canceled' || subscription.status === 'unpaid' ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,
        null,
        subscription.canceledAt ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'div',
          { className: 'billing-detail' },
          'Subscription canceled on',
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(FormattedDate, { date: subscription.canceledAt * 1000 }),
          '.'
        ) : __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'div',
          { className: 'billing-detail' },
          'This subscription has been canceled.'
        ),
        viewBillingHistoryLink
      ) : subscription.status === 'canceled_renewal' ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          'div',
          { className: 'billing-detail' },
          'Subscription service will be interrupted on ',
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(FormattedDate, {
            date: subscription.currentPeriodEnd * 1000 }),
          '.'
        ),
        viewBillingHistoryLink
      ) : subscription.status === 'past_due' ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(PastDueFooter, {
        billingLink: viewBillingHistoryLink,
        subscription: subscription,
        daysUntilCancel: daysUntilCancel,
        paymentErrorDetail: paymentErrorDetail }) : ' '
    )
  );
};

var CancelSubscriptionDialog = (_dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withToggles"])('isLoading'), _dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(undefined, { cancelSubscription: __WEBPACK_IMPORTED_MODULE_7__reducers__["e" /* cancelSubscription */] }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withRouteTo"])(_class3 = _dec3(_class3 = _dec4(_class3 = function (_React$Component) {
  _inherits(CancelSubscriptionDialog, _React$Component);

  function CancelSubscriptionDialog() {
    var _ref8;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, CancelSubscriptionDialog);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref8 = CancelSubscriptionDialog.__proto__ || Object.getPrototypeOf(CancelSubscriptionDialog)).call.apply(_ref8, [this].concat(args))), _this3), _this3.captchaRef = { current: null }, _this3.cancelSubscriptionWithCaptcha = function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__checkout_CaptchaUtils__["a" /* waitCaptcha */])(function (token) {
        _this3.handleCaptchaCallback(token);
      }, _this3.captchaRef).then(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__checkout_CaptchaUtils__["b" /* executeCaptcha */])({});
      });
    }, _this3.handleCaptchaCallback = function (captchaToken) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs__["postFetcher"])('/api/update-subscription', {
        stripeCardToken: _this3.props.currentCard.id,
        stripePlanId: _this3.props.stripePlanId,
        captchaToken: captchaToken
      }, { method: 'PUT' }).then(function () {
        return _this3.props.routeTo('/billing', true);
      }).then(_this3.props.refreshFetchedState).then(_this3.props.closeDialog);
    }, _this3.cancelSubscription = function () {
      _this3.props.isLoading.open();
      if (_this3.props.subscriptionType === 'REPORT') {
        return _this3.cancelSubscriptionWithCaptcha();
      } else {
        return _this3.props.cancelSubscription(_this3.props.subscriptionType).then(function () {
          return _this3.props.routeTo('/billing', true);
        }).then(_this3.props.refreshFetchedState).then(_this3.props.closeDialog);
      }
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(CancelSubscriptionDialog, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          planName = _props2.planName,
          closeDialog = _props2.closeDialog,
          isLoading = _props2.isLoading,
          isStorage = _props2.isStorage;

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Dialog"],
        {
          closeDialog: closeDialog,
          title: 'Confirm ' + planName + ' cancelation?'
        },
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Dialog"].Content,
          { icon: 'warning' },
          isStorage ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'p',
              null,
              'By canceling your ',
              planName,
              ' subscription you ',
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'strong',
                null,
                'won\u2019t be able to store new studies'
              ),
              '.'
            ),
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'p',
              null,
              'We do not guarantee storage or access to studies unless you have an active subscription.'
            )
          ) : __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'p',
              null,
              'By canceling your ',
              planName,
              ' subscription, you will not be able to edit reports or create new ones.'
            ),
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'p',
              null,
              'Access to reports already created will be available, but in read-only mode, unless you create a new subscription.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'strong',
              null,
              'Do you want to cancel your subscription?'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Dialog"].Footer,
          null,
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"],
            { onClick: closeDialog },
            'Close'
          ),
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"],
            { alert: true, isLoading: isLoading.isOpen, onClick: this.cancelSubscription },
            'Cancel subscription'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', {
          ref: function ref(el) {
            return _this4.captchaRef.current = el;
          },
          className: 'g-recaptcha'
        }),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__checkout_CaptchaUtils__["c" /* RecaptchaBrandingText */],
          null,
          'This site is protected by reCAPTCHA and the Google ',
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'a',
            {
              href: 'https://policies.google.com/privacy',
              rel: 'noopener noreferrer',
              target: '_blank'
            },
            'Privacy Policy'
          ),
          ' and ',
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'a',
            {
              href: 'https://policies.google.com/terms',
              rel: 'noopener noreferrer',
              target: '_blank'
            },
            'Terms of Service'
          ),
          ' apply.'
        )
      );
    }
  }]);

  return CancelSubscriptionDialog;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component)) || _class3) || _class3) || _class3);

var BillingHistoryDialogComponent = function (_React$Component2) {
  _inherits(BillingHistoryDialogComponent, _React$Component2);

  function BillingHistoryDialogComponent() {
    var _ref9;

    var _temp3, _this5, _ret3;

    _classCallCheck(this, BillingHistoryDialogComponent);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this5 = _possibleConstructorReturn(this, (_ref9 = BillingHistoryDialogComponent.__proto__ || Object.getPrototypeOf(BillingHistoryDialogComponent)).call.apply(_ref9, [this].concat(args))), _this5), _this5.state = { invoices: null }, _temp3), _possibleConstructorReturn(_this5, _ret3);
  }

  _createClass(BillingHistoryDialogComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this6 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs__["getFetcher"])('/api/stripe-invoices').then(function (_ref10) {
        var data = _ref10.data;
        return _this6.setState({ invoices: data });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var invoices = this.state.invoices;
      var closeDialog = this.props.closeDialog;

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        BillingHistoryDialog,
        {
          closeDialog: closeDialog,
          title: 'Billing history'
        },
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Dialog"].Content,
          null,
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'p',
            null,
            'All successful and failed payment attempts listed below:'
          ),
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'div',
            { className: 'box' },
            invoices ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'div',
              { className: 'table-container' },
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                'table',
                null,
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                      'th',
                      null,
                      'Date'
                    ),
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                      'th',
                      null,
                      'Period'
                    ),
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                      'th',
                      null,
                      'Amount'
                    ),
                    __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                      'th',
                      null,
                      'Status'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                  'tbody',
                  null,
                  invoices.map(function (invoice) {
                    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                      'tr',
                      { key: invoice.id },
                      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(FormattedDate, { date: invoice.date * 1000 })
                      ),
                      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(FormattedDate, { date: invoice.periodStart * 1000, format: 'L dd' }),
                        ' - ',
                        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(FormattedDate, {
                          date: invoice.periodEnd * 1000, format: 'L dd, yyyy' })
                      ),
                      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                        'td',
                        null,
                        invoice.currency.toUpperCase(),
                        ' ',
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["g" /* formatCurrency */])(invoice.total)
                      ),
                      __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
                        'td',
                        null,
                        !invoice.attempted ? 'Not Attempted' : invoice.paid ? 'Successful' : 'Failure'
                      )
                    );
                  })
                )
              )
            ) : __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              DialogContentLoading,
              null,
              __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Loading"], { absolute: true, size: 40, borderWidth: 6 })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            'p',
            null,
            'Need help with any issue regarding payments? Reach out to our ',
            __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
              'a',
              { className: 'link',
                href: 'mailto:support@horosproject.org' },
              'support team'
            ),
            '.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Dialog"].Footer,
          null,
          __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_startlibs_lib_components__["Button"],
            { onClick: closeDialog },
            'Close'
          )
        )
      );
    }
  }]);

  return BillingHistoryDialogComponent;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoadingUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slot_fill__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_icepath__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dashboard_Dashboard__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Navbar__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__signin_PasswordRecovery__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user_ProfileData__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__signin_SignIn__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__signin_SignUp__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__workstations_Workstations__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__report_Report__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__public_Terms__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__signin_RedefinePassword__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reducers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__user_AccountSettings__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__PageError__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__user_Billing__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_polished__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lib__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__public_ExpiredShare__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__public_PageNotFound__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__user_ConfirmDeleteAccount__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__public_DeleteAccountFinished__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__public_ExpiredDeletionLink__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__shareModule_DownloadStudyPage__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__checkout_StorageCheckout__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__user_CreditCardUpdate__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__checkout_ReportCheckout__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__public_FirstSteps__ = __webpack_require__(76);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps, _icons, _dec, _dec2, _class2, _dec3, _dec4, _class3, _dec5, _class5;

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  * {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  img {\n    max-width: 11rem;\n    margin-bottom: 4rem;\n  }\n'], ['\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  * {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  img {\n    max-width: 11rem;\n    margin-bottom: 4rem;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background: #00D2FF;\n'], ['\n  background: #00D2FF;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  height: ', 'px;\n'], ['\n  height: ', 'px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 101;\n  background: ', ';\n  .banner-content-container {\n    max-width: 62rem;\n    margin: 0 auto;\n    display: flex;\n    padding: 2rem;\n    font-size: 13px;\n    align-items: center;\n    justify-content: center;\n    color: ', ';\n  }\n  .banner-content {\n    margin-right: 1rem;\n  }\n  .additional-info {\n    font-size: 12px;\n  }\n  ', '{\n    flex-shrink: 0;\n    font-weight: 600;\n  }\n  .close-icon {\n    position: absolute;\n    width: 32px;\n    height: 32px;\n    font-size: 24px;\n    line-height: 32px;\n    cursor: pointer;\n    border-radius: 50%;\n    text-align: center;\n    background: ', ';\n    color: ', ';\n    z-index: 1000;\n    bottom: 50%;\n    transform: translateY(50%);\n    right: 1rem;\n    :hover {\n      background: ', ';\n    }\n  }\n  @media (max-width: 820px) {\n    .banner-content-container {\n      margin: 0 2.75rem 0 0;\n    }\n  }\n  @media (max-width: 550px) {\n    .banner-content-container {\n      padding: 1.5rem;\n      font-size: 12px;\n      display: block;\n      margin-right: 0;\n    }\n    .banner-content {\n      margin-bottom: 1rem;\n    }\n    .close-icon {\n      bottom: 1.5rem;\n      transform: none;\n    }\n  }\n'], ['\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 101;\n  background: ', ';\n  .banner-content-container {\n    max-width: 62rem;\n    margin: 0 auto;\n    display: flex;\n    padding: 2rem;\n    font-size: 13px;\n    align-items: center;\n    justify-content: center;\n    color: ', ';\n  }\n  .banner-content {\n    margin-right: 1rem;\n  }\n  .additional-info {\n    font-size: 12px;\n  }\n  ', '{\n    flex-shrink: 0;\n    font-weight: 600;\n  }\n  .close-icon {\n    position: absolute;\n    width: 32px;\n    height: 32px;\n    font-size: 24px;\n    line-height: 32px;\n    cursor: pointer;\n    border-radius: 50%;\n    text-align: center;\n    background: ', ';\n    color: ', ';\n    z-index: 1000;\n    bottom: 50%;\n    transform: translateY(50%);\n    right: 1rem;\n    :hover {\n      background: ', ';\n    }\n  }\n  @media (max-width: 820px) {\n    .banner-content-container {\n      margin: 0 2.75rem 0 0;\n    }\n  }\n  @media (max-width: 550px) {\n    .banner-content-container {\n      padding: 1.5rem;\n      font-size: 12px;\n      display: block;\n      margin-right: 0;\n    }\n    .banner-content {\n      margin-bottom: 1rem;\n    }\n    .close-icon {\n      bottom: 1.5rem;\n      transform: none;\n    }\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n          box-shadow: inset 0 -3px 0 0 rgba(0,0,0,0.15);\n          border-radius: 5px;\n          ', '\n      '], ['\n          box-shadow: inset 0 -3px 0 0 rgba(0,0,0,0.15);\n          border-radius: 5px;\n          ', '\n      ']),
    _templateObject6 = _taggedTemplateLiteral(['\n            box-shadow: inset 0 -2px 0 0 rgba(0,0,0,0.15);\n            ', ' {\n              width: 18px;\n              height: 18px;\n              border-width: 3px;\n            }\n          '], ['\n            box-shadow: inset 0 -2px 0 0 rgba(0,0,0,0.15);\n            ', ' {\n              width: 18px;\n              height: 18px;\n              border-width: 3px;\n            }\n          ']),
    _templateObject7 = _taggedTemplateLiteral(['\n        ', '\n        ', '\n      '], ['\n        ', '\n        ', '\n      ']),
    _templateObject8 = _taggedTemplateLiteral(['\n          & > a, & > label {\n            background-color: ', ';\n            color: white;\n          }\n        '], ['\n          & > a, & > label {\n            background-color: ', ';\n            color: white;\n          }\n        ']),
    _templateObject9 = _taggedTemplateLiteral(['\n            color: ', ';\n            font-weight: 600;\n        '], ['\n            color: ', ';\n            font-weight: 600;\n        ']),
    _templateObject10 = _taggedTemplateLiteral(['\n        background-color: white;\n        border-radius: 6px;\n        ', ' {\n          border-top: none;\n        }\n        ', ' {\n          border-top: none;\n        }\n        ', ' {\n          font-size: 100px;\n        }\n      '], ['\n        background-color: white;\n        border-radius: 6px;\n        ', ' {\n          border-top: none;\n        }\n        ', ' {\n          border-top: none;\n        }\n        ', ' {\n          font-size: 100px;\n        }\n      ']),
    _templateObject11 = _taggedTemplateLiteral(['\n        border-radius: 5px;\n        ', ' {\n          font-size: 120px;\n          line-height: 56px;\n        }\n        ', ' {\n          padding: 1rem;\n          box-shadow: inset 0 -3px 0 0 rgba(0,0,0,.15);\n        }\n      '], ['\n        border-radius: 5px;\n        ', ' {\n          font-size: 120px;\n          line-height: 56px;\n        }\n        ', ' {\n          padding: 1rem;\n          box-shadow: inset 0 -3px 0 0 rgba(0,0,0,.15);\n        }\n      ']),
    _templateObject12 = _taggedTemplateLiteral(['\n        background: ', ';\n        color: white;\n        border: 0;\n        ', ' {\n          color: white;\n          background-color: rgba(0, 0, 0, 0.2);\n          width: 20px;\n          height: 20px;\n          line-height: 20px;\n          &:hover {\n            background: rgba(0,0,0,0.25);\n          }\n        }\n        a {\n          color: white;\n          font-weight: 600;\n        }\n      '], ['\n        background: ', ';\n        color: white;\n        border: 0;\n        ', ' {\n          color: white;\n          background-color: rgba(0, 0, 0, 0.2);\n          width: 20px;\n          height: 20px;\n          line-height: 20px;\n          &:hover {\n            background: rgba(0,0,0,0.25);\n          }\n        }\n        a {\n          color: white;\n          font-weight: 600;\n        }\n      ']);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }



























// import {Checkout} from './checkout/Checkout'














var LoadingUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"])(function (_ref) {
  var className = _ref.className;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: '/public/favicon.png' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Loading"], { size: 40, borderWidth: 6 })
  );
})(_templateObject);

var PurviewPageLoader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["PageLoader"])(_templateObject2);

var BottomBannerPlaceholder = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject3, function (props) {
  return props.size;
});

var BottomBanner = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject4, function (props) {
  return props.warning ? '#eedcaa' : props.canceled ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_polished__["lighten"])(0.425, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('alert')(props)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_polished__["lighten"])(0.5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('main')(props));
}, function (props) {
  return props.warning ? 'rgba(0,0,0,0.6)' : props.canceled ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('alert') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('main');
}, __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Button"], function (props) {
  return props.warning || props.canceled ? 'rgba(0,0,0,0.1)' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_polished__["lighten"])(0.425, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('main')(props));
}, function (props) {
  return props.warning || props.canceled ? 'rgba(0,0,0,0.4)' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('main');
}, function (props) {
  return props.warning || props.canceled ? 'rgba(0,0,0,0.15)' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_polished__["lighten"])(0.39, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('main')(props));
});

var AppPresentation = (_temp = _class = function (_React$Component) {
  _inherits(AppPresentation, _React$Component);

  function AppPresentation(props) {
    _classCallCheck(this, AppPresentation);

    var _this = _possibleConstructorReturn(this, (AppPresentation.__proto__ || Object.getPrototypeOf(AppPresentation)).call(this, props));

    _initialiseProps.call(_this);

    _this.originalLocation = props.location.pathname;
    return _this;
  }

  _createClass(AppPresentation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('scroll', this.handleWindowScroll);
      var log = function log() {
        return _this2.props.getAccount().then(function (_ref2) {
          var errors = _ref2.errors;

          if (errors && !(errors instanceof Error)) localStorage.removeItem('hasLogged');
          _this2.props.hasFetchedUser.open();
        });
      };
      if (localStorage.getItem('hasLogged') === 'true') {
        log();
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs__["getFetcher"])('/api/authenticate/').then(function (_ref3) {
          var errors = _ref3.errors;

          if (errors) {
            _this2.props.hasFetchedUser.open();
          } else {
            log();
          }
        }).catch(this.props.hasFetchedUser.open);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleWindowScroll);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps) {
      // const completedProfile = (oldProps.user && this.props.user && oldProps.user.hasProfile === false && this.props.user.hasProfile === true)
      // if (this.props.user.id && !this.props.originalLocation.isOpen) {
      //   this.props.originalLocation.open()
      // }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          user = _props.user,
          hasFetchedUser = _props.hasFetchedUser;

      var publicRoutes = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { key: 'storageCheckout', path: '/storage/checkout', exact: true, component: __WEBPACK_IMPORTED_MODULE_33__checkout_StorageCheckout__["a" /* StorageCheckout */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { key: 'reportCheckout', path: '/checkout', exact: true, component: __WEBPACK_IMPORTED_MODULE_35__checkout_ReportCheckout__["a" /* ReportCheckout */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { key: 'license', path: '/license', exact: true, component: __WEBPACK_IMPORTED_MODULE_17__public_Terms__["a" /* Terms */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { key: 'expired', path: '/error/linkexpired', exact: true, component: __WEBPACK_IMPORTED_MODULE_27__public_ExpiredShare__["a" /* ExpiredShare */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { key: 'expiredDelete', path: '/error/deletionExpired', exact: true, component: __WEBPACK_IMPORTED_MODULE_31__public_ExpiredDeletionLink__["a" /* ExpiredDeletionLink */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { key: 'signUp', path: '/signUp', exact: true, component: __WEBPACK_IMPORTED_MODULE_14__signin_SignUp__["a" /* SignUp */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { key: 'recovery', path: '/recovery', exact: true, component: __WEBPACK_IMPORTED_MODULE_11__signin_PasswordRecovery__["a" /* PasswordRecovery */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { key: 'first-steps', path: '/first-steps', exact: true, component: __WEBPACK_IMPORTED_MODULE_36__public_FirstSteps__["a" /* FirstSteps */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { key: 'redefinePassword', path: '/redefinePassword/:key', exact: true, component: __WEBPACK_IMPORTED_MODULE_18__signin_RedefinePassword__["a" /* RedefinePassword */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { key: 'sharedStudy', path: '/sharedStudy/:uuid', exact: true, component: __WEBPACK_IMPORTED_MODULE_32__shareModule_DownloadStudyPage__["a" /* DownloadStudyPage */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { key: 'signIn', path: '/signIn', exact: true,
        render: function render(props) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__signin_SignIn__["a" /* SignIn */], _extends({}, props, { isLoggedIn: !!user.id, originalLocation: _this3.originalLocation }));
        } })];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_startlibs__["StartlibsProvider"],
        { config: AppPresentation.startlibsConfig },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_styled_components__["ThemeProvider"],
          { theme: AppPresentation.theme },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'App', onClick: this.closePopups },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Notifications, null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PurviewPageLoader, null),
            user.id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Switch"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/signUp', exact: true, render: function render() {
                  return null;
                } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/recovery', exact: true, render: function render() {
                  return null;
                } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/license', exact: true, render: function render() {
                  return null;
                } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/expired', exact: true, render: function render() {
                  return null;
                } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/redefinePassword/:key', exact: true, render: function render() {
                  return null;
                } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { component: __WEBPACK_IMPORTED_MODULE_10__Navbar__["a" /* Navbar */] })
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Switch"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/checkout', component: __WEBPACK_IMPORTED_MODULE_10__Navbar__["a" /* Navbar */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/storage/checkout', component: __WEBPACK_IMPORTED_MODULE_10__Navbar__["a" /* Navbar */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/first-steps', component: __WEBPACK_IMPORTED_MODULE_10__Navbar__["a" /* Navbar */] })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["ErrorBoundary"],
              { Error: __WEBPACK_IMPORTED_MODULE_23__PageError__["a" /* PageError */] },
              user.id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Switch"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/report/:uid', exact: true, component: __WEBPACK_IMPORTED_MODULE_16__report_Report__["a" /* Report */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/profile', exact: true, component: __WEBPACK_IMPORTED_MODULE_12__user_ProfileData__["a" /* ProfileData */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { from: '/firstSignIn', exact: true, to: '/profile' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/workstations', exact: true, component: __WEBPACK_IMPORTED_MODULE_15__workstations_Workstations__["a" /* Workstations */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/account-settings', exact: true, component: __WEBPACK_IMPORTED_MODULE_21__user_AccountSettings__["a" /* AccountSettings */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/deleteAccount/:token', exact: true, to: '/signIn', component: __WEBPACK_IMPORTED_MODULE_29__user_ConfirmDeleteAccount__["a" /* ConfirmDeleteAccount */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/reportCleanup/:token', exact: true,
                  render: function render() {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__user_ConfirmDeleteAccount__["a" /* ConfirmDeleteAccount */], { isReportCleanup: true });
                  } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { from: '/changePassword', exact: true, to: '/account-settings' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { from: '/activated', exact: true, to: '/profile?from=activation' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/card-update', exact: true, component: __WEBPACK_IMPORTED_MODULE_34__user_CreditCardUpdate__["a" /* CreditCardUpdate */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/billing', exact: true, component: __WEBPACK_IMPORTED_MODULE_24__user_Billing__["a" /* Billing */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/', exact: true, component: __WEBPACK_IMPORTED_MODULE_9__dashboard_Dashboard__["a" /* Dashboard */] }),
                publicRoutes,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { component: __WEBPACK_IMPORTED_MODULE_28__public_PageNotFound__["a" /* PageNotFound */] })
              ) : hasFetchedUser.isOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Switch"],
                null,
                publicRoutes,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { from: '/billing', exact: true, to: '/signIn' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { from: '/activated', exact: true, to: '/signIn' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { from: '/profile', exact: true, to: '/signIn' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { from: '/account-settings', exact: true, to: '/signIn' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { from: '/changePassword', exact: true, to: '/signIn' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { from: '/deleteAccount/:token', exact: true, to: '/signIn' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { from: '/reportCleanup/:token', exact: true, to: '/signIn' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { from: '/', exact: true, to: '/signIn' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/account-deleted', exact: true, component: __WEBPACK_IMPORTED_MODULE_30__public_DeleteAccountFinished__["a" /* DeleteAccountFinished */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { component: __WEBPACK_IMPORTED_MODULE_28__public_PageNotFound__["a" /* PageNotFound */] })
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Switch"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { key: 'sharedStudy', path: '/sharedStudy/:uuid', exact: true, component: __WEBPACK_IMPORTED_MODULE_32__shareModule_DownloadStudyPage__["a" /* DownloadStudyPage */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { component: LoadingUser })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActivationStatusNotification, null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlanStatusNotification, { status: user && user.accountStatus, user: user,
              stripeCardAdded: user && user.stripeCardAdded }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: 'absolute', top: 0, left: 0, right: 0, zIndex: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_slot_fill__["Slot"], { name: 'Popup' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: 'absolute', top: 0, left: 0, right: 0, zIndex: 200 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_slot_fill__["Slot"], { name: 'Portal' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_slot_fill__["Slot"], { name: 'Dialog' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_slot_fill__["Slot"], { name: 'Confirm-Dialog' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_slot_fill__["Slot"], { name: 'Notification' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_slot_fill__["Slot"], { name: 'Notifications' })
            )
          )
        )
      );
    }
  }]);

  return AppPresentation;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.startlibsConfig = {
  confirmDialogLabels: {
    title: 'Your changes will not be saved',
    content: 'The changes made in this screen were not saved. Would you like to quit anyway?',
    confirm: 'Save Changes',
    discard: 'Discard Changes',
    cancel: 'Cancel'
  },
  FormUploadingImageError: 'The image is being uploaded, please wait a monent.',
  ErrorDialog: {
    title: 'This content could not be loaded',
    content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      'Please refresh the page and try again. ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      'If the problem persists, contact us.'
    ),
    close: 'Close'
  },
  fetchRoutes: [['/', '/api/reports?size=40&page=0&sort=last_Saved,desc'], [/\/profile(\?.+)?/, '/api/profiles/'], ['/workstations', '/api/station-tokens'], ['/billing', '/api/stripe-customer'], [/(\/storage)?\/checkout\/?(\?.*of=plan.*)/, '/api/stripe-customer'], [/(\/storage)?\/checkout\/?(\?.*from=signup.*)/, '/api/stripe-customer'], [/(\/storage)?\/checkout\/?(\?.+)?/, '/api/stripe-plans?'], [/\/report\/([^/]+)$/, '/api/report-json/$1'], [/\/reportCleanup\/.+/, '/api/stripe-customer'], [/\/deleteAccount\/.+/, '/api/stripe-customer']]
}, _class.theme = {
  startlibs: {
    Button: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(_templateObject5, function (props) {
      return props.small && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(_templateObject6, __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Loading"]);
    }),
    ContextMenu: '\n        box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.5);\n        border-radius: 5px;\n      ',
    Popup: '\n        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.4);\n        border-radius: 4px;\n      ',
    ListItem: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(_templateObject7, function (props) {
      return props.hover && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(_templateObject8, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('main'));
    }, function (props) {
      return props.highlight && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(_templateObject9, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('main'));
    }),
    Dialog: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(_templateObject10, __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Dialog"].Content, __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Dialog"].Footer, __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Dialog"].DialogIcon),
    FieldLabel: '\n        font-weight: 600;\n      ',
    TextInput: '\n        border-radius: 5px;\n      ',
    IconRadioBox: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(_templateObject11, __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Icon"], __WEBPACK_IMPORTED_MODULE_22_startlibs_lib_form__["IconRadioBox"].Text),
    ErrorItem: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(_templateObject12, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"])('alert'), __WEBPACK_IMPORTED_MODULE_22_startlibs_lib_form__["Errors"].CloseIcon)
  },
  colors: {
    gray30: '#1e1e1e',
    gray60: '#3c3c3c',
    gray90: '#5a5a5a',
    gray120: '#787878',
    gray150: '#969696',
    gray180: '#b4b4b4',
    gray210: '#d2d2d2',
    gray240: '#f0f0f0',
    main: '#008bd2',
    secondary: '#28AAE1',
    alert: '#C3282D',
    warning: '#e6932e',
    success: '#39B54A',
    physician: '#00a99d',
    organization: '#ed1e79'
  },
  iconFont: 'pix-icons',
  icons: (_icons = {
    'note': '\uE935',
    'delete': '\uE934',
    'help': '\uE933',
    'download': '\uE930',
    'print': '\uE931',
    'email': '\uE932',
    'arrow-up-line': '\uE92C',
    'arrow-down-line': '\uE92D',
    'arrow-left-line': '\uE92E',
    'arrow-right-line': '\uE92F',
    'hlogo-right': '\uE929',
    'hlogo-left': '\uE92A',
    'hlogo-center': '\uE92B',
    'reload': '\uE927',
    'image': '\uE928',
    'external-link-line': '\uE923',
    'edit': '\uE924',
    'reorder': '\uE925',
    'move': '\uE926',
    'bold': '\uE91B',
    'italic': '\uE91C',
    'underline': '\uE91D',
    'strikethrough': '\uE91E',
    'insertUnorderedList': '\uE91F',
    'insertOrderedList': '\uE920',
    'outdent': '\uE921',
    'indent': '\uE922',
    'sort': '\uE91A',
    'zip-file': '\uE919',
    'calendar': '\uE917',
    'lock': '\uE918',
    'directories': '\uE913',
    'files': '\uE914',
    'failure': '\uE915',
    'external-link': '\uE916',
    'plus': '\uE910',
    'edit-box': '\uE911',
    'sign-out': '\uE912',
    'share': '\uE90A',
    'arrow-down': '\uE903',
    'arrow-up': '\uE904',
    'arrow-left': '\uE905',
    'arrow-right': '\uE906',
    'upload': '\uE907',
    'view': '\uE908',
    'settings': '\uE909',
    'search': '\uE90B',
    'check': '\uE90C',
    'x': '\uE90D',
    'plus-circle': '\uE90E',
    'notification': '\uE90F',
    'user': '\uE900',
    'physician': '\uE901',
    'organization': '\uE902',
    'report': '\uE936',
    'checked-report': '\uE937',
    'station': '\uE938',
    'warning': '\uE939',
    'premium': '\uE93A',
    'credit-card': '\uE93B',
    'clock': '\uE93D',
    'zoom-in': '\uE93E',
    'zoom-out': '\uE93F',
    'minus': '\uE941'
  }, _defineProperty(_icons, 'plus', '\uE910'), _defineProperty(_icons, 'home-line', '\uE940'), _defineProperty(_icons, 'home', '\uE942'), _icons)
}, _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleWindowScroll = function () {
    var classes = document.body.className.split(' ');
    if (!window.pageYOffset !== classes.indexOf('scrolled') < 0) {
      var className = classes.filter(function (_) {
        return _ !== 'scrolled';
      }).join(' ');
      document.body.className = className + (window.pageYOffset ? ' scrolled' : '');
    }
  };

  this.closePopups = function () {
    if (_this4.props.openPopup) {
      _this4.props.closePopups();
    }
  };
}, _temp);
var Notifications = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(function (_ref4) {
  var appUI = _ref4.appUI;
  return {
    notifications: appUI.notifications
  };
}, { clearNotifications: __WEBPACK_IMPORTED_MODULE_19__reducers__["b" /* clearNotifications */] }), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_startlibs_lib_hocs__["withToggles"])('toggle'), _dec(_class2 = _dec2(_class2 = function (_React$Component2) {
  _inherits(Notifications, _React$Component2);

  function Notifications() {
    _classCallCheck(this, Notifications);

    return _possibleConstructorReturn(this, (Notifications.__proto__ || Object.getPrototypeOf(Notifications)).apply(this, arguments));
  }

  _createClass(Notifications, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps) {
      if (oldProps.notifications !== this.props.notifications && this.props.notifications.length) {
        this.props.toggle.open();
        setTimeout(this.props.toggle.closeAfter(4000, 2000), 100);
      }
      if (!this.props.toggle.isOpen && oldProps.toggle.isOpen) {
        this.props.clearNotifications();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          toggle = _props2.toggle,
          notifications = _props2.notifications;

      return toggle.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_slot_fill__["Fill"],
        { name: 'Notifications' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'system-notification success' },
          notifications,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'icon icon-x', onClick: toggle.close })
        )
      );
    }
  }]);

  return Notifications;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class2) || _class2);
var ActivationStatusNotification = (_dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_startlibs_lib_hocs__["withToggles"])('dismissed', 'isLoading'), _dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(function (_ref5) {
  var user = _ref5.user;
  return { user: user };
}, { setNotifications: __WEBPACK_IMPORTED_MODULE_19__reducers__["c" /* setNotifications */] }), _dec3(_class3 = _dec4(_class3 = function (_React$Component3) {
  _inherits(ActivationStatusNotification, _React$Component3);

  function ActivationStatusNotification() {
    var _ref6;

    var _temp2, _this6, _ret;

    _classCallCheck(this, ActivationStatusNotification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp2 = (_this6 = _possibleConstructorReturn(this, (_ref6 = ActivationStatusNotification.__proto__ || Object.getPrototypeOf(ActivationStatusNotification)).call.apply(_ref6, [this].concat(args))), _this6), _this6.state = {}, _this6.checkTime = function () {
      if (new Date(_this6.props.user.createdDate).getTime() + 60 * 60 * 1000 > new Date().getTime()) {
        _this6.props.dismissed.open();
      }
    }, _this6.sendNewLink = function () {
      _this6.props.isLoading.open();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs__["getFetcher"])("/api/account/activation-link").then(function () {
        _this6.props.isLoading.close();
        _this6.props.setNotifications('Activation email sent, please check your email');
        _this6.props.dismissed.open();
      });
    }, _temp2), _possibleConstructorReturn(_this6, _ret);
  }

  _createClass(ActivationStatusNotification, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.element) {
        if (this.state.elementHeight !== this.element.offsetHeight) this.setState({ elementHeight: this.element.offsetHeight });
      }
      this.checkTime();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.user.createdDate !== this.props.user.createdDate) {
        this.checkTime();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _props3 = this.props,
          dismissed = _props3.dismissed,
          isLoading = _props3.isLoading,
          user = _props3.user;

      if (!user.id || user.activated || dismissed.isOpen) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BottomBannerPlaceholder, { size: this.state.elementHeight }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          BottomBanner,
          { innerRef: function innerRef(el) {
              return _this7.element = el;
            }, warning: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'banner-content-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'banner-content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'Please activate your account clicking on the link sent to your email.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'additional-info' },
                'If you do not find the email in your inbox, please check your spam or junk folder.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Button"].a,
              { highlight: true, small: true, isLoading: isLoading.isOpen, onClick: this.sendNewLink },
              'Send a new link'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Icon"], { className: 'close-icon', icon: 'x', onClick: dismissed.open })
        )
      );
    }
  }]);

  return ActivationStatusNotification;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class3) || _class3);
var PlanStatusNotification = (_dec5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_startlibs_lib_hocs__["withToggles"])('dismissed'), _dec5(_class5 = function (_React$Component4) {
  _inherits(PlanStatusNotification, _React$Component4);

  function PlanStatusNotification() {
    var _ref7;

    var _temp3, _this8, _ret2;

    _classCallCheck(this, PlanStatusNotification);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this8 = _possibleConstructorReturn(this, (_ref7 = PlanStatusNotification.__proto__ || Object.getPrototypeOf(PlanStatusNotification)).call.apply(_ref7, [this].concat(args))), _this8), _this8.state = { subscription: null, elementHeight: 0 }, _this8.element = null, _this8.load = function () {
      if (_this8.props.status === 'past_due' || _this8.props.status === 'canceled' || _this8.props.status === 'trialing' && !_this8.props.stripeCardAdded) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs__["getFetcher"])('/api/stripe-customer').then(function (_ref8) {
          var daysUntilCancel = _ref8.daysUntilCancel,
              customer = _ref8.customer;
          return _this8.setState({
            daysUntilCancel: daysUntilCancel,
            subscription: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__lib__["a" /* normalizeSubscription */])(customer.subscriptions && customer.subscriptions.data[0])
          });
        });
      } else if (_this8.props.user.id) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs__["getFetcher"])('/api/account/limits').then(function (limits) {
          var _ref9 = __WEBPACK_IMPORTED_MODULE_5_icepath__["ice"].get(_this8.props.user, ['settings', 'limitsDismissed']) || [],
              _ref10 = _slicedToArray(_ref9, 3),
              month = _ref10[0],
              dimissedReportCount = _ref10[1],
              dismissedShareCount = _ref10[2];

          if (month !== new Date().getMonth() || dimissedReportCount !== limits.currentReports || dismissedShareCount !== limits.currentShares) {
            _this8.setState({ limits: _extends({}, limits, { dimissedReportCount: dimissedReportCount, dismissedShareCount: dismissedShareCount }) });
          }
        });
      }
    }, _this8.closeLimits = function () {
      _this8.props.dismissed.open();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs__["postFetcher"])('/api/settings', _extends({}, _this8.props.user.settings, {
        limitsDismissed: [new Date().getMonth(), _this8.state.limits.currentReports, _this8.state.limits.currentShares]
      }), { method: 'PUT' });
    }, _this8.trialDaysLeft = function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__lib__["b" /* daysLeft */])(_this8.state.subscription.trialEnd * 1000);
    }, _temp3), _possibleConstructorReturn(_this8, _ret2);
  }

  _createClass(PlanStatusNotification, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps) {
      if (oldProps.status !== this.props.status) {
        this.load();
      }
      if (this.element) {
        if (this.state.elementHeight !== this.element.offsetHeight) this.setState({ elementHeight: this.element.offsetHeight });
      } else if (this.state.elementHeight) {
        this.setState({ elementHeight: 0 });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var dismissed = this.props.dismissed;
      var _state = this.state,
          subscription = _state.subscription,
          limits = _state.limits,
          daysUntilCancel = _state.daysUntilCancel;

      var paymentScreens = location.pathname.indexOf('/billing') === 0 || location.pathname.indexOf('/firstSignIn') === 0 || location.pathname.indexOf('/checkout') === 0;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BottomBannerPlaceholder, { size: this.state.elementHeight }),
        !subscription || paymentScreens || dismissed.isOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LimitsNotification, {
          innerRef: function innerRef(el) {
            return _this9.element = el;
          },
          closeLimits: this.closeLimits,
          limits: limits,
          dismissed: dismissed
        }) : subscription.status === 'canceled' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          BottomBanner,
          { innerRef: function innerRef(el) {
              return _this9.element = el;
            }, canceled: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'banner-content-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'banner-content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Your Horos Cloud subscription is currently canceled.'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                'Subscribe to Horos Cloud for keeping your reports safely stored and accessible.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Button"].Link,
              { highlight: true, to: '/checkout' },
              'Subscribe now'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Icon"], { className: 'close-icon', icon: 'x', onClick: dismissed.open })
        ) : subscription.status === 'past_due' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          BottomBanner,
          { innerRef: function innerRef(el) {
              return _this9.element = el;
            }, warning: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'banner-content-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'banner-content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'We\u2019ve identified pending payments in your Horos Cloud subscription.'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                'Please check your billing details before ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__user_Billing__["b" /* FormattedDate */], {
                  date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__user_Billing__["c" /* getCancelDate */])(subscription.currentPeriodEnd, daysUntilCancel),
                  format: 'LL dd' }),
                ' to avoid service interruption.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Button"].Link,
              { highlight: true, to: '/billing' },
              'Go to billing'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Icon"], { className: 'close-icon', icon: 'x', onClick: dismissed.open })
        ) : subscription.trialEnd && this.trialDaysLeft() <= 15 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          BottomBanner,
          { innerRef: function innerRef(el) {
              return _this9.element = el;
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: 'banner-content-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'banner-content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                this.trialDaysLeft() === 0 ? ' This is your last free trial day' : ' Your trial period will end in ' + this.trialDaysLeft() + ' days'
              ),
              '. Subscribe to Horos Cloud to continue using cloud reporting features.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Button"].Link,
              { highlight: true,
                to: '/checkout' },
              'Subscribe now'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Icon"], { className: 'close-icon', icon: 'x',
            onClick: dismissed.open })
        ) : null
      );
    }
  }]);

  return PlanStatusNotification;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class5);


var pluralize = function pluralize(n) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 's';
  var str = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return n > 1 ? str + suffix : str;
};

var LimitsNotification = function LimitsNotification(_ref11) {
  var limits = _ref11.limits,
      dismissed = _ref11.dismissed,
      closeLimits = _ref11.closeLimits,
      innerRef = _ref11.innerRef;

  if (dismissed.isOpen || !limits) return null;
  var showReportLimits = limits.currentreports !== limits.dismissedReportCount && limits.currentPlanReportLimits > 0 && limits.currentReports >= limits.currentPlanReportLimits * 4 / 5;
  var showShareLimits = limits.currentShares !== limits.dismissedShareCount && limits.currentPlanShareLimits > 0 && limits.currentShares >= limits.currentPlanShareLimits * 4 / 5;

  // FOR TESTING, UNCOMMENT LINES BELLOW, DELETE AFTER FINISHED
  // showReportLimits = true
  // showShareLimits = true
  if (!showReportLimits && !showShareLimits) return null;

  var remainingReports = limits.currentPlanReportLimits - limits.currentReports;
  var remainingShares = limits.currentPlanShareLimits - limits.currentShares;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    BottomBanner,
    { warning: true, innerRef: innerRef },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'banner-content-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'banner-content' },
        showReportLimits && showShareLimits ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'You can create ',
              remainingReports,
              ' more report',
              pluralize(remainingReports),
              ' and have ',
              remainingShares,
              ' more study share',
              pluralize(remainingShares),
              ' available this month.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'upgrade-cta' },
            'Upgrade your plan to have unlimited shares and reports per month.'
          )
        ) : showReportLimits ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'You can create only ',
              remainingReports,
              ' more report',
              pluralize(remainingReports),
              ' this month.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'upgrade-cta' },
            'Upgrade your plan to have unlimited reports per month.'
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'You have only ',
              remainingShares,
              ' more study share',
              pluralize(remainingShares),
              ' available this month.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'upgrade-cta' },
            'Upgrade your plan to have unlimited shares per month.'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Button"].Link,
        { highlight: true, to: '/checkout?of=plan' },
        'Upgrade your plan'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_startlibs_lib_components__["Icon"], { className: 'close-icon', icon: 'x', onClick: closeLimits })
  );
};

var App = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(function (_ref12) {
  var appUI = _ref12.appUI,
      user = _ref12.user;
  return {
    openPopup: appUI.openPopup,
    user: user
  };
}, { closePopups: __WEBPACK_IMPORTED_MODULE_4_startlibs__["closePopups"], getAccount: __WEBPACK_IMPORTED_MODULE_19__reducers__["d" /* getAccount */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_startlibs_lib_hocs__["withToggles"])('hasFetchedUser')(AppPresentation)));

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return waitCaptcha; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return executeCaptcha; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RecaptchaBrandingText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_little_loader__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_little_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_little_loader__);
var _templateObject = _taggedTemplateLiteral(['\n.grecaptcha-badge { visibility: hidden; }\n'], ['\n.grecaptcha-badge { visibility: hidden; }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: rgba(0,0,0,0.4);\n  font-size: 12px;\n  margin-right: auto;\n  padding-right: 1rem;\n  align-self: center;\n  a {\n    color: inherit;\n  }\n'], ['\n  color: rgba(0,0,0,0.4);\n  font-size: 12px;\n  margin-right: auto;\n  padding-right: 1rem;\n  align-self: center;\n  a {\n    color: inherit;\n  }\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }





var captchaPromise = new Promise(function (res, rej) {
  window.onLoadCaptchResolve = res;
});

var waitCaptcha = function waitCaptcha(captchaCallback, captchaRef) {
  __WEBPACK_IMPORTED_MODULE_2_little_loader___default()("https://www.google.com/recaptcha/api.js?onload=onLoadCaptchResolve&render=explicit");
  return captchaPromise.then(function () {
    return new Promise(function (res) {
      window.grecaptcha.ready(function () {
        window.grecaptcha.render(captchaRef.current, {
          "sitekey": "6LdLB_8lAAAAAEw76Pnd9NaPpYOhGl8mxqB2TRVj",
          "size": "invisible",
          callback: captchaCallback
        });
        res();
      });
    });
  });
};

var executeCaptcha = function executeCaptcha(values) {
  return new Promise(function (res, rej) {
    window.grecaptcha.reset();
    window.grecaptcha.execute();
    var iframe = document.querySelector("iframe[title='recaptcha challenge']");
    if (!iframe || !iframe.parentNode || iframe.parentNode.parentNode) {
      return;
    }
    var container = iframe.parentNode.parentNode;
    var observer = new MutationObserver(function (mutations) {
      if (container && container.style.visibility === 'hidden') {
        if (!window.grecaptcha.getResponse()) {
          rej([values, {}]);
        }
        observer.disconnect();
      }
    });
    observer.observe(container, { attributes: true, attributeFilter: ['style'] });
  });
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["injectGlobal"])(_templateObject);

var RecaptchaBrandingText = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FieldRequirements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SignUp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignInLayout__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_startlibs_lib_lib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_startlibs_lib_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class;

var _templateObject = _taggedTemplateLiteral(['\n  background: rgba(0,0,0,0.05);\n  color: rgba(0,0,0,0.4);\n  font-size: 11px;\n  padding: 0.75rem;\n  border-radius: 5px;\n  margin-top: -0.5rem;\n  margin-bottom: 1rem;\n  ', '\n'], ['\n  background: rgba(0,0,0,0.05);\n  color: rgba(0,0,0,0.4);\n  font-size: 11px;\n  padding: 0.75rem;\n  border-radius: 5px;\n  margin-top: -0.5rem;\n  margin-bottom: 1rem;\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    background: #ffdedf;\n    color: ', ';\n  '], ['\n    background: #ffdedf;\n    color: ', ';\n  ']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }















var FieldRequirements = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].div(_templateObject, function (props) {
  return props.hasErrors && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_styled_components__["css"])(_templateObject2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_startlibs_lib_lib__["getColor"])('alert'));
});

var SignUpContent = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__["withToggles"])('termsDialog', 'signUpSuccessDialog', 'loading'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["withForm"])(__WEBPACK_IMPORTED_MODULE_6_startlibs__["formFetch"]), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(undefined, { logout: __WEBPACK_IMPORTED_MODULE_9__reducers__["h" /* logout */], signIn: __WEBPACK_IMPORTED_MODULE_9__reducers__["i" /* signIn */] }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__["withRouteTo"])(_class = _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
  _inherits(SignUpContent, _React$Component);

  function SignUpContent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SignUpContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignUpContent.__proto__ || Object.getPrototypeOf(SignUpContent)).call.apply(_ref, [this].concat(args))), _this), _this.onFailure = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_validation__["d" /* responseFailure */])(_this.props.form, function (response) {
      return response.errorKey === "userexists" && { email: ["E-mail already registered."] } || response.errorKey === "userNotActivated" && { email: ["E-mail already registered."] } || response.errorKey === "userAccountRemoved" && { email: ['This account has been previously deleted. To reactivate the account please check ' + _this.props.form.properties.email + ' and click the reactivation link.'] } || response.message === "error.validation" && { email: ['Invalid e-mail.'] };
    }), _this.onSuccess = function () {
      _this.props.loading.open();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_startlibs__["getFetcher"])('/api/account').then(function (result) {
        _this.props.signIn(result);
        _this.props.routeTo("/checkout?from=signup");
      });
    }, _this.preValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_validation__["a" /* buildValidation */])({
      confirmEmail: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_validation__["f" /* confirmEmail */])('email'),
      acceptedTerms: function acceptedTerms(t) {
        return !t && 'You must read & agree to the terms';
      },
      email: [__WEBPACK_IMPORTED_MODULE_7__lib_validation__["g" /* emailValidation */], __WEBPACK_IMPORTED_MODULE_7__lib_validation__["b" /* required */]],
      firstName: [__WEBPACK_IMPORTED_MODULE_7__lib_validation__["b" /* required */]],
      lastName: [__WEBPACK_IMPORTED_MODULE_7__lib_validation__["b" /* required */]],
      password: [__WEBPACK_IMPORTED_MODULE_7__lib_validation__["b" /* required */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_validation__["c" /* minLength */])(6)]
    }, function (_ref2) {
      var password = _ref2.password,
          email = _ref2.email,
          firstName = _ref2.firstName,
          lastName = _ref2.lastName;
      return { firstName: firstName, lastName: lastName, password: password, email: email, langKey: 'en', login: email };
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SignUpContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          form = _props.form,
          loading = _props.loading,
          termsDialog = _props.termsDialog,
          signUpSuccessDialog = _props.signUpSuccessDialog;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'opening-section' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Sign up for Horos Cloud'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Enter your details below to create your account'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["Form"],
          { url: '/api/register',
            preValidation: this.preValidation,
            onSuccess: this.onSuccess,
            onFailure: this.onFailure,
            form: form
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["SplitColumnsContainer"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["TextInput"], {
              tabIndex: 1,
              path: 'firstName',
              form: form,
              placeholder: 'Ex: John',
              label: 'First name:'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["TextInput"], {
              tabIndex: 1,
              path: 'lastName',
              form: form,
              placeholder: 'Ex: Doe',
              label: 'Last name:'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["TextInput"], {
            tabIndex: 1,
            label: 'E-mail:',
            placeholder: 'example@email.com',
            form: form,
            path: 'email'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["TextInput"], {
            path: 'confirmEmail',
            tabIndex: 1,
            form: form,
            placeholder: 'Ex: example@email.com',
            label: 'Confirm email:'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["TextInput"], {
            tabIndex: 1,
            label: 'Password:',
            type: 'password',
            form: form,
            placeholder: 'Enter your password',
            path: 'password'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            FieldRequirements,
            null,
            'Your password shall contain at least 6 characteres.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'checkbox-list' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["SimpleCheckbox"], {
              form: form,
              label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'I\'ve read and agree to the ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'license-link', onClick: termsDialog.open },
                  'License Terms'
                ),
                '.'
              ),
              path: 'acceptedTerms',
              tabIndex: 1
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-actions sign-up-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"],
              { isLoading: form.isLoading || loading.isOpen, className: 'highlight with-loader', tabIndex: 1, type: 'submit' },
              'Sign up'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["Errors"], { form: form })
        ),
        signUpSuccessDialog.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Dialog"],
          {
            closeDialog: signUpSuccessDialog.close,
            closeOnClick: true,
            title: 'Almost there! Check your email'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Dialog"].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'We have e-mailed you a link to activate your account.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Please check ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'b',
                null,
                form.properties.email
              ),
              ' and click the activation link to finish signing up.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'additional-info' },
              'If you do not find the email in your inbox, please check your spam or junk folder.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Dialog"].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"].Link,
              { highlight: true, skipTo: '/' },
              'Ok'
            )
          )
        ),
        termsDialog.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Dialog"],
          {
            className: 'license-terms-dialog',
            closeDialog: termsDialog.close,
            closeOnClick: true,
            title: 'Horos Cloud license terms'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Dialog"].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'By clicking "Agree" you fully agree to the following license terms:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'terms-wrapper' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'These Terms of Service (the "Agreement") govern your use of this service (the "Services") from Nimble Co, LLC d/b/a Purview (referred to herein as "Purview", "we", "us", and "our"). BY ACCEPTING THIS AGREEMENT, EITHER BY CLICKING A BOX INDICATING YOUR ACCEPTANCE OR USING THIS PRODUCT, YOU AGREE TO BE LEGALLY BOUND BY THE TERMS AND CONDITIONS OF THIS AGREEMENT. IF YOU ARE ENTERING INTO THIS AGREEMENT ON BEHALF OF A COMPANY OR OTHER LEGAL ENTITY, YOU REPRESENT THAT YOU HAVE THE AUTHORITY TO BIND SUCH ENTITY AND ITS AFFILIATES TO THESE TERMS AND CONDITIONS, IN WHICH CASE THE TERMS "YOU", "YOUR", OR "PARTY" SHALL REFER TO SUCH ENTITY AND ITS AFFILIATES. IF YOU DO NOT HAVE SUCH AUTHORITY, OR IF YOU DO NOT AGREE WITH THESE TERMS AND CONDITIONS, YOU MUST NOT ACCEPT THIS AGREEMENT AND MAY NOT USE THE SERVICES.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'You may not access the Services for the purposes of monitoring the availability, performance or functionality of the Service, or for any other comparative or competitive purposes.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'This Agreement was last updated on April 1, 2018. It is effective between you and us as of the date of your acceptance of this Agreement.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'TERMS AND CONDITIONS'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '1. AGREEMENT. As referred to herein, "Agreement" means these Terms of Service, together with all policies and addenda that are incorporated herein by reference in the attached Exhibits. Definitions of terms are found in this Terms of Service Agreement.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '2. SERVICES; FEES; RESTRICTIONS ON USE; REGULATORY & INTENDED USES.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '2.1 Services. Subject to the terms and conditions of this Agreement, Purview grants to you a limited, non-transferable, non-exclusive license to access and use the Services for your own or your practice\u2019s use and not to be resold, relicensed or otherwise re-marketed as a product or service. You are responsible for: (a) complying with this Agreement; (b) the confidentiality and security of your or your patients\u2019 personal health information; (c) the accuracy, integrity, quality and legality of your images and information; (d) using commercially reasonable efforts to prevent unauthorized access to or use of the Services, and notifying us promptly of any such unauthorized access or use; (e) ensuring all of your data is backed up or archived elsewhere; and (f) using the Services only in accordance your applicable laws and government regulations.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '2.2 Fees. Your use of the Services is subject to license or usage fees established from time to time by Purview. Fees are subject to change during the Term. Failure to pay current fees when due or the failure to maintain a current payment method (credit or debit card, prepayment, or electronic funds transfer) may cause termination of your Services. Should you later wish to reinstate your Service, you will be responsible for all fees incurred for the duration of time from termination until reinstatement of your Services. You are responsible for all taxes associated with the Services other than U.S. taxes based on Purview\u2019s net income.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '2.3 Availability. Uploaded patient data, reports or other information will be available only for as long as you remain current on the payment of your Fees. Should your Services terminate for any reason, Purview will retain your stored information for ninety (90) days from such termination and shall make this data or information available to you for your electronic download for a fee equal to your last month\u2019s Service fee. Alternatively you may reinstate your account by paying the fees stated in Paragraph 2.2. Purview shall not otherwise be responsible for the return of stored data or other uploaded information for an account that has been terminated.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '2.4 Restrictions on Use. You agree not to: (i) resell the Services or use Services that have been resold; (ii) modify, decompile, reverse engineer, disassemble, attempt to discover the source code or algorithms of, or create derivative works based on, any of the Services or any part thereof; (iii) disable or circumvent any access control or related device, process or procedure established with respect to the Services or any part thereof; (iv) copy, rent, lease, lend, assign, sublicense, transfer, or otherwise make available, the Services or any rights under this Agreement to any Third Party except as expressly permitted by this Agreement; or (v) remove or obscure Purview\'s proprietary rights notices. Further, you agree not to: (vi) use the Services to transmit or store infringing, libelous, inappropriate, or otherwise unlawful or tortuous information or images; (v) use the Services to transmit or store information or images in violation of third-party privacy rights, (vi) use the Services to transmit or store Malicious Code; (vii) interfere with or disrupt the integrity or performance of the Services or third-party information contained therein, or (viii) attempt to gain unauthorized access to the Services or their related systems or networks, including impersonating other users or fictitious persons.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Purview, in its sole discretion, may delete or restrict access to the Services if it determines any of the restrictions on use have been violated. Purview may also delete any information, images or other material associated with an account deemed to be in violation of this Section 2.4.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '2.5 Intended Uses. The Services are intended for: (i) the storage and (ii) viewing of images acquired from CT, MR, CR, DR, US, NM and other DICOM compliant medical imaging systems when installed on suitable commercial standard hardware; (iii) the generation and storage of information related to these images; and (iv) the sharing of medical images with medical and healthcare personnel to facilitate clinical discussions. Unless otherwise stated, Purview Services are NOT intended to be used: (i) for primary diagnosis use by radiologists or diagnostic use by non-radiologists; (ii) within the standard radiology workflow; and (iii) for use as a pre-operative surgical planning tool and must not be used for this purpose. Horos itself is not a part of this Service and is covered by a separate LGPL license agreement.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '2.6 Regulatory. By using the Services, You acknowledge and agree that your or your patient\u2019s personal private health information may be transmitted and stored outside of your local geography or country. You hereby waive any and all objection to your local laws, statues or other regulations that prohibit the transmittal or storage of such information beyond your local geographic boundaries and/or you agree that if required, you have obtained explicit authorization from any person whose personal information is stored using our Services and that you have given that person a clear and unambiguous option to disallow the storage of such person\u2019s personal information.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '3. YOUR OBLIGATIONS. In addition to other obligations under this Agreement:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '3.1 You will cooperate with Purview in the performance of Purview\'s obligations hereunder, including without limitation, and in each instance subject to normal security requirements and in a manner that is not unnecessarily disruptive to you or your business, by: (i) providing to Purview such information, Data, management decisions, approvals and acceptances as may be reasonable to permit Purview to provide Services hereunder; (ii) providing Purview secure, remote access to your network and/or computing technology, as required; and (iii) abiding with all commercially reasonable security and privacy requests made by Purview.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '3.2 You acknowledge that, in connection with the Services from time to time and with the performance of any of its obligations hereunder, Purview may require the technical assistance and cooperation of you and you will provide, at no charge to Purview, such technical assistance and cooperation as Purview may from time to time reasonably request during the Term.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '3.3 You acknowledge that Services may be subject to other limitations, such as limits on storage space and on the number of times you are permitted to access or transfer Data to or from our website, applications, and other products or services.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '5. OWNERSHIP. As between the Parties, the Services are, and at all times shall remain, Purview or its Licensors\' sole and exclusive property, including all copyrights, trademarks, patents and other intellectual property rights. You agree that neither you nor any Third Party shall obtain any express or implied rights in or to any part of the Services. All rights not expressly granted are reserved by Purview. As between you and us, you exclusively own all rights, title and interest in and to all your uploaded information and images.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '6. EQUIPMENT NEEDS AND LIMITATIONS.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '6.1 Equipment. You are responsible for obtaining and maintaining all computer hardware, software and communications equipment needed to access and use the Services and for paying all Third Party access charges (e.g., ISP, telecommunications) incurred while using the Services.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '6.2 Backend Equipment. Purview reserves the right to establish a maximum amount of network bandwidth, memory, or other computer storage and a maximum amount of Data that you may store, post or transmit on or through the Services.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '7. CONDUCT. You shall be solely responsible for your actions and the actions of your users while using the Services and the contents of transmissions through the Services (including, without limitation, your Data). You agree not to knowingly upload or distribute in any way files that contain viruses, corrupted files, or any other similar software or programs that may damage the operation of the Services or any computer. You agree not to knowingly upload or distribute in any way image files that violate in any way protected health information (PHI), personal protected information, or patient identifiers as defined in the USA by the Health Information Privacy and Accountability Act of 1996 Privacy Rule (see 45 C.F.R. Part 160 and Subparts A & E of Part 164, as subsequently amended, as defined under the GDPR, or otherwise. You agree to immediately delete any series or studies that are discovered to contain any image files that violate in any way protected health information (PHI), personal protected information or patient identifiers, or to immediately notify Purview by email at\xA0support@Purview.com\xA0if such images are encountered in shared series or studies that you do not have necessary permissions to delete.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '8. CONFIDENTIALITY; YOUR DATA.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '8.1 Confidentiality of Patient Information. You are responsible for maintaining the confidentiality of your own or your patients\u2019information.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '8.2 Confidential Information. Purview and You each agree to use commercially reasonable efforts to maintain the other\'s Confidential Information in confidence and to not use or disclose any portion of the other Party\'s Confidential Information to Third Parties, except as reasonably necessary to perform this Agreement and as required by law.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '8.3 Your Data. As between the Parties, You shall own all data, information or material that you enter into the Services or has entered on its behalf ("Your Data"). For purposes of clarity, Your Data does not include Purview Data. Purview may access your account and Your Data from time-to-time as Purview deems necessary, solely for purposes of support, administration and invoicing related to your use of the Services. Except as permitted in this Agreement, Purview will not edit, delete or disclose Your Data unless authorized by you or unless Purview is required to do so by law or in the good faith belief that such action is necessary to: (i) conform with applicable laws or comply with legal process served on Purview; (ii) protect and defend the rights or property of Purview; or (iii) enforce this Agreement. Purview may provide user statistical information related to the usage of the Services such as usage or traffic patterns in aggregate form to Third Parties, but such information will not include identifiable information of you or personally identifying information for you or you patients. Notwithstanding the above, you agree and acknowledge that Purview may completely anonymize your data and use such anonymized data to aggregate health information, results or other statistics that may be valuable and helpful to the future prevention and treatment of disease.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '8.4 You may request the deletion of return of your Data or that of your patients.  Upon such request, Purview will either delete that Data and provide your with such confirmation or will make that data available to you in electronic form.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '9. TERM AND TERMINATION.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '9.1 Term. This Agreement shall begin as of the Effective Date and shall remain in full force and effect until you cease to use the Service or unless and until such terms are modified by Purview. In such event you will be notified and you may decide to discontinue the use of the Service.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '9.2 Termination Upon an Event of Default. Purview may terminate this agreement immediately if you materially breach this Agreement or fail to pay Fees when due.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '10. INDEMNIFICATION.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '10.1 Patents and Copyrights. If an unaffiliated Third Party claims that any of the Services or Your Data infringe that party\'s patents or copyrights, Purview will, at Purview\'s expense, modify them to make them non-infringing, or to replace them with another service that is substantially a functional equivalent. If Purview determines that none of these options is reasonably available, then Purview may terminate this Agreement in whole or with respect to the affected Services. THIS IS Purview\'s ENTIRE OBLIGATION AND LIABILITY REGARDING INFRINGEMENT OR CLAIMS OF INFRINGEMENT.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '10.2 Your Indemnity. You will, at your expense, defend Purview against all claims by unaffiliated Third Parties arising from or related to the Your Data or your use or misuse of the Services, and you shall pay costs, losses, damages, and attorneys\' fees that a court finally awards, and all associated settlements.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '10.3 Indemnification Procedure. The indemnification obligations under Sections 10.1 and 10.2 are conditioned on the indemnifying Party receiving (i) prompt written notice of the claim, (ii) the necessary assistance, information and authority to defend the claim and perform its obligations, and (iii) sole control of the defense and settlement of such claim and all associated negotiations. This Section 10 states the indemnifying party\'s sole liability to, and the indemnified party\'s exclusive remedy against, the other party for any type of Claim described in this Section.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '11. DISCLAIMER. PURVIEW MAKES NO WARRANTIES, GUARANTEES OR REPRESENTATIONS OF ANY KIND, EXPRESS OR IMPLIED, WITH RESPECT TO THE OPERATION, CAPACITY, SPEED, FUNCTIONALITY, QUALIFICATIONS OR CAPABILITIES OF THE SERVICES OR ANY GOODS OR PERSONNEL RESOURCES PROVIDED HEREUNDER, INCLUDING, WITHOUT LIMITATION, ANY IMPLIED WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE, TITLE OR NON-INFRINGEMENT. Purview DOES NOT WARRANT ANY PARTICULAR RESULTS THAT MAY BE OBTAINED BY THE USE OF THE SERVICES OR THAT THE SERVICES OR ASSOCIATED SYSTEMS WILL OPERATE IN AN ERROR-FREE OR UNINTERRUPTED MANNER, OR IN COMBINATION WITH THIRD PARTY PRODUCTS.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '12. MISCELLANEOUS.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '12.1 Assignment. You may not assign, transfer, or sell any of its rights or delegate any of its responsibilities under this Agreement, without Purview\'s prior written consent. Any purported assignment of rights or delegation of performance in violation of this Section 12.1 is void.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '12.2 Force Majeure. Neither Party shall be liable for any delay or failure due to force majeure and other causes beyond its control, including for acts of God, labor disputes, changes in government policy/law, war, epidemics, acts or omissions of vendors or suppliers, disruptions caused by failures of the Internet or service providers (including those providing electricity, telecommunications links and/or Internet connectivity), or other occurrences which are beyond its reasonable control. This provision shall not apply to any of your payment obligations. In the event that either Party is excused from the performance of its obligations hereunder pursuant to this Section 12.2, then that Party shall use all efforts that are reasonable under the circumstances to resume performance of its obligations hereunder as soon as feasible.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '12.3 Compliance with Laws. The Services are provided solely for lawful purposes and use. Without limiting the other terms of this Agreement, you shall be solely responsible for, and agree to comply with, all laws, statutes, ordinances and/or regulations (including without limitation the laws and regulations governing export control, unfair competition, anti-discrimination, false advertising, privacy and data protection, and publicity) (collectively, "Laws") applicable to you and your business and its use of the Services. You will not directly or indirectly ship, transfer, export or transmit the Services into any country or permit or authorize use by any Person in any manner prohibited by the United States Export Administration Act, the International Traffic in Arms Regulations of the U.S. State Department, or any other export laws, restrictions, or regulations of any jurisdiction. The Parties agree that Purview may in its sole discretion make changes to any of the Services from time to time as may be reasonably necessary or appropriate for Purview to comply with applicable Laws. The Parties further agree that if a change in applicable Laws makes the continued performance of this Agreement (or any part thereof), in Purview\'s sole reasonable discretion, unduly burdensome or unlawful, Purview may terminate this Agreement in whole or in part upon notice to you.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '12.4 Entire Agreement. This Agreement constitutes the entire agreement and understanding of the Parties with respect to the subject matter hereof, superseding any prior oral or written communications. Sections 5, 7, 8, 10, 11 and 12 shall survive the termination or expiration of this Agreement. The Parties are independent contractors for all purposes under this Agreement.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '12.5 Governing Law. This Agreement shall be governed by the laws of the State of Maryland, USA without regard to its conflict of law provisions. Any dispute arising out of or related to this Agreement shall be resolved only in the state and federal courts located in Anne Arundel County, Maryland.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '12.7 Amendments and Waivers. No amendment to this Agreement shall be valid unless it is in writing and is signed by each of the Parties. Except where a specific period for action or inaction is provided herein, no delay on the part of either Party in exercising any right, power or privilege hereunder shall operate as a waiver thereof. No waiver on the part of either Party of any such right, power or privilege shall preclude any further exercise thereof or the exercise of any other such right, power or privilege.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '12.8 Severability. If any provision of this Agreement is held to be illegal or unenforceable for any reason, then such provision shall be deemed to be restated so as to be enforceable to the maximum extent permissible under law; the remainder of this Agreement shall remain in full force and effect.'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Dialog"].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Dialog"].FooterAuxiliaryContainer,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: '/license', className: 'button with-icon' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon icon-print' }),
                ' Print'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"],
                { onClick: function onClick(e) {
                    termsDialog.close();
                    form.connector.setValue('acceptedTerms', false);
                  } },
                'Cancel'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"],
                { className: 'highlight', onClick: function onClick(e) {
                    termsDialog.close();
                    form.connector.setValue('acceptedTerms', true);
                  } },
                'Agree'
              )
            )
          )
        )
      );
    }
  }]);

  return SignUpContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class) || _class) || _class) || _class);


function SignUpFooter() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'signup-question' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      'Already have an account?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],
      { className: 'button outline', to: '/' },
      'Sign in'
    )
  );
}

var SignUp = function SignUp() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SignInLayout__["a" /* SignInLayout */], { Content: SignUpContent, Footer: SignUpFooter });
};

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckoutSignupDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__signin_SignIn__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_startlibs_lib_lib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_startlibs_lib_lib__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class;

var _templateObject = _taggedTemplateLiteral(['\n  max-width: 36rem;\n  h2 {\n    color: ', ';\n  }\n  p {\n    color: rgba(0,0,0,0.5);\n    margin-top: -1.25rem;\n    margin-bottom: 1.5rem;\n    max-width: 28rem;\n  }\n'], ['\n  max-width: 36rem;\n  h2 {\n    color: ', ';\n  }\n  p {\n    color: rgba(0,0,0,0.5);\n    margin-top: -1.25rem;\n    margin-bottom: 1.5rem;\n    max-width: 28rem;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  text-align: center;\n  margin-top: 2rem;\n  ', ' {\n    width: 12rem;\n  }\n'], ['\n  text-align: center;\n  margin-top: 2rem;\n  ', ' {\n    width: 12rem;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 2rem -2rem -2rem;\n  background-color: ', ';\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  color: ', ';\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  border-top: 1px solid rgba(0,0,0,0.1);\n  ', ' {\n    margin-left: 1rem;\n  }\n'], ['\n  margin: 2rem -2rem -2rem;\n  background-color: ', ';\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  color: ', ';\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  border-top: 1px solid rgba(0,0,0,0.1);\n  ', ' {\n    margin-left: 1rem;\n  }\n']);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }













var SignUpDialog = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Dialog"])(_templateObject, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_startlibs_lib_lib__["getColor"])('main'));
var SubmitButtonContainer = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject2, __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"]);
var SignUpDialogFooter = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject3, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_startlibs_lib_lib__["getColor"])('gray240'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_startlibs_lib_lib__["getColor"])('gray120'), __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"]);
var ALREADY_REGISTERED = 'E-mail already registered.';

var CheckoutSignupDialog = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["withForm"])(__WEBPACK_IMPORTED_MODULE_5_startlibs__["formFetch"]), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withToggles"])('signInToggle', 'loading'), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(undefined, { signIn: __WEBPACK_IMPORTED_MODULE_8__reducers_index__["i" /* signIn */], setNotifications: __WEBPACK_IMPORTED_MODULE_8__reducers_index__["c" /* setNotifications */] }), _dec(_class = _dec2(_class = _dec3(_class = function (_React$PureComponent) {
  _inherits(CheckoutSignupDialog, _React$PureComponent);

  function CheckoutSignupDialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CheckoutSignupDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CheckoutSignupDialog.__proto__ || Object.getPrototypeOf(CheckoutSignupDialog)).call.apply(_ref, [this].concat(args))), _this), _this.onFailure = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_validation__["d" /* responseFailure */])(_this.props.form, function (_ref2) {
      var detail = _ref2.detail,
          errorKey = _ref2.errorKey,
          message = _ref2.message;
      return (
        // sign up
        errorKey === 'userexists' && { email: [ALREADY_REGISTERED] } || errorKey === 'userNotActivated' && { email: [ALREADY_REGISTERED] } || errorKey === 'userAccountRemoved' && { email: ['This account has been previously deleted. To reactivate the account please check ' + _this.props.form.properties.email + ' and click the reactivation link.'] } || message === 'error.validation' && { email: ['Invalid e-mail.'] } ||
        // sign in
        detail === 'Bad credentials' && { '': ['Invalid e-mail and password combination'] } || detail && detail.indexOf(' has not activated') >= 0 && { 'username': [ALREADY_REGISTERED] } || detail && detail.indexOf(' check your e-mail to reactivate') >= 0 && { 'username': ['This account has been previously deleted. To reactivate the account please check ' + _this.props.form.properties.email + ' and click the reactivation link.'] }
      );
    }), _this.preValidation = function () {
      return _this.props.signInToggle.isOpen ? _this.validateSignIn : _this.validateSignUp;
    }, _this.validateSignIn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_validation__["a" /* buildValidation */])({
      password: [__WEBPACK_IMPORTED_MODULE_4__lib_validation__["b" /* required */]],
      email: [__WEBPACK_IMPORTED_MODULE_4__lib_validation__["b" /* required */]]
    }, function (_ref3) {
      var email = _ref3.email,
          rest = _objectWithoutProperties(_ref3, ['email']);

      return _extends({}, rest, { username: email });
    }), _this.validateSignUp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_validation__["a" /* buildValidation */])({
      confirmEmail: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_validation__["f" /* confirmEmail */])('email'),
      email: [__WEBPACK_IMPORTED_MODULE_4__lib_validation__["g" /* emailValidation */], __WEBPACK_IMPORTED_MODULE_4__lib_validation__["b" /* required */]],
      firstName: [__WEBPACK_IMPORTED_MODULE_4__lib_validation__["b" /* required */]],
      lastName: [__WEBPACK_IMPORTED_MODULE_4__lib_validation__["b" /* required */]],
      password: [__WEBPACK_IMPORTED_MODULE_4__lib_validation__["b" /* required */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_validation__["c" /* minLength */])(6)]
    }, function (_ref4) {
      var confirmEmail = _ref4.confirmEmail,
          email = _ref4.email,
          rest = _objectWithoutProperties(_ref4, ['confirmEmail', 'email']);

      return _extends({}, rest, { langKey: 'en', email: email, login: email });
    }), _this.signInSuccess = function () {
      localStorage.setItem('hasLogged', 'true');
      _this.props.loading.open();
      Promise.all([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs__["getFetcher"])('/api/account'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs__["getFetcher"])('/api/stripe-customer')]).then(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            account = _ref6[0],
            stripeCustomer = _ref6[1];

        _this.props.setStripCustomer(stripeCustomer);
        _this.props.signIn(account);
        _this.props.nextStep();
      });
    }, _this.signUpSuccess = function () {
      _this.props.loading.open();
      localStorage.setItem('hasLogged', 'true');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs__["getFetcher"])('/api/account').then(function (result) {
        _this.props.setStripCustomer(undefined, true);
        _this.props.setNotifications("We sent an activation link to your email, please check it later.");
        _this.props.signIn(result);
        _this.props.nextStep();
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CheckoutSignupDialog, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.signInToggle.isOpen !== this.props.signInToggle.isOpen) {
        this.props.form.connector.clearErrors();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          closeDialog = _props.closeDialog,
          form = _props.form,
          loading = _props.loading,
          signInToggle = _props.signInToggle;

      return !signInToggle.isOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        SignUpDialog,
        {
          title: 'Sign up for Horos Cloud',
          closeDialog: closeDialog
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["Form"],
          {
            alwaysSave: true,
            preValidation: this.preValidation(),
            onSuccess: this.signUpSuccess,
            onFailure: this.onFailure,
            form: form,
            url: '/api/register'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Dialog"].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Create an account to proceed with your subscription, or ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'link', onClick: signInToggle.toggle },
                'sign in'
              ),
              ' if you are already registered.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["SplitColumnsContainer"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["TextInput"], {
                path: 'firstName',
                form: form,
                placeholder: 'Ex: John',
                label: 'First name:'
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["TextInput"], {
                path: 'lastName',
                form: form,
                placeholder: 'Ex: Doe',
                label: 'Last name:'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["TextInput"], {
              path: 'email',
              form: form,
              placeholder: 'Ex: example@email.com',
              label: 'Email:'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["TextInput"], {
              path: 'confirmEmail',
              form: form,
              placeholder: 'Ex: example@email.com',
              label: 'Confirm email:'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["TextInput"], {
              path: 'password',
              form: form,
              type: 'password',
              placeholder: 'Create a password',
              label: 'Password:'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["Errors"], { form: form })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            SubmitButtonContainer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"],
              { highlight: true, isLoading: form.isLoading || loading.isOpen, type: 'submit' },
              'Sign Up'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            SignUpDialogFooter,
            null,
            'Already have an account?',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"],
              { outline: true, disabled: form.isLoading || loading.isOpen, onClick: signInToggle.toggle },
              'Sign In'
            )
          )
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        SignUpDialog,
        {
          title: 'Sign in to Horos Cloud',
          closeDialog: closeDialog
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["Form"],
          {
            alwaysSave: true,
            preValidation: this.preValidation(),
            onSuccess: this.signInSuccess,
            onFailure: this.onFailure,
            form: form,
            url: '/api/authenticate'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Dialog"].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["TextInput"], {
              path: 'email',
              form: form,
              placeholder: 'Your email',
              label: 'Email:'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["TextInput"], {
              path: 'password',
              form: form,
              type: 'password',
              placeholder: 'Your password',
              label: 'Password:'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_form__["Errors"], { form: form })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            SubmitButtonContainer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"],
              { highlight: true, type: 'submit', isLoading: form.isLoading || loading.isOpen },
              'Sign In'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            SignUpDialogFooter,
            null,
            'Don\'t have an account?',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"],
              { disabled: form.isLoading || loading.isOpen, onClick: signInToggle.toggle },
              'Sign Up'
            )
          )
        )
      );
    }
  }]);

  return CheckoutSignupDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class) || _class) || _class);

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportCheckoutSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StorageCheckoutSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 2rem;\n  ', ' {\n    border: 4px solid ', ';\n    width: 4rem;\n    height: 4rem;\n    line-height: 41px;\n    text-align: center;\n    display: inline-block;\n    border-radius: 100px;\n    margin-right: 1rem;\n    font-size: 34px;\n  }\n  p {\n    margin-bottom: 0;\n    font-size: 14px;\n    color: rgba(0,0,0,0.6);\n  }\n'], ['\n  color: ', ';\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 2rem;\n  ', ' {\n    border: 4px solid ', ';\n    width: 4rem;\n    height: 4rem;\n    line-height: 41px;\n    text-align: center;\n    display: inline-block;\n    border-radius: 100px;\n    margin-right: 1rem;\n    font-size: 34px;\n  }\n  p {\n    margin-bottom: 0;\n    font-size: 14px;\n    color: rgba(0,0,0,0.6);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin-bottom: 3rem;\n  p {\n    margin-bottom 0;\n  }\n'], ['\n  margin-bottom: 3rem;\n  p {\n    margin-bottom 0;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-bottom: 2rem;\n'], ['\n  margin-bottom: 2rem;\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }







var SuccessFeedback = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib__["getColor"])('success'), __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Icon"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib__["getColor"])('success'));
var AdditionalInstruction = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2);
var ManageSubscriptionButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"].Link)(_templateObject3);

var CheckoutSuccess = function (_React$PureComponent) {
  _inherits(CheckoutSuccess, _React$PureComponent);

  function CheckoutSuccess() {
    _classCallCheck(this, CheckoutSuccess);

    return _possibleConstructorReturn(this, (CheckoutSuccess.__proto__ || Object.getPrototypeOf(CheckoutSuccess)).apply(this, arguments));
  }

  _createClass(CheckoutSuccess, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isStorageCheckout = _props.isStorageCheckout,
          title = _props.title,
          finishButton = _props.finishButton,
          content = _props.content,
          additional = _props.additional,
          orderPreview = _props.orderPreview;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content edit-profile' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-header checkout-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            title
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          SuccessFeedback,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Icon"], { icon: 'check' }),
          content
        ),
        additional,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null),
        orderPreview(null, true),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          ManageSubscriptionButton,
          { to: '/billing', small: true, outline: true },
          'Manage Subscription'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__CheckoutComponents__["b" /* ServicesOfferingWrapper */],
          null,
          isStorageCheckout ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'card' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: '/public/report-plan-220x220.png', alt: 'Plan Icon' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              'Check out Horos Cloud Reporting and Sharing tools'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Share studies and create reports with your Horos Cloud subscription!',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'Select a plan that best fits your study needs.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"].Link,
              { highlight: true, to: '/checkout' },
              'Check our plans'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"].a,
              { target: '_blank', href: 'https://horosproject.org/horos-cloud-reporting/', outline: true },
              'Learn more'
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'card' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: '/public/storage-plan-220x220.png', alt: 'Plan Icon' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              'Would you like to store and have access to your image studies using the cloud?'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Securely store and easily access medical imaging studies in your Horos Cloud.',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'You can access them when and where you need to.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"].Link,
              { highlight: true, to: '/storage/checkout' },
              'Check our plans'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"].a,
              { target: '_blank', href: 'https://horosproject.org/cloud-access-pricing/', outline: true },
              'Learn more'
            )
          )
        ),
        finishButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-footer' },
          finishButton
        )
      );
    }
  }]);

  return CheckoutSuccess;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var ReportCheckoutSuccess = function ReportCheckoutSuccess(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckoutSuccess, _extends({
    title: 'Horos Cloud subscription',
    content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'You successfully subscribed to ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'b',
          null,
          props.planName,
          ' plan'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Thank you for subscribing. ',
        !props.isFreePlanSelected && "Check the details of your order below."
      )
    )
  }, props));
};

var StorageCheckoutSuccess = function StorageCheckoutSuccess(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckoutSuccess, _extends({
    title: 'Horos Access subscription',
    isStorageCheckout: true,
    content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'You successfully subscribed to ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'b',
          null,
          props.planName,
          ' plan'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Thank you for subscribing. Check the details of your order below.'
      )
    ),
    additional: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      AdditionalInstruction,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'b',
          null,
          'We will contact you in 1 business day to start your cloud storage setup.'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'If you need any additional informance or assistance, feel free to reach out to our ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'link', href: 'mailto:support@horosproject.org' },
          'support team'
        ),
        '.'
      )
    )
  }, props));
};

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreditCardCheckout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_little_loader__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_little_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_little_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_StripeConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CheckoutComponents__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_icepath__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__user_Billing__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CaptchaUtils__ = __webpack_require__(46);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var CreditCardCheckout = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_hocs__["withToggles"])('loading', 'updateCard'), _dec(_class = function (_React$PureComponent) {
  _inherits(CreditCardCheckout, _React$PureComponent);

  function CreditCardCheckout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CreditCardCheckout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreditCardCheckout.__proto__ || Object.getPrototypeOf(CreditCardCheckout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.cardErrors = {
      cardCvc: { message: 'Your card\'s security code is incomplete.' },
      cardExpiry: { message: 'Your card\'s expiration date is incomplete.' },
      card: { message: 'Your card number is incomplete.' }
    }, _this.preValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_validation__["a" /* buildValidation */])({
      cardholder: __WEBPACK_IMPORTED_MODULE_9__lib_validation__["b" /* required */],
      country: __WEBPACK_IMPORTED_MODULE_9__lib_validation__["b" /* required */],
      businessName: _this.props.skipContactInfo ? function () {
        return false;
      } : __WEBPACK_IMPORTED_MODULE_9__lib_validation__["b" /* required */],
      phoneNumber: _this.props.skipContactInfo ? function () {
        return false;
      } : __WEBPACK_IMPORTED_MODULE_9__lib_validation__["b" /* required */],
      zipCode: [__WEBPACK_IMPORTED_MODULE_9__lib_validation__["b" /* required */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_validation__["c" /* minLength */])(4)]
    }), _this.onlyPlanPreValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_validation__["a" /* buildValidation */])({
      businessName: _this.props.skipContactInfo ? function () {
        return false;
      } : __WEBPACK_IMPORTED_MODULE_9__lib_validation__["b" /* required */],
      phoneNumber: _this.props.skipContactInfo ? function () {
        return false;
      } : __WEBPACK_IMPORTED_MODULE_9__lib_validation__["b" /* required */]
    }), _this.captchaRef = { current: null }, _this.loadStripe = function () {
      return window.Stripe ? Promise.resolve(window.Stripe) : new Promise(function (res, rej) {
        return __WEBPACK_IMPORTED_MODULE_4_little_loader___default()('https://js.stripe.com/v3/', function (err) {
          if (err) {
            rej();
          }
          res(window.Stripe);
        });
      });
    }, _this.handleSubmit = function (e) {
      e.preventDefault();
      _this.props.loading.open();
      if (_this.props.updateCard.isOpen) {
        _this.validate().then(function () {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__CaptchaUtils__["b" /* executeCaptcha */])();
        }).catch(function () {
          _this.props.loading.close();
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__CaptchaUtils__["b" /* executeCaptcha */])().catch(function () {
          _this.props.loading.close();
        });
      }
    }, _this.handleCaptchaSuccess = function (captchaToken) {
      if (_this.props.updateCard.isOpen) {
        _this.submitSubscriptionUpdate(captchaToken);
      } else {
        _this.submitPlanUpdate(captchaToken);
      }
    }, _this.submitPlanUpdate = function (captchaToken) {
      var _this$props = _this.props,
          loading = _this$props.loading,
          skipContactInfo = _this$props.skipContactInfo,
          nextStep = _this$props.nextStep,
          form = _this$props.form,
          workstationsVPN = _this$props.workstationsVPN,
          prorate = _this$props.prorate,
          coupon = _this$props.coupon;

      var stripePlanId = _this.props.finalPlan.id;
      var values = _this.props.form.properties;
      _this.props.form.connector.clearErrors();
      var validation = _this.onlyPlanPreValidation(form.properties, {});
      if (validation.errors) {
        form.connector.setErrors(validation.errors);
        return;
      }
      loading.open();
      Promise.all([skipContactInfo ? Promise.resolve() : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_startlibs__["postFetcher"])('/api/contact-info', { businessName: values.businessName, phoneNumber: values.phoneNumber }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_startlibs__["postFetcher"])('/api/update-subscription', _extends({
        stripeCardToken: __WEBPACK_IMPORTED_MODULE_7_icepath__["ice"].get(_this.props.currentCard, 'id'),
        stripePlanId: stripePlanId,
        captchaToken: captchaToken,
        subscriptionType: 'STORAGE',
        workstationsVPN: workstationsVPN
      }, coupon && prorate && prorate.discount ? { coupon: coupon } : {}), { method: 'PUT' })]).then(nextStep).catch(loading.close);
    }, _this.stripeResult = null, _this.validate = function () {
      var _this$props2 = _this.props,
          loading = _this$props2.loading,
          form = _this$props2.form;
      var stripe = _this.state.stripe;

      var validated = _this.preValidation(form.properties, {});
      var cardErrors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_icepath__["ice"])(_this.cardErrors).filter(function (v) {
        return v;
      }).map(function (v) {
        return [v.message];
      }).value();
      var stripeValidation = Object.keys(cardErrors).length ? stripe.createToken(_this.card).then(function (result) {
        return { card: [result.error.message] };
      }) : Promise.resolve({});

      if (validated.errors) {
        stripeValidation.then(function (stripeErrors) {
          return form.connector.setErrors(_extends({}, validated.errors, cardErrors));
        });
        return;
      }
      loading.open();
      var values = form.properties;
      return Promise.all([stripe.createToken(_this.card, {
        address_zip: values.zipCode,
        address_country: values.country,
        name: values.cardholder
      }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_startlibs__["postFetcher"])('/api/contact-info', { businessName: values.businessName, phoneNumber: values.phoneNumber })]).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            stripeResult = _ref3[0],
            profileResult = _ref3[1];

        if (stripeResult.error || profileResult.error) {
          return Promise.reject(stripeResult.error ? stripeResult : profileResult);
        } else {
          _this.stripeResult = stripeResult;
        }
      }).catch(function (result) {
        if (result && result.error) {
          form.connector.setErrors({ card: [result.error.message] });
        } else {
          form.connector.setErrors({ form: [__WEBPACK_IMPORTED_MODULE_8_startlibs__["AJAX_ERROR"]] });
        }
        loading.close();
        return Promise.reject();
      });
    }, _this.submitSubscriptionUpdate = function (captchaToken) {
      var _this$props3 = _this.props,
          loading = _this$props3.loading,
          nextStep = _this$props3.nextStep;
      // Send the token to your server.

      var stripePlanId = _this.props.finalPlan.id;
      var coupon = _this.props.appliedCoupon;
      var workstationsVPN = _this.props.workstationsVPN;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_startlibs__["postFetcher"])('/api/update-subscription', _extends({
        captchaToken: captchaToken,
        stripeCardToken: _this.stripeResult.token.id,
        stripePlanId: stripePlanId,
        subscriptionType: 'STORAGE',
        workstationsVPN: workstationsVPN
      }, coupon ? { coupon: coupon } : {}), { method: 'PUT' }).then(nextStep).catch(function (e) {
        _this.props.loading.close();
        _this.props.form.connector.setErrors({ "card": [e && e.errorResponse ? e.errorResponse.detail || e.errorResponse.title : __WEBPACK_IMPORTED_MODULE_8_startlibs__["AJAX_ERROR"]] });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CreditCardCheckout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.isCurrentPlanSelected) {
        return this.props.prevStep();
      }

      Promise.all([this.loadStripe(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__CaptchaUtils__["a" /* waitCaptcha */])(function (token) {
        _this2.handleCaptchaSuccess(token);
      }, this.captchaRef)]).then(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            Stripe = _ref5[0],
            captcha = _ref5[1];

        return _this2.setState({ stripe: Stripe(__WEBPACK_IMPORTED_MODULE_5__config_StripeConfig__["a" /* STRIPE_KEY */]) });
      });
      this.props.form.connector.clearErrors();
      window.scroll(0, 0);
      if (!this.props.currentCard) {
        this.props.updateCard.open();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.form.connector.clearErrors();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps, oldState) {
      var _this3 = this;

      if (oldState.stripe !== this.state.stripe) {
        var elements = this.state.stripe.elements();
        var style = {
          base: {
            color: '#3c3c3c',
            lineHeight: '18px',
            fontFamily: '"Open Sans", sans-serif',
            fontSize: '14px',
            '::placeholder': {
              color: 'rgba(0,0,0,0.35)'
            }
          },
          invalid: {
            color: '#C3282D',
            iconColor: '#fa755a'
          }
        };

        var cardExpiry = elements.create('cardExpiry', { style: style });
        cardExpiry.mount('#card-expiry-element');
        cardExpiry.on('change', function (_ref6) {
          var error = _ref6.error;

          _this3.cardModified = true;
          _this3.cardErrors = _extends({}, _this3.cardErrors, { cardExpiry: error });
        });

        var cardCvc = elements.create('cardCvc', { style: style });
        cardCvc.mount('#card-cvc-element');
        cardCvc.on('change', function (_ref7) {
          var error = _ref7.error;

          _this3.cardModified = true;
          _this3.cardErrors = _extends({}, _this3.cardErrors, { cardCvc: error });
        });

        this.card = elements.create('cardNumber', { style: style });
        this.card.on('change', function (event) {
          _this3.setState({ cardBrand: event.brand });
          _this3.cardModified = true;
          _this3.cardErrors = _extends({}, _this3.cardErrors, { card: event.error });
        });
        this.card.mount('#card-element');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          form = _props.form,
          skipContactInfo = _props.skipContactInfo,
          currentCard = _props.currentCard,
          hasCurrentActivePlan = _props.hasCurrentActivePlan,
          isStorage = _props.isStorage,
          updateCard = _props.updateCard,
          loading = _props.loading,
          prevStep = _props.prevStep,
          orderPreview = _props.orderPreview;
      var cardBrand = this.state.cardBrand;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content edit-profile' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-header checkout-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            hasCurrentActivePlan && "Update ",
            'Horos ',
            isStorage ? "Access" : "Cloud",
            ' subscription'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"].a,
            { small: true, href: 'https://info.horosproject.org/horos-cloud-faq', target: '_blank' },
            'Learn more'
          )
        ),
        orderPreview(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
          { small: true, onClick: prevStep },
          'Change order'
        )),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          null,
          !updateCard.isOpen && currentCard && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'Credit card details'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Subscription charges for the selected plans will be done in the following credit card registered in your account. You can change it clicking on the button bellow (all your subscriptions will be charged to the new credit card).'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__user_Billing__["e" /* CreditCardDetails */],
              { card: currentCard },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
                { small: true, onClick: updateCard.open },
                'Change credit card'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__CheckoutComponents__["a" /* CreditCardWrapper */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: updateCard.isOpen ? 'expanded-card' : 'hidden' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'update-card-heading' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'heading-text' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    null,
                    'Credit card details'
                  ),
                  !currentCard ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'Please fill in your new credit card details below:'
                  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'By changing your credit card, ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'b',
                      null,
                      'all subscriptions will be charged according to the new registered card'
                    ),
                    '.'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'action-wrapper' },
                  currentCard && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
                    { onClick: function onClick() {
                        updateCard.close();
                        form.connector.clearErrors();
                      } },
                    'Use current credit card instead'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'card billing-card' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["TextInput"], {
                  form: form,
                  autoFocus: true,
                  type: 'text',
                  path: 'cardholder',
                  label: 'Name on card:',
                  placeholder: 'Ex: John Doe'
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["Field"],
                  { label: 'Card number:' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CheckoutComponents__["c" /* StripeInput */], { id: 'card-element' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CheckoutComponents__["d" /* CreditCardIcon */], { src: '/public/icon/' + (cardBrand || 'unknown') + '.svg' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["SplitColumnsContainer"],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["Field"],
                    { label: 'Expiration:' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CheckoutComponents__["c" /* StripeInput */], { id: 'card-expiry-element' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["Field"],
                    { label: 'CVC:' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CheckoutComponents__["c" /* StripeInput */], { id: 'card-cvc-element' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["SplitColumnsContainer"],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["TextInput"], {
                    form: form,
                    type: 'text',
                    path: 'country',
                    label: 'Country:',
                    placeholder: 'Ex: USA'
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["TextInput"], {
                    form: form,
                    type: 'text',
                    path: 'zipCode',
                    label: 'Zip code:',
                    placeholder: 'Ex: 21401'
                  })
                )
              )
            )
          ),
          !skipContactInfo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__CheckoutComponents__["a" /* CreditCardWrapper */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'expanded-card' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'update-card-heading' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'heading-text' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    null,
                    'Contact details'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'We will contact you in 1 business day to start you cloud storage setup.'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'card billing-card' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["TextInput"], {
                  form: form,
                  path: 'businessName',
                  label: 'Business Name:'
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["TextInput"], {
                  form: form,
                  setValue: function setValue(newValue, _, _setValue) {
                    return _setValue(newValue.replace(/[^0-9()\-+\s]/, ''));
                  },
                  path: 'phoneNumber',
                  label: 'Phone Number:'
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_form__["Errors"], { form: form })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-footer' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
            { onClick: prevStep },
            'Return'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"],
            { highlight: true, isLoading: loading.isOpen, onClick: this.handleSubmit },
            'Subscribe'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          ref: function ref(el) {
            return _this4.captchaRef.current = el;
          },
          className: 'g-recaptcha'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__CaptchaUtils__["c" /* RecaptchaBrandingText */],
            null,
            'This site is protected by reCAPTCHA and the Google ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                href: 'https://policies.google.com/privacy',
                rel: 'noopener noreferrer',
                target: '_blank'
              },
              'Privacy Policy'
            ),
            ' and ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                href: 'https://policies.google.com/terms',
                rel: 'noopener noreferrer',
                target: '_blank'
              },
              'Terms of Service'
            ),
            ' apply.'
          )
        )
      );
    }
  }]);

  return CreditCardCheckout;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STRIPE_KEY; });
var STRIPE_KEY = 'pk_live_nwa1uyr0ZYgUTMuooDcP4ScF';

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportInfoCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_report_components__ = __webpack_require__(14);




var ReportInfoCard = function ReportInfoCard(_ref) {
  var report = _ref.report;

  var studyToDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components__["c" /* dicomDateToDate */])(report.studydate);
  var studydate = isNaN(studyToDate.getTime()) ? report.studydate : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components__["a" /* formatDate */])(studyToDate, __WEBPACK_IMPORTED_MODULE_2_report_components__["b" /* en_US */], 'L dd, yyyy');
  var lastSaved = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components__["a" /* formatDate */])(new Date(report.lastSaved), __WEBPACK_IMPORTED_MODULE_2_report_components__["b" /* en_US */], 'L dd, yyyy - hh:mm');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'card with-icon dialog-version' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'card-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'card-icon' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Icon"], { icon: report.finished ? 'checked-report' : 'report' })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'card-title' },
        report.patientName
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'card-detail' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'b',
          null,
          'Study: '
        ),
        report.studydesc,
        ' (',
        studydate,
        ')'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'card-detail' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'b',
          null,
          'Referred by: '
        ),
        report.refphysician ? report.refphysician : "Unknown"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { hidden: true, className: 'card-footer' },
      (report.finished ? 'Finished on ' : 'Last draft saved on ') + lastSaved
    )
  );
};

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FirstStepsGuide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FirstSteps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  .need-help {\n    margin-top: 2rem;\n  }\n'], ['\n  .need-help {\n    margin-top: 2rem;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 4rem 1rem;\n  text-align: center;\n  background-color: rgba(0,0,0,0.05);\n  border-radius: 8px;\n  h2 {\n      margin: 0 auto 3rem;\n      font-size: 19px;\n      line-height: normal;\n      max-width: 350px;\n  }\n  p {\n      font-size: 14px;\n      margin: 0 auto 1.5rem;\n  }\n  .horos-download-button {\n      margin-bottom: 0.5rem;\n      min-width: 16rem;\n  }\n  .download-message {\n    font-size: 11px;\n    color: rgba(0,0,0,0.5);\n  }\n  .screenshot-image {\n    width: 100%;\n    max-width: 580px;\n    margin: 4rem auto 2rem;\n  }\n'], ['\n  padding: 4rem 1rem;\n  text-align: center;\n  background-color: rgba(0,0,0,0.05);\n  border-radius: 8px;\n  h2 {\n      margin: 0 auto 3rem;\n      font-size: 19px;\n      line-height: normal;\n      max-width: 350px;\n  }\n  p {\n      font-size: 14px;\n      margin: 0 auto 1.5rem;\n  }\n  .horos-download-button {\n      margin-bottom: 0.5rem;\n      min-width: 16rem;\n  }\n  .download-message {\n    font-size: 11px;\n    color: rgba(0,0,0,0.5);\n  }\n  .screenshot-image {\n    width: 100%;\n    max-width: 580px;\n    margin: 4rem auto 2rem;\n  }\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }






var FirstStepsPage = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);

var FirstStepsGuide = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);

var FirstSteps = function (_React$PureComponent) {
  _inherits(FirstSteps, _React$PureComponent);

  function FirstSteps() {
    _classCallCheck(this, FirstSteps);

    return _possibleConstructorReturn(this, (FirstSteps.__proto__ || Object.getPrototypeOf(FirstSteps)).apply(this, arguments));
  }

  _createClass(FirstSteps, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        FirstStepsPage,
        { className: 'content edit-profile' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'First steps'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          FirstStepsGuide,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'guide-content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              null,
              'To create a report or share a study please launch Horos on macOS'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_components__["Button"].a,
              { highlight: true, href: 'horos://', className: 'horos-download-button' },
              'Launch Horos'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'download-message' },
              'Do not have Horos App installed yet? ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'link nowrap', target: '_blank', href: 'https://horosproject.org/download-horos/' },
                'Download here'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'screenshot-image', alt: 'instructions', src: '/public/firststeps-screenshot.png' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'need-help' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'b',
            null,
            'Need help?'
          ),
          ' We have a dedicated team for all questions regarding Horos Cloud. Contact us at ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'link', href: 'mailto:support@horosproject.org' },
            'support@horosproject.org'
          ),
          ' or call us at ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'b',
            null,
            '(800) 501 - 1537'
          ),
          '.'
        )
      );
    }
  }]);

  return FirstSteps;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sendEmailFetcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReportViewerHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_report_components__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dashboard_ReportInfoCard__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);







var sendEmailFetcher = function sendEmailFetcher(reportUid) {
  return function (data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs__["postFetcher"])("/api/share-report/" + reportUid, data);
  };
};

var getInfo = function getInfo(basicInfo, dicomInfo) {
  return function (key) {
    return basicInfo.filter(function (_) {
      return _.dicomField === key;
    }).map(function (_) {
      return _.value;
    })[0] || dicomInfo[key];
  };
};
var translateReportPropsToInfoCard = function translateReportPropsToInfoCard(_ref) {
  var lastSaved = _ref.lastSaved,
      finished = _ref.finished,
      dicomInfo = _ref.dicomInfo,
      reportBasicInfos = _ref.reportBasicInfos;

  var getKey = getInfo(Object.values(reportBasicInfos), dicomInfo);
  return {
    lastSaved: lastSaved,
    finished: finished,
    studydate: getKey('studydate'),
    patientName: getKey('patientname'),
    studydesc: getKey('studydesc'),
    refphysician: getKey('refphysician')
  };
};

var ReportViewerHeader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (_ref2) {
  var report = _ref2.report;
  return {
    reportRecipients: report.reportRecipients,
    reportInfoCard: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__dashboard_ReportInfoCard__["a" /* ReportInfoCard */], { report: translateReportPropsToInfoCard(report) }),
    renderEndPoint: report.pdfrenderer.reportRendererEndpoint,
    loaderEndPoint: report.pdfrenderer.reportLoaderEnpoint,
    userEmail: report.userEmail,
    reportFinished: report.finished,
    lastSaved: report.lastSaved,
    reportUID: report.reportUID,
    attachedReport: true,
    isUploadingKeyImages: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["a" /* isUploadingKeyImages */])(report.reportKeyImages),
    language: report.reportSettings.layout.language,
    dateFormat: report.reportSettings.layout.dateFormat,
    studies: report.dicomInfo.studies,
    readOnly: report.readOnly,
    patientName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_report_components_lib_selectors__["b" /* getPatientName */])(report),
    sendEmailFetcher: sendEmailFetcher(report.reportUID)
  };
})(__WEBPACK_IMPORTED_MODULE_1_report_components__["e" /* ViewerHeader */]);

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getWorkstations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var getItems = function getItems(stateSelector) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(stateSelector, function (items) {
    return items.order ? items.order.map(function (_) {
      return items[_];
    }) : [];
  });
};

var getReports = getItems(function (state) {
  return state.reports;
});

var getWorkstations = getItems(function (state) {
  return state.workstations;
});

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PageCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CardContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CardIcon; });
/* unused harmony export ErrorIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SuccessIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DownloadLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PageFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__);
var _templateObject = _taggedTemplateLiteral(['\n  max-width: 40rem;\n  margin: 0 auto;\n  padding: 4rem 1rem 2rem;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n'], ['\n  max-width: 40rem;\n  margin: 0 auto;\n  padding: 4rem 1rem 2rem;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: white;\n  border-radius: 5px;\n  box-shadow: 0 0 4px 0 rgba(0,0,0,.25);\n  text-align: center;\n  color: rgba(0,0,0,0.6);\n  position: relative;\n  margin: 6rem 0;\n  h2 {\n    color: ', ';\n    margin-bottom: .5rem;\n    font-size: 21px;\n    &.error-title {\n      color: ', ';\n    }\n  }\n  .main-text {\n    font-size: 14px;\n    margin: 0 auto 1rem;\n  }\n  .download-text {\n    max-width:  12rem;\n  }\n  .patient-name {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 10px;\n    margin-top: -.25rem;\n  }\n  .card-note {\n    margin-top: 1rem;\n    color: rgba(0,0,0,0.5);\n  }\n  form {\n    margin-top: 1.5rem;\n  }\n  label {\n    text-align: left;\n    display: block;\n    color: ', ';\n  }\n  .post-field-description {\n    margin-bottom: 2rem;\n  }\n  ', ' {\n    min-width: 130px;\n    margin-top: 1rem;\n  }\n  li {\n    text-align: left;\n  }\n'], ['\n  background-color: white;\n  border-radius: 5px;\n  box-shadow: 0 0 4px 0 rgba(0,0,0,.25);\n  text-align: center;\n  color: rgba(0,0,0,0.6);\n  position: relative;\n  margin: 6rem 0;\n  h2 {\n    color: ', ';\n    margin-bottom: .5rem;\n    font-size: 21px;\n    &.error-title {\n      color: ', ';\n    }\n  }\n  .main-text {\n    font-size: 14px;\n    margin: 0 auto 1rem;\n  }\n  .download-text {\n    max-width:  12rem;\n  }\n  .patient-name {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 10px;\n    margin-top: -.25rem;\n  }\n  .card-note {\n    margin-top: 1rem;\n    color: rgba(0,0,0,0.5);\n  }\n  form {\n    margin-top: 1.5rem;\n  }\n  label {\n    text-align: left;\n    display: block;\n    color: ', ';\n  }\n  .post-field-description {\n    margin-bottom: 2rem;\n  }\n  ', ' {\n    min-width: 130px;\n    margin-top: 1rem;\n  }\n  li {\n    text-align: left;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  padding: 6rem 3rem 3rem;\n  position: relative;\n'], ['\n  padding: 6rem 3rem 3rem;\n  position: relative;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%,-50%);\n  img {\n    width: 110px\n  }\n  ', ' {\n    position: absolute;\n    bottom: -6px;\n    right: -6px;\n    font-size: 26px;\n    background: white;\n    border-radius: 50%;\n    width: 32px;\n    height: 32px;\n    line-height: 32px;\n    padding-left: 1px;\n    text-align: center;\n    box-shadow: 0 0 4px 0 rgba(0,0,0,0.25);\n  }\n'], ['\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%,-50%);\n  img {\n    width: 110px\n  }\n  ', ' {\n    position: absolute;\n    bottom: -6px;\n    right: -6px;\n    font-size: 26px;\n    background: white;\n    border-radius: 50%;\n    width: 32px;\n    height: 32px;\n    line-height: 32px;\n    padding-left: 1px;\n    text-align: center;\n    box-shadow: 0 0 4px 0 rgba(0,0,0,0.25);\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: white;\n  font-size: 50px;\n  line-height: 60px;\n  background: ', ';\n  border-radius: 50%;\n  height: 60px;\n  width: 60px;\n  display: block;\n  text-align: center;\n  margin: 2rem auto;\n'], ['\n  color: white;\n  font-size: 50px;\n  line-height: 60px;\n  background: ', ';\n  border-radius: 50%;\n  height: 60px;\n  width: 60px;\n  display: block;\n  text-align: center;\n  margin: 2rem auto;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  background: white;\n  color: ', ';\n  line-height: 56px;\n  border: 4px solid ', ';\n'], ['\n  background: white;\n  color: ', ';\n  line-height: 56px;\n  border: 4px solid ', ';\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  margin: 2rem auto;\n'], ['\n  margin: 2rem auto;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  text-align: center;\n  color: rgba(0,0,0,0.4);\n  a {\n    color: inherit;\n    font-weight: 600;\n    font-size: 13px;\n    ~ a {\n      margin-left: 0.5rem;\n    }\n    :hover {\n      color: ', ';\n    }\n  }\n'], ['\n  text-align: center;\n  color: rgba(0,0,0,0.4);\n  a {\n    color: inherit;\n    font-weight: 600;\n    font-size: 13px;\n    ~ a {\n      margin-left: 0.5rem;\n    }\n    :hover {\n      color: ', ';\n    }\n  }\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }





var PageContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject);
var PageCard = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('main'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('alert'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('gray90'), __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Button"]);
var CardContent = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject3);
var CardIcon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject4, __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Icon"]);
var ErrorIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Icon"])(_templateObject5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('alert'));
var SuccessIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(ErrorIcon)(_templateObject6, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('main'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('main'));
var DownloadLoading = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_components__["Loading"])(_templateObject7);
var PageFooter = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject8, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"])('main'));

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ACTIVATED_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SignIn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignInLayout__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_icepath__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_little_loader__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_little_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_little_loader__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class, _class2, _temp2, _initialiseProps;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var defaultProps = { rememberMe: true };

var doRedirect = ['/activated', '/profile', '/workstations', '/changePassword', '/account-settings', '/checkout', '/billing', /\/deleteAccount\/.*/, /\/reportCleanup\/.*/, /\/report\/.*/];
var NOT_ACTIVATED_ERROR = function NOT_ACTIVATED_ERROR(email) {
  return 'This account is not activated yet. Please check ' + email + ' and click the activation link to finish sign up.';
};

var SignInContent = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__["withToggles"])('loading', 'activationFeedback'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["withForm"])(__WEBPACK_IMPORTED_MODULE_5_startlibs__["formFetch"]), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(undefined, { signIn: __WEBPACK_IMPORTED_MODULE_7__reducers__["i" /* signIn */] }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["withRouter"])(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__["withRouteTo"])(_class = _dec(_class = _dec2(_class = _dec3(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(SignInContent, _React$Component);

  function SignInContent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SignInContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignInContent.__proto__ || Object.getPrototypeOf(SignInContent)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SignInContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isLoggedIn) {
        this.props.history.push('/');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          form = _props.form,
          loading = _props.loading,
          activationFeedback = _props.activationFeedback;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'opening-section' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Sign in to Horos Cloud'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Enter your details below'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["Form"],
          {
            alwaysSave: true,
            preValidation: this.preValidation,
            onSuccess: this.onSuccess,
            onFailure: this.onFailure,
            form: form,
            url: '/api/authenticate',
            defaultProperties: defaultProps
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["TextInput"], {
            tabIndex: 1,
            label: 'E-mail:',
            placeholder: 'example@email.com',
            form: form,
            path: 'username'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["Field"],
            { label: 'Password:' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],
              { className: (Object.keys(form.errors).length ? 'has-error ' : '') + 'password-link', to: '/recovery',
                tabIndex: 2 },
              'Forgot password?'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["TextInput"], {
              tabIndex: 1,
              type: 'password',
              form: form,
              withoutField: true,
              path: 'password',
              placeholder: 'Enter your password'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'checkbox-list' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["SimpleCheckbox"], {
              form: form,
              label: 'Keep me signed in while in this computer',
              path: 'rememberMe'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"],
              { isLoading: form.isLoading || loading.isOpen, className: 'highlight with-loader', tabIndex: 1, type: 'submit' },
              'Sign in'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_form__["Errors"], { form: form })
        ),
        activationFeedback.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActivationFeedbackDialog, { email: this.props.form.properties.username, closeDialog: activationFeedback.close })
      );
    }
  }]);

  return SignInContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onFailure = function () {
    _this2.failedUsername = _this2.props.form.properties.username;
    _this2.failedTime = Date.now();

    var _ref2 = arguments.length <= 1 ? undefined : arguments[1],
        response = _ref2.response;

    if (response.detail && response.detail.indexOf(' has not activated') >= 0) {
      return _this2.props.activationFeedback.open();
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_validation__["d" /* responseFailure */])(_this2.props.form, function (_ref3) {
      var detail = _ref3.detail,
          message = _ref3.message;
      return detail === 'Bad credentials' && { '': ['Invalid e-mail and password combination'] } || detail && detail.indexOf(' check your e-mail to reactivate') >= 0 && { 'username': ['This account has been previously deleted. To reactivate the account please check ' + _this2.props.form.properties.username + ' and click the reactivation link.'] };
    }).apply(undefined, arguments);
  };

  this.onSuccess = function () {
    localStorage.setItem('hasLogged', 'true');
    var url = _this2.props.originalLocation;
    _this2.props.loading.open();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs__["getFetcher"])('/api/account').then(function (result) {
      return _this2.props.signIn(result);
    }).then(function () {
      if (doRedirect.find(function (_) {
        return _.test ? _.test(url) : _ === url;
      })) {
        _this2.props.history.push(_this2.props.originalLocation);
      } else {
        _this2.props.history.push('/');
      }
    });
  };

  this.preValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_validation__["a" /* buildValidation */])({
    password: [__WEBPACK_IMPORTED_MODULE_8__lib_validation__["b" /* required */]],
    username: [__WEBPACK_IMPORTED_MODULE_8__lib_validation__["b" /* required */], function () {
      return _this2.props.form.properties.username === _this2.failedUsername && __WEBPACK_IMPORTED_MODULE_10_icepath__["ice"].get(_this2.props.form, ['errors', 'username', 0]) === NOT_ACTIVATED_ERROR && _this2.failedTime + 1000 * 30 > Date.now() && NOT_ACTIVATED_ERROR(_this2.props.form.properties.username);
    }]
  });
}, _temp2)) || _class) || _class) || _class) || _class) || _class);


var ActivationFeedbackDialog = function ActivationFeedbackDialog(_ref4) {
  var email = _ref4.email,
      closeDialog = _ref4.closeDialog;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Dialog"],
    {
      closeDialog: closeDialog,
      title: 'Please activate your account'
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Dialog"].Content,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Your email is not verified yet.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Please check ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'b',
          null,
          email
        ),
        ' and click the activation link to validate your account and sign in.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'additional-info' },
        'If you do not find the email in your inbox, please check your spam or junk folder.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Dialog"].Footer,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Button"],
        { highlight: true, onClick: closeDialog },
        'Ok'
      )
    )
  );
};

var SignInFooter = function (_React$Component2) {
  _inherits(SignInFooter, _React$Component2);

  function SignInFooter() {
    _classCallCheck(this, SignInFooter);

    return _possibleConstructorReturn(this, (SignInFooter.__proto__ || Object.getPrototypeOf(SignInFooter)).apply(this, arguments));
  }

  _createClass(SignInFooter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_11_little_loader___default()("https://fast.wistia.com/embed/medias/oa5uzcuxxp.jsonp");
      __WEBPACK_IMPORTED_MODULE_11_little_loader___default()("https://fast.wistia.com/assets/external/E-v1.js");
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'signup-question' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Don\'t have an account?'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],
            { className: 'button outline', to: '/signUp' },
            'Sign up'
          )
        )
      );
    }
  }]);

  return SignInFooter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var SignIn = function SignIn(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SignInLayout__["a" /* SignInLayout */], { contentProps: props, Content: SignInContent, Footer: SignInFooter });
};

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NewUserDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfileData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_navigation_prompt__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_navigation_prompt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_navigation_prompt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AvatarUploadForm__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ConfirmLeaveDialog__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_startlibs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styled_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_url_search_params__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_url_search_params___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_url_search_params__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class;

var _templateObject = _taggedTemplateLiteral(['\n  max-width: 38rem;\n  text-align: center;\n  p {\n    margin: auto 1rem;\n  }\n  img {\n    max-width: 10rem;\n    margin: 2rem auto 2rem;\n  }\n  h2 {\n    padding-right: 0;\n  }\n  ', ' {\n     justify-content: center;\n  }\n'], ['\n  max-width: 38rem;\n  text-align: center;\n  p {\n    margin: auto 1rem;\n  }\n  img {\n    max-width: 10rem;\n    margin: 2rem auto 2rem;\n  }\n  h2 {\n    padding-right: 0;\n  }\n  ', ' {\n     justify-content: center;\n  }\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
















var NewUserDialog = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Dialog"])(_templateObject, __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Dialog"].Footer);

var ProfileData = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__["fetchConnect"])(function (_ref) {
  var user = _ref.user;
  return {
    userEmail: user.email,
    firstSignIn: !user.hasProfile
  };
}, { setProfile: __WEBPACK_IMPORTED_MODULE_9__reducers__["m" /* setProfile */] }, 'formProperties'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["withForm"])(__WEBPACK_IMPORTED_MODULE_9__reducers__["m" /* setProfile */]), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_hocs__["withToggles"])('confirmLeaveDialog', 'redirectToDashboard', 'welcomeDialog'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["withRouter"])(_class = _dec(_class = _dec2(_class = _dec3(_class = function (_React$PureComponent) {
  _inherits(ProfileData, _React$PureComponent);

  function ProfileData() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ProfileData);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ProfileData.__proto__ || Object.getPrototypeOf(ProfileData)).call.apply(_ref2, [this].concat(args))), _this), _this.signOut = function () {
      localStorage.removeItem('hasLogged');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_startlibs__["getFetcher"])('/api/logout').then(function () {
        return window.location = '/';
      });
    }, _this.justActivated = new __WEBPACK_IMPORTED_MODULE_13_url_search_params___default.a(_this.props.location.search).get('from') === 'activation', _this.preValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_validation__["a" /* buildValidation */])({
      firstName: __WEBPACK_IMPORTED_MODULE_12__lib_validation__["b" /* required */],
      lastName: __WEBPACK_IMPORTED_MODULE_12__lib_validation__["b" /* required */],
      specializations: function specializations(val) {
        return val && val.filter(function (_) {
          return typeof _ === 'string' && _.trim();
        }).length && 'Specializations must have at least 3 characteres';
      }
    }, function (props) {
      return _extends({}, props, { specializations: props.specializations.filter(function (_) {
          return _.label;
        }) });
    }), _this.specializationValidation = function (label) {
      return { success: { label: label } };
    }, _this.fetchSpecializationSuggestions = function (s) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_startlibs__["getFetcher"])('/api/specializations?label=' + s);
    }, _this.getSpecializationLabel = function (_) {
      return _.label;
    }, _this.handleSubmit = function (e) {
      e.preventDefault();
      _this.props.form.connector.submitProperties().then(function (_ref3, test, test2) {
        var success = _ref3.success,
            errors = _ref3.errors;

        if (!errors) {
          _this.props.redirectToDashboard.open();
        }
      });
    }, _this.onFailure = function (_, errors) {
      console.log(errors);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProfileData, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.justActivated) {
        this.props.welcomeDialog.open();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          form = _props.form,
          userEmail = _props.userEmail,
          welcomeDialog = _props.welcomeDialog,
          firstSignIn = _props.firstSignIn,
          redirectToDashboard = _props.redirectToDashboard;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content edit-profile provider-profile' },
        !firstSignIn && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Button"].Link,
            { className: 'return-home-button', icon: 'arrow-left', to: '/' },
            'Home'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Your profile'
          ),
          !firstSignIn && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'profile-menu' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Link"],
              { className: 'button nav-tab active', to: '/profile' },
              'Profile'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Link"],
              { className: 'button nav-tab', skipTo: '/account-settings' },
              'Settings'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Link"],
              { className: 'button nav-tab workstations', to: '/workstations' },
              'Manage workstations'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["SplitColumnsContainer"],
          { viewportMinWidth: 610, margin: 'big' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'change-picture' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'field-label' },
                'Profile picture:'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_AvatarUploadForm__["a" /* AvatarUploadForm */], {
              form: form,
              path: 'picture',
              getResource: __WEBPACK_IMPORTED_MODULE_10__lib__["h" /* getResource */],
              uploadFetcher: function uploadFetcher(formData) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_startlibs__["postFetcher"])('/api/upload-profile-picture', formData);
              },
              defaultPicture: '/public/user-avatar.png'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["Errors"], { form: form, path: 'picture' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'profile-type' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'field-label' },
                'Role:'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'radio-list' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["SimpleRadiobox"], {
                form: form,
                path: 'physicianType',
                fieldValue: 'referring',
                label: 'Referring physician'
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["SimpleRadiobox"], {
                form: form,
                path: 'physicianType',
                fieldValue: 'radiologist',
                label: 'Radiologist'
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["SimpleRadiobox"], {
                form: form,
                path: 'physicianType',
                fieldValue: 'other',
                label: 'Other'
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["Form"],
          {
            form: form,
            url: '/api/profiles',
            onSubmit: this.handleSubmit,
            preValidation: this.preValidation,
            onFailure: this.onFailure
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["SplitColumnsContainer"],
            { viewportMinWidth: 610, margin: 'big' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
              form: form,
              path: 'firstName',
              placeholder: 'Ex: John',
              label: 'First name:'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
              form: form,
              path: 'lastName',
              placeholder: 'Ex: Doe',
              label: 'Last name:'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
            form: form,
            disabled: true,
            value: userEmail,
            label: 'E-mail:',
            locked: true
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["AutoComplete"], {
            form: form,
            autoSelect: true,
            getLabel: this.getSpecializationLabel,
            minQueryLength: 2,
            validation: this.specializationValidation,
            fetchSuggestions: this.fetchSpecializationSuggestions,
            path: 'specializations',
            label: 'Specialization:',
            helpText: '(Optional)',
            placeholder: 'Ex: Neurology'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["SplitColumnsContainer"],
            { viewportMinWidth: 610, margin: 'big' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
              form: form,
              path: 'phoneNumber',
              setValue: function setValue(newValue, _, _setValue) {
                return _setValue(newValue.replace(/[^0-9()\-+\s]/, ''));
              },
              placeholder: '(123) 456-7890',
              label: 'Phone number:'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
              form: form,
              path: 'phoneNumber2',
              setValue: function setValue(newValue, _, _setValue2) {
                return _setValue2(newValue.replace(/[^0-9()\-+\s]/, ''));
              },
              helpText: '(Optional)',
              placeholder: '(123) 456-7890',
              label: 'Phone number 2:'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
            form: form,
            path: 'address',
            placeholder: 'Ex: Sesame Street, 60 - Harlem',
            label: 'Address:'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["SplitColumnsContainer"],
            { viewportMinWidth: 610, margin: 'big' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
              form: form,
              path: 'zipCode',
              placeholder: 'Ex: 10026',
              label: 'Zip code:'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
              form: form,
              path: 'city',
              placeholder: 'Ex: New York',
              label: 'City:'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["SplitColumnsContainer"],
            { viewportMinWidth: 610, margin: 'big' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
              form: form,
              path: 'state',
              placeholder: 'Ex: New York',
              label: 'State:'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["TextInput"], {
              form: form,
              path: 'country',
              placeholder: 'Ex: USA',
              label: 'Country:'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'profile-errors-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_form__["Errors"], { form: form })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'profile-footer' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'footer-left-container' }),
            firstSignIn ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Button"],
              { onClick: this.signOut },
              'Sign out'
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Button"].Link,
              { to: '/' },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Button"],
              { type: 'submit', disabled: !form.hasChanged && !this.justActivated, isLoading: form.isLoading,
                highlight: true },
              firstSignIn ? 'Save profile' : 'Save'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router_navigation_prompt___default.a,
          { when: form.hasChanged,
            beforeCancel: function beforeCancel(cb) {
              return window.history.replaceState('', '', null) || cb();
            } },
          function (_ref4) {
            var onConfirm = _ref4.onConfirm,
                onCancel = _ref4.onCancel;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ConfirmLeaveDialog__["a" /* ConfirmLeaveDialog */], {
              save: function save() {
                return form.connector.submitProperties().then(function (_ref5) {
                  var success = _ref5.success,
                      errors = _ref5.errors;
                  return errors ? onCancel() : onConfirm();
                });
              },
              discard: onConfirm,
              isLoading: form.isLoading,
              closeDialog: onCancel
            });
          }
        ),
        redirectToDashboard.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: '/' }),
        welcomeDialog.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          NewUserDialog,
          {
            title: 'Account activated'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Dialog"].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Your Horos Cloud account has been successfully activated!'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: '/public/favicon.png' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Please complete your user profile.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Dialog"].Footer,
            { className: 'center' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Button"],
              { onClick: welcomeDialog.close, highlight: true },
              'Complete profile'
            )
          )
        )
      );
    }
  }]);

  return ProfileData;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class) || _class) || _class) || _class);

/***/ })

},[311]);


// WEBPACK FOOTER //
// static/js/main.8c711a9e.js